// Versão: 2.47
// Data..: 2026-10-15
// v2.47: CompaniesTab — bloco "⏱ Suporte (contrato de horas)" no modal da empresa
// (Horas contratadas/mês → contractedSupportHours; Valor hora adicional R$ →
// supportHourlyRate), incluídos em blank/startEdit/payloadFromForm (vazio = undefined).
// v2.46: Ponto Eletrônico — papel "Contabilidade" (roleLabels + opção no select de
// usuário) e aba "Ponto" (grupo Sistema) com a configuração de envio automático do
// relatório para a contabilidade (habilitar, e-mails de destino e dia do mês 1..28).
// v2.45: Contratos — "Valor total" sincroniza automaticamente com a soma dos itens de
// serviço (todo item add/alterado/removido reflete no total) e campo "Periodicidade"
// vira select em português (1 mês, 3 meses, 6 meses, 1 ano, 2 anos...), com conversão
// de valores legados em inglês ("1 month") para o rótulo pt-BR.
// v2.44: Contratos — editor "Cobrança temporária (mês único)" no modal de contrato
// (lista de oneTimeItems: descrição, qtd, valor unit., total e competência-alvo com
// default no mês corrente), espelhando o editor de serviços; envia oneTimeItems no save.
// v2.43: Orçamento — prazo de assinatura (signatureDeadlineDays) no formulário; situação
// "Expirado" (expired); painel "Status das assinaturas" exibe o vencimento (expiresAt) e,
// quando expirado, aviso + botão "Reemitir" (POST /quotes/:id/reissue-signature); botão
// "Reemitir" também na linha da tabela quando o orçamento está expirado.
// v2.42: aba "Faturamento Inter" (módulo Invoice) com ícone 💳 (distinto do 🧾 de Serviços)
// no grupo Sistema; toggle "Emissão de boleto pelo painel" (inter-emission-enabled) em
// Configurações. Wira o InvoicingPanel (boleto/PIX via Banco Inter).
// v2.41: Orçamento — painel "Status das assinaturas" agora exibe o IP ao lado da data/hora
// de visualização de cada signatário e, quando disponível, uma linha com o dispositivo
// (user agent resumido). Exibição restrita ao painel staff; nada exposto em telas públicas.
// v2.40: Contratos — modal de edição maior (maxWidth 920) e mais detalhado; form
// reorganizado em seções com cabeçalhos <h4> (Identificação, Serviços, Recorrência,
// Suporte, Comercial e vigência, Observações) para melhor UX; itens de serviço com
// cartão numerado e campos mais legíveis. Handlers/estados preservados.
// v2.39: Visibilidade de chamados por PERTENCIMENTO (opção A) — o atendente vê as filas
// dos departamentos do seu cadastro (Usuários → Departamentos); card vira informativo
// (sem seleção por-usuário, escala com muitos usuários). Chamado sem depto = Suporte.
// v2.38: Visibilidade de chamados — modelo por AGENTE (seleciona quais atendentes veem
// a fila de cada departamento; sem seleção = só admin). Chamado sem departamento = Suporte.
// v2.37: Configurações — card "Visibilidade de chamados por departamento" (define, por
// departamento, quais departamentos seus agentes podem ver; aplica ao salvar).
// v2.36: aba "Bot WhatsApp" — fluxo configurável de passos ordenáveis (subir/descer,
// ligar/desligar), com passos personalizados de "Mensagem" e "Pergunta" no meio do
// fluxo, além do menu de roteamento (departamento/fila/nível).
// v2.35: aba "Bot WhatsApp" — configura o menu de triagem (URA): liga/desliga, coleta de
// nome/e-mail, mensagens editáveis e opções com roteamento (departamento/fila/nível).
// v2.34: Orçamento — botão "Status" mostra quem visualizou/assinou/recusou (com motivo).
// v2.33: Configurações — remetente de orçamentos/contratos (contracts-from-address,
// default sistema@makweb.com.br) para prévia e assinatura.
// v2.32: Orçamento — botão "Prévia" abre resumo executivo (Makweb, cliente, itens, prazo,
// pagamento, condições) com envio da prévia por e-mail ao cliente para análise.
// v2.31: Orçamento — combobox de serviço com busca ao digitar e criação rápida em popup
// (auto-seleciona), botões Visualizar contrato e Reenviar e-mail; Serviços com botão de
// gerar código aleatório. PDF do contrato agrega logo, SLA e texto integral da minuta.
// v2.30: Empresas — botão "Excluir" (remove empresa, bloqueado se houver usuários
// vinculados) e paginação com atalhos "Início" e "Última".
// v2.29: na aba Orçamento, botão "Assinar" envia o contrato para assinatura eletrônica
// (gera PDF no servidor, arquiva no S3 e dispara e-mails aos signatários).
// v2.28: nova aba "Orçamento" — monta proposta/contrato (contratante, escopo, SLA,
// vigência, pagamento, Anexo I de valores com itens de serviço e signatários) e gera
// o contrato pronto em PDF (layout da minuta Makweb). Base para assinatura eletrônica.
// v2.27: nova aba "Serviços" (CRUD + importar da GestãoClick), separada do catálogo de
// chamados. Contratos totalmente editáveis e estruturados: itens de serviço (add/remover),
// recorrência/faturamento (valor, periodicidade, dia de vencimento, próxima emissão,
// forma/condição de pagamento, plano de contas, centro de custo), comercial e vigência.
// Base para migração da gestão de contratos da GestãoClick (boleto/NF no futuro).
// v2.26: ao editar um contrato importado, painel "Dados da GestãoClick (origem)" mostra
// TODOS os campos da origem — escalares (inclui próxima emissão/vencimento) e listas
// (serviços, produtos, pagamentos, histórico) como tabelas, exatamente como vieram.
// v2.25: Configurações com botão "Importar contratos" (GestãoClick); aba Contratos
// exibe código/situação de origem, valor e nome do cliente de origem (sem empresa).
// v2.22: grids de endereço da empresa e do modal de duplicar ativo usam .field-pair
// (colapsam em 1 coluna no mobile em vez de larguras fixas).
// Administração: usuários com senha definida pelo admin (no cadastro e via "Definir
// senha"), com opção de exigir troca no primeiro acesso. Nav por grupos, KPIs, CSAT.
// v2.16: duplicar ativo via modal editável; confirmações usam o diálogo da aplicação.
// v2.17: Usuários em tela cheia com modal de criação/edição ("Criar usuário");
// ordenação clicável nas tabelas principais (Usuários, Empresas, Contratos, Ativos, Auditoria).
// v2.18: todas as abas com formulário (Empresas, Departamentos, Filas, Contratos, Ativos,
// Categorias, Catálogo, Respostas prontas, Automações) usam botão + modal (sem coluna fixa).
// v2.19: admin pode redefinir o MFA do usuário (desvincula o app autenticador).
// v2.24: automações com mais condições (cliente, nível, depto, responsável, tag,
// é-tarefa), operadores (não contém, começa com, está/não está entre) e ações
// (encaminhar N1/N2/N3, definir fila/categoria, marcar tarefa) + exceções (stopOnMatch).
// v2.25: aba Contratos com busca instantânea e paginação (Início/Anterior/Próxima/Fim);
// backend passa a listar todos os contratos (remove limite de 500 que ocultava itens).
// v2.26: busca + paginação em todas as abas de listagem (Usuários, Serviços, Ativos,
// Catálogo, Respostas, Departamentos, Filas, Auditoria) via componente Pager;
// backend removeu limites que ocultavam itens; "Financeiro API" virou aba (Sistema).
// v2.20: Configurações com integração GestãoClick (tokens/URL, sync automático e
// botão "Sincronizar agora" para importar clientes como empresas).
// v2.21: Empresas com busca instantânea (nome/CNPJ/e-mail/cidade/domínio) e paginação.
// v2.23: telefonia 3CX — ramal 3CX no usuário, ramal interno na empresa, botões de
// ligar (click-to-call) e config 3CX (URL + vínculo ligação↔chamado).

import { useEffect, useState, type FormEvent, type Dispatch, type SetStateAction } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
  UserRole,
  SupportLevel,
  ContractType,
  AssetType,
  AssetStatus,
  ContractTypeLabels,
  AssetTypeLabels,
  AssetStatusLabels,
  type Company,
  type Department,
  type Queue,
  TicketEventLabels,
  TicketEventIcons,
  TicketPriority,
  AutomationTrigger,
  ConditionField,
  ConditionOperator,
  ActionType,
  AutomationTriggerLabels,
  ConditionFieldLabels,
  ConditionOperatorLabels,
  ActionTypeLabels,
  SupportLevelLabels,
  getUserSupportLevels,
  ChannelLabels,
  StatusLabels,
  PriorityLabels,
  type Category,
  type Contract,
  type ContractServiceItem,
  type OneTimeChargeItem,
  type CommercialService,
  type Quote,
  type QuoteSigner,
  type QuoteLineItem,
  type Asset,
  type TicketEvent,
  type CannedResponse,
  type BillingReport,
  type CsatReport,
  type ServiceCatalogItem,
  type AutomationRule,
  type AutomationCondition,
  type AutomationAction,
  type User,
  type Paginated,
  type WhatsAppBotConfig,
  type WhatsAppBotOption,
  type WhatsAppBotFlowStep,
  type WhatsAppBotStepType,
  type AccountingDeliveryConfig,
  type AccountingDeliveryConfigInput,
} from '@makweb/shared';
import { api } from '../lib/api.js';
import { useAuth } from '../context/AuthContext.js';
import { useToast } from '../context/ToastContext.js';
import { useDialog } from '../context/DialogContext.js';
import { PageHeader } from '../components/PageHeader.js';
import { CallButton } from '../components/CallButton.js';
import { Modal } from '../components/Modal.js';
import { useSortable, SortableTh } from '../components/SortableTable.js';
import { usePaged, Pager } from '../components/Pager.js';
import { FinanceApiPanel } from './FinancePage.js';
import { InvoicingPanel } from './InvoicesPage.js';
import { generateContractPdf } from '../lib/contractPdf.js';
import { config } from '../config.js';
import { getToken } from '../lib/auth.js';
import { ServiceCombobox } from '../components/ServiceCombobox.js';
import { buildCategoryOptions } from '../lib/categories.js';
import { toCsv, downloadCsv } from '../lib/csv.js';
import { lookupCep, lookupCnpj } from '../lib/brazilApi.js';

type Tab = 'companies' | 'users' | 'departments' | 'queues' | 'categories' | 'contracts' | 'services' | 'quotes' | 'assets' | 'billing' | 'financeApi' | 'invoicing' | 'catalog' | 'automation' | 'whatsappBot' | 'canned' | 'csat' | 'audit' | 'timeclock' | 'settings';
type TabGroup = 'Cadastros' | 'Operação' | 'Sistema';

const tabs: { id: Tab; label: string; icon: string; group: TabGroup; desc: string; adminOnly?: boolean }[] = [
  { id: 'companies', label: 'Empresas', icon: '🏢', group: 'Cadastros', desc: 'Empresas clientes e seus domínios de e-mail.' },
  { id: 'users', label: 'Usuários', icon: '👤', group: 'Cadastros', desc: 'Contas de acesso: administradores, atendentes e clientes.' },
  { id: 'contracts', label: 'Contratos', icon: '📄', group: 'Cadastros', desc: 'Contratos por empresa: serviços, valores, recorrência e faturamento.', adminOnly: true },
  { id: 'services', label: 'Serviços', icon: '🧾', group: 'Cadastros', desc: 'Catálogo de serviços comerciais (base para contratos, boleto e nota fiscal).', adminOnly: true },
  { id: 'quotes', label: 'Orçamento', icon: '📝', group: 'Cadastros', desc: 'Monte propostas/contratos, gere o PDF e envie para assinatura eletrônica.', adminOnly: true },
  { id: 'assets', label: 'Ativos (CMDB)', icon: '🖥', group: 'Cadastros', desc: 'Inventário de equipamentos por empresa.' },
  { id: 'departments', label: 'Departamentos', icon: '🗂', group: 'Cadastros', desc: 'Áreas responsáveis pelo atendimento.' },
  { id: 'queues', label: 'Filas', icon: '📋', group: 'Cadastros', desc: 'Filas de atendimento por departamento e nível.' },
  { id: 'categories', label: 'Categorias', icon: '🏷', group: 'Operação', desc: 'Árvore de categorias dos chamados.', adminOnly: true },
  { id: 'catalog', label: 'Catálogo', icon: '🧰', group: 'Operação', desc: 'Serviços solicitáveis que pré-configuram chamados.', adminOnly: true },
  { id: 'automation', label: 'Automações', icon: '🤖', group: 'Operação', desc: 'Regras QUANDO → SE → FAÇA aplicadas aos chamados.', adminOnly: true },
  { id: 'whatsappBot', label: 'Bot WhatsApp', icon: '💬', group: 'Operação', desc: 'Menu de triagem (URA) do WhatsApp: boas-vindas, coleta de contato e roteamento.', adminOnly: true },
  { id: 'canned', label: 'Respostas prontas', icon: '💬', group: 'Operação', desc: 'Modelos de resposta reutilizáveis pela equipe.' },
  { id: 'billing', label: 'Faturamento', icon: '💰', group: 'Sistema', desc: 'Consumo de horas por empresa e período.', adminOnly: true },
  { id: 'financeApi', label: 'Financeiro API', icon: '📈', group: 'Sistema', desc: 'Relatórios financeiros da GestãoClick e automação de cobrança.', adminOnly: true },
  { id: 'invoicing', label: 'Faturamento Inter', icon: '💳', group: 'Sistema', desc: 'Cobranças mensais e avulsas: boleto/PIX via Banco Inter, envio por e-mail e baixa.', adminOnly: true },
  { id: 'csat', label: 'Satisfação', icon: '⭐', group: 'Sistema', desc: 'Relatório de satisfação (CSAT) dos atendimentos.' },
  { id: 'audit', label: 'Auditoria', icon: '📜', group: 'Sistema', desc: 'Trilha de eventos de todos os chamados.', adminOnly: true },
  { id: 'timeclock', label: 'Ponto', icon: '🕒', group: 'Sistema', desc: 'Envio automático do relatório de ponto para a contabilidade.', adminOnly: true },
  { id: 'settings', label: 'Configurações', icon: '⚙', group: 'Sistema', desc: 'Canais, SLA, horário comercial e regras de operação.', adminOnly: true },
];

const TAB_GROUPS: TabGroup[] = ['Cadastros', 'Operação', 'Sistema'];

export function AdminPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === UserRole.ADMIN;
  const [searchParams] = useSearchParams();
  // Aba inicial a partir da URL (?tab=invoicing) — permite deep-link do sininho/menus para
  // uma aba específica. Só aceita um id de aba conhecido; senão cai em 'companies'.
  const requestedTab = searchParams.get('tab');
  const initialTab: Tab = tabs.some((t) => t.id === requestedTab) ? (requestedTab as Tab) : 'companies';
  const [tab, setTab] = useState<Tab>(initialTab);
  const visibleTabs = tabs.filter((t) => !t.adminOnly || isAdmin);
  const activeMeta = tabs.find((t) => t.id === tab);
  return (
    <div className="full-bleed">
      <PageHeader eyebrow="Gestão" title="Administração" description="Cadastros, operação e configurações do portal." />
      <div className="admin-layout">
        {/* Navegação lateral por grupos (vira topo em telas estreitas). */}
        <aside className="admin-nav">
          {TAB_GROUPS.map((g) => {
            const items = visibleTabs.filter((t) => t.group === g);
            if (!items.length) return null;
            return (
              <div key={g} className="admin-nav-group">
                <div className="admin-nav-label">{g}</div>
                {items.map((t) => (
                  <button
                    key={t.id}
                    className={`admin-nav-item ${tab === t.id ? 'active' : ''}`}
                    onClick={() => setTab(t.id)}
                  >
                    <span className="admin-nav-icon">{t.icon}</span> {t.label}
                  </button>
                ))}
              </div>
            );
          })}
        </aside>

        <section className="admin-content fade-in" key={tab}>
          {activeMeta && (
            <div className="admin-section-head">
              <span className="sec-icon">{activeMeta.icon}</span>
              <div>
                <h2>{activeMeta.label}</h2>
                <p className="sec-desc">{activeMeta.desc}</p>
              </div>
            </div>
          )}
          {tab === 'companies' && <CompaniesTab />}
      {tab === 'users' && <UsersTab />}
      {tab === 'departments' && <DepartmentsTab />}
      {tab === 'contracts' && isAdmin && <ContractsTab />}
      {tab === 'services' && isAdmin && <ServicesTab />}
      {tab === 'quotes' && isAdmin && <QuotesTab />}
      {tab === 'assets' && <AssetsTab />}
      {tab === 'billing' && isAdmin && <BillingTab />}
      {tab === 'financeApi' && isAdmin && <FinanceApiPanel />}
      {tab === 'invoicing' && isAdmin && <InvoicingPanel />}
      {tab === 'queues' && <QueuesTab />}
      {tab === 'categories' && isAdmin && <CategoriesTab />}
      {tab === 'catalog' && isAdmin && <CatalogTab />}
      {tab === 'automation' && isAdmin && <AutomationTab />}
      {tab === 'whatsappBot' && isAdmin && <WhatsAppBotTab />}
          {tab === 'canned' && <CannedTab />}
          {tab === 'csat' && <CsatTab />}
          {tab === 'audit' && isAdmin && <AuditTab />}
          {tab === 'timeclock' && isAdmin && <TimeclockDeliveryTab />}
          {tab === 'settings' && isAdmin && <SettingsTab />}
        </section>
      </div>
    </div>
  );
}

// Resumo consolidado de uma empresa (espelha orgService.CompanyOverview do backend).
interface CompanyUserSummary { id: string; name: string; email: string; role: string; ticketCount: number; }
interface CompanyOverview { companyId: string; totalTickets: number; users: CompanyUserSummary[]; externalTickets: number; }

function CompaniesTab() {
  const toast = useToast();
  const { confirm } = useDialog();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [selected, setSelected] = useState<Company | null>(null);
  const [overview, setOverview] = useState<CompanyOverview | null>(null);
  const [loadingOv, setLoadingOv] = useState(false);
  const [editing, setEditing] = useState<Company | null>(null); // empresa em edição (null = nova)
  const [filter, setFilter] = useState(''); // busca instantânea por texto
  const [page, setPage] = useState(1); // página atual da lista
  const pageSize = 20; // empresas por página

  const blank = { name: '', document: '', email: '', phone: '', internalExtension: '', domains: '', cep: '', street: '', number: '', complement: '', neighborhood: '', city: '', state: '', contractedSupportHours: '', supportHourlyRate: '' };
  const [form, setForm] = useState({ ...blank });
  const [open, setOpen] = useState(false);
  const [lookingCep, setLookingCep] = useState(false);
  const [lookingCnpj, setLookingCnpj] = useState(false);

  const load = () => api.get<Paginated<Company>>('/companies').then((r) => setCompanies(r.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  const startNew = () => { setEditing(null); setForm({ ...blank }); setOpen(true); };
  const closeModal = () => { setOpen(false); setEditing(null); setForm({ ...blank }); };
  const startEdit = (c: Company) => {
    setEditing(c);
    setForm({
      name: c.name, document: c.document ?? '', email: c.email ?? '', phone: c.phone ?? '',
      internalExtension: c.internalExtension ?? '',
      domains: (c.emailDomains ?? []).join(', '),
      cep: c.cep ?? '', street: c.street ?? '', number: c.number ?? '', complement: c.complement ?? '',
      neighborhood: c.neighborhood ?? '', city: c.city ?? '', state: c.state ?? '',
      contractedSupportHours: c.contractedSupportHours?.toString() ?? '',
      supportHourlyRate: c.supportHourlyRate?.toString() ?? '',
    });
    setOpen(true);
  };

  // Remove uma empresa (admin). O backend bloqueia se houver usuários vinculados.
  const remove = async (c: Company) => {
    if (!(await confirm({
      title: 'Remover empresa',
      message: `Remover "${c.name}"? Esta ação não pode ser desfeita.`,
      confirmLabel: 'Remover',
      danger: true,
    }))) return;
    try {
      await api.delete(`/companies/${c.id}`);
      toast.success('Empresa removida');
      if (selected?.id === c.id) { setSelected(null); setOverview(null); }
      load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao remover empresa');
    }
  };

  const payloadFromForm = () => ({
    name: form.name.trim(),
    document: form.document || undefined,
    email: form.email || undefined,
    phone: form.phone || undefined,
    internalExtension: form.internalExtension.trim() || undefined,
    cep: form.cep || undefined,
    street: form.street || undefined,
    number: form.number || undefined,
    complement: form.complement || undefined,
    neighborhood: form.neighborhood || undefined,
    city: form.city || undefined,
    state: form.state || undefined,
    emailDomains: form.domains
      .split(/[,;\n]/)
      .map((d) => d.trim().toLowerCase().replace(/^@/, ''))
      .filter(Boolean),
    // Horas de suporte: vazio → undefined (não envia); backend valida >= 0.
    contractedSupportHours: form.contractedSupportHours ? Number(form.contractedSupportHours) : undefined,
    supportHourlyRate: form.supportHourlyRate ? Number(form.supportHourlyRate) : undefined,
  });

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.patch(`/companies/${editing.id}`, payloadFromForm());
        toast.success('Empresa atualizada');
      } else {
        await api.post('/companies', payloadFromForm());
        toast.success('Empresa cadastrada');
      }
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar empresa');
    }
  };

  // Autofill de endereço pelo CEP (ViaCEP).
  const onCepBlur = async () => {
    if (!form.cep.replace(/\D/g, '')) return;
    setLookingCep(true);
    try {
      const r = await lookupCep(form.cep);
      if (r) setForm((f) => ({ ...f, street: r.street ?? f.street, neighborhood: r.neighborhood ?? f.neighborhood, city: r.city ?? f.city, state: r.state ?? f.state }));
      else toast.error('CEP não encontrado');
    } catch { toast.error('Falha ao consultar o CEP'); }
    finally { setLookingCep(false); }
  };

  // Autofill de dados pelo CNPJ (BrasilAPI).
  const onCnpjBlur = async () => {
    if (form.document.replace(/\D/g, '').length !== 14) return; // só CNPJ (14 dígitos)
    setLookingCnpj(true);
    try {
      const r = await lookupCnpj(form.document);
      if (r) {
        setForm((f) => ({
          ...f,
          name: f.name || r.name || '',
          email: f.email || r.email || '',
          phone: f.phone || r.phone || '',
          cep: r.cep ?? f.cep, street: r.street ?? f.street, number: r.number ?? f.number,
          complement: r.complement ?? f.complement, neighborhood: r.neighborhood ?? f.neighborhood,
          city: r.city ?? f.city, state: r.state ?? f.state,
        }));
        toast.success('Dados preenchidos pelo CNPJ');
      } else toast.error('CNPJ não encontrado');
    } catch { toast.error('Falha ao consultar o CNPJ'); }
    finally { setLookingCnpj(false); }
  };

  const openCompany = (c: Company) => {
    setSelected(c); setOverview(null); setLoadingOv(true);
    api.get<CompanyOverview>(`/companies/${c.id}/overview`)
      .then(setOverview)
      .catch(() => toast.error('Falha ao carregar dados da empresa'))
      .finally(() => setLoadingOv(false));
  };

  // Filtra pelo termo digitado (nome, documento, e-mail, domínios e cidade).
  const term = filter.trim().toLowerCase();
  const filtered = term
    ? companies.filter((c) =>
        c.name.toLowerCase().includes(term) ||
        (c.document ?? '').toLowerCase().includes(term) ||
        (c.email ?? '').toLowerCase().includes(term) ||
        (c.city ?? '').toLowerCase().includes(term) ||
        (c.emailDomains ?? []).some((d) => d.toLowerCase().includes(term)),
      )
    : companies;

  const { sorted: sortedCompanies, sort } = useSortable<Company>(filtered, {
    name: (c) => c.name,
    domains: (c) => c.emailDomains?.join(', ') ?? '',
  });

  // Paginação client-side sobre a lista filtrada/ordenada.
  const totalPages = Math.max(1, Math.ceil(sortedCompanies.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pageStart = (currentPage - 1) * pageSize;
  const pageCompanies = sortedCompanies.slice(pageStart, pageStart + pageSize);

  // Ao mudar o filtro, volta para a primeira página.
  const onFilterChange = (v: string) => { setFilter(v); setPage(1); };

  return (
    <div>
      <div className="flex flex-col gap-4">
          <div className="flex gap-2 items-end justify-between flex-wrap">
            <div className="field mb-0" style={{ flex: 1, maxWidth: 320 }}>
              <label className="label">Buscar empresa</label>
              <input className="input" value={filter} onChange={(e) => onFilterChange(e.target.value)} placeholder="nome, CNPJ/CPF, e-mail, cidade ou domínio" />
            </div>
            <button className="btn btn-primary" onClick={startNew}>+ Nova empresa</button>
          </div>
          <div className="card card-flush">
            {companies.length === 0 ? <div className="empty"><div className="empty-icon">🏢</div>Nenhuma empresa.</div> :
             sortedCompanies.length === 0 ? <div className="empty"><div className="empty-icon">🔍</div>Nenhuma empresa encontrada para "{filter}".</div> :
              <table className="table"><thead><tr>
                <SortableTh<Company> field="name" sort={sort}>Empresa</SortableTh>
                <SortableTh<Company> field="domains" sort={sort}>Domínios de e-mail</SortableTh>
                <th></th>
              </tr></thead><tbody>
                {pageCompanies.map((c) => (
                  <tr key={c.id} style={{ background: selected?.id === c.id ? 'var(--brand-soft)' : undefined }}>
                    <td className="font-semibold" style={{ cursor: 'pointer' }} onClick={() => openCompany(c)}>{c.name}</td>
                    <td className="text-muted text-sm">{c.emailDomains?.join(', ') || '—'}</td>
                    <td className="text-right" style={{ whiteSpace: 'nowrap' }}>
                      <button className="btn btn-sm btn-ghost" onClick={() => openCompany(c)}>Ver</button>
                      <button className="btn btn-sm btn-ghost" onClick={() => startEdit(c)}>Editar</button>
                      <button className="btn btn-sm btn-ghost" onClick={() => remove(c)}>Excluir</button>
                    </td>
                  </tr>
                ))}
              </tbody></table>}
          </div>

          {/* Paginação: só aparece quando há mais de uma página. */}
          {sortedCompanies.length > pageSize && (
            <div className="flex items-center justify-between flex-wrap gap-2">
              <span className="text-dim text-sm">
                {pageStart + 1}–{Math.min(pageStart + pageSize, sortedCompanies.length)} de {sortedCompanies.length} empresas
              </span>
              <div className="flex items-center gap-2">
                <button className="btn btn-sm btn-ghost" disabled={currentPage <= 1} onClick={() => setPage(1)} title="Primeira página">« Início</button>
                <button className="btn btn-sm btn-ghost" disabled={currentPage <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>‹ Anterior</button>
                <span className="text-sm">Página {currentPage} de {totalPages}</span>
                <button className="btn btn-sm btn-ghost" disabled={currentPage >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>Próxima ›</button>
                <button className="btn btn-sm btn-ghost" disabled={currentPage >= totalPages} onClick={() => setPage(totalPages)} title="Última página">Última »</button>
              </div>
            </div>
          )}

          {selected && (
            <div className="card">
              <div className="flex items-center justify-between mb-2">
                <h3 style={{ margin: 0 }}>🏢 {selected.name}</h3>
                <div className="flex items-center gap-2">
                  {/* Ligar para o telefone / ramal interno da empresa (click-to-call). */}
                  {selected.phone && <CallButton number={selected.phone} contactName={selected.name} label="Telefone" />}
                  {selected.internalExtension && <CallButton number={selected.internalExtension} contactName={selected.name} label={`Ramal ${selected.internalExtension}`} />}
                  <button className="btn btn-sm btn-ghost" onClick={() => { setSelected(null); setOverview(null); }}>Fechar</button>
                </div>
              </div>
              {loadingOv ? (
                <div className="flex justify-center" style={{ padding: 24 }}><span className="spinner" /></div>
              ) : overview ? (
                <>
                  <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 'var(--s3)', marginBottom: 'var(--s3)' }}>
                    <div className="stat-card"><span className="stat-icon">🎫</span><div className="stat-label">Total de chamados</div><div className="stat-value">{overview.totalTickets}</div></div>
                    <div className="stat-card"><span className="stat-icon">👥</span><div className="stat-label">Usuários</div><div className="stat-value">{overview.users.length}</div></div>
                    <div className="stat-card"><span className="stat-icon">📥</span><div className="stat-label">Externos (e-mail/WhatsApp)</div><div className="stat-value">{overview.externalTickets}</div></div>
                  </div>
                  {overview.users.length === 0 ? (
                    <div className="empty"><div className="empty-icon">👤</div>Nenhum usuário vinculado a esta empresa.</div>
                  ) : (
                    <table className="table">
                      <thead><tr><th>Usuário</th><th>E-mail</th><th>Perfil</th><th className="text-right">Chamados</th></tr></thead>
                      <tbody>
                        {overview.users.map((u) => (
                          <tr key={u.id}>
                            <td className="font-semibold">{u.name}</td>
                            <td className="text-muted text-sm">{u.email}</td>
                            <td className="text-sm">{roleLabels[u.role] ?? u.role}</td>
                            <td className="text-right font-semibold">{u.ticketCount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </>
              ) : null}
            </div>
          )}
      </div>

      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? 'Editar empresa' : 'Nova empresa'}
        maxWidth={620}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="company-form">{editing ? 'Salvar alterações' : 'Adicionar empresa'}</button>
          </>
        }
      >
        <form id="company-form" onSubmit={save}>
          <div className="field">
            <label className="label">CNPJ/CPF {lookingCnpj && <span className="spinner" style={{ width: 12, height: 12, marginLeft: 6 }} />}</label>
            <input className="input" value={form.document} onChange={(e) => setForm({ ...form, document: e.target.value })} onBlur={onCnpjBlur} placeholder="00.000.000/0000-00 (preenche pelo CNPJ)" />
          </div>
          <div className="field"><label className="label">Nome</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="form-grid">
            <div className="field"><label className="label">E-mail</label><input className="input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
            <div className="field"><label className="label">Telefone</label><input className="input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
          </div>
          <div className="field mt-3 mb-0"><label className="label">Ramal interno (3CX)</label>
            <input className="input" value={form.internalExtension} onChange={(e) => setForm({ ...form, internalExtension: e.target.value })} placeholder="ex.: 205 (se o cliente usa nosso PBX)" inputMode="numeric" />
          </div>
          <div className="field-pair mt-3">
            <div className="field mb-0">
              <label className="label">CEP {lookingCep && <span className="spinner" style={{ width: 12, height: 12, marginLeft: 6 }} />}</label>
              <input className="input" value={form.cep} onChange={(e) => setForm({ ...form, cep: e.target.value })} onBlur={onCepBlur} placeholder="00000-000" />
            </div>
            <div className="field mb-0"><label className="label">Rua</label><input className="input" value={form.street} onChange={(e) => setForm({ ...form, street: e.target.value })} /></div>
          </div>
          <div className="field-pair mt-3">
            <div className="field mb-0"><label className="label">Número</label><input className="input" value={form.number} onChange={(e) => setForm({ ...form, number: e.target.value })} /></div>
            <div className="field mb-0"><label className="label">Complemento</label><input className="input" value={form.complement} onChange={(e) => setForm({ ...form, complement: e.target.value })} /></div>
          </div>
          <div className="field-pair mt-3">
            <div className="field mb-0"><label className="label">Bairro</label><input className="input" value={form.neighborhood} onChange={(e) => setForm({ ...form, neighborhood: e.target.value })} /></div>
            <div className="field mb-0"><label className="label">Cidade</label><input className="input" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} /></div>
            <div className="field mb-0"><label className="label">UF</label><input className="input" value={form.state} maxLength={2} onChange={(e) => setForm({ ...form, state: e.target.value.toUpperCase() })} /></div>
          </div>
          <div className="field mt-3 mb-0">
            <label className="label">Domínios de e-mail</label>
            <input className="input" value={form.domains} onChange={(e) => setForm({ ...form, domains: e.target.value })} placeholder="cliente.com.br, filial.com.br, grupo.com" />
            <p className="text-dim text-xs mt-1">Vários domínios separados por vírgula. E-mails vindos destes domínios são associados automaticamente a esta empresa.</p>
          </div>
          {/* Contrato de horas de suporte: fonte principal do relatório de horas
              (Painel Gerencial). Vazio = sem contrato de horas na empresa. */}
          <div className="mt-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">⏱ Suporte (contrato de horas)</h4>
            <div className="field-pair">
              <div className="field mb-0">
                <label className="label">Horas de suporte contratadas (por mês)</label>
                <input className="input" type="number" min="0" step="0.5" value={form.contractedSupportHours} onChange={(e) => setForm({ ...form, contractedSupportHours: e.target.value })} placeholder="ex.: 10" />
              </div>
              <div className="field mb-0">
                <label className="label">Valor da hora adicional (R$)</label>
                <input className="input" type="number" min="0" step="0.01" value={form.supportHourlyRate} onChange={(e) => setForm({ ...form, supportHourlyRate: e.target.value })} placeholder="ex.: 150.00" />
              </div>
            </div>
            <p className="text-dim text-xs mt-1">As horas excedentes ao contratado no mês são cobradas pelo valor da hora adicional. Deixe vazio se a empresa não tiver contrato de horas.</p>
          </div>
        </form>
      </Modal>
    </div>
  );
}

const roleLabels: Record<string, string> = { admin: 'Administrador', agent: 'Atendente', client: 'Cliente', accounting: 'Contabilidade' };

// Aba "Ponto" (Sistema): configura o envio automático do relatório de ponto para a
// contabilidade (habilitar, lista de e-mails de destino e dia do mês 1..28). Só admin.
function TimeclockDeliveryTab() {
  const toast = useToast();
  const [enabled, setEnabled] = useState(false);
  const [recipientsText, setRecipientsText] = useState('');
  const [dayOfMonth, setDayOfMonth] = useState(1);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get<{ config: AccountingDeliveryConfig | null }>('/timeclock/accounting-config')
      .then((r) => {
        if (r.config) {
          setEnabled(r.config.enabled);
          setRecipientsText((r.config.recipients ?? []).join(', '));
          setDayOfMonth(r.config.dayOfMonth ?? 1);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async (e: FormEvent) => {
    e.preventDefault();
    // Divide por vírgula/ponto-e-vírgula/quebra de linha e remove vazios.
    const recipients = recipientsText.split(/[,;\n]/).map((s) => s.trim()).filter(Boolean);
    if (enabled && recipients.length === 0) {
      toast.error('Informe ao menos um e-mail de destino para habilitar o envio.');
      return;
    }
    const day = Math.min(28, Math.max(1, Math.round(dayOfMonth)));
    setSaving(true);
    try {
      const body: AccountingDeliveryConfigInput = { enabled, recipients, dayOfMonth: day };
      const r = await api.put<{ config: AccountingDeliveryConfig }>('/timeclock/accounting-config', body);
      setEnabled(r.config.enabled);
      setRecipientsText((r.config.recipients ?? []).join(', '));
      setDayOfMonth(r.config.dayOfMonth ?? day);
      toast.success('Configuração de envio salva');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar a configuração');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center" style={{ padding: 24 }}><span className="spinner" /></div>;
  }

  return (
    <form onSubmit={save} className="card">
      <h3>🕒 Envio do relatório para a contabilidade</h3>
      <p className="text-muted text-sm">
        Envie automaticamente, por e-mail, o relatório de ponto (PDF) do mês anterior para a
        contabilidade no dia escolhido de cada mês.
      </p>

      <label className="flex items-center gap-2 mt-2" style={{ cursor: 'pointer' }}>
        <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
        <span>Habilitar envio automático</span>
      </label>

      <div className="field mt-3">
        <label className="label">E-mails de destino</label>
        <textarea
          className="input"
          rows={3}
          value={recipientsText}
          onChange={(e) => setRecipientsText(e.target.value)}
          placeholder="contabilidade@empresa.com, financeiro@empresa.com"
        />
        <div className="text-dim text-xs mt-1">Separe por vírgula, ponto-e-vírgula ou quebra de linha.</div>
      </div>

      <div className="field" style={{ maxWidth: 220 }}>
        <label className="label">Dia do mês para o envio</label>
        <input
          className="input"
          type="number"
          min={1}
          max={28}
          value={dayOfMonth}
          onChange={(e) => setDayOfMonth(Number(e.target.value))}
        />
        <div className="text-dim text-xs mt-1">Entre 1 e 28 (refere-se ao mês anterior).</div>
      </div>

      <button className="btn btn-primary mt-2" type="submit" disabled={saving}>{saving ? 'Salvando...' : 'Salvar configuração'}</button>
    </form>
  );
}

function UsersTab() {
  const toast = useToast();
  const { confirm } = useDialog();
  const { user: me } = useAuth();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [departments, setDepartments] = useState<Department[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [editing, setEditing] = useState<User | null>(null);
  const [filter, setFilter] = useState('');
  type UserForm = {
    name: string; email: string; role: UserRole; companyId: string;
    supportLevels: SupportLevel[]; departmentIds: string[];
    phone: string; extension: string; password: string; requireChange: boolean;
  };
  const blank: UserForm = { name: '', email: '', role: UserRole.CLIENT as UserRole, companyId: '', supportLevels: [], departmentIds: [], phone: '', extension: '', password: '', requireChange: true };
  const [form, setForm] = useState<UserForm>({ ...blank });

  // Alterna um valor em um array do formulário (níveis ou departamentos).
  const toggleInArray = <T,>(list: T[], value: T): T[] =>
    list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
  // Usuário-alvo do painel "Definir senha" (aberto pela lista).
  const [pwUser, setPwUser] = useState<User | null>(null);
  const [pwValue, setPwValue] = useState('');
  const [pwRequireChange, setPwRequireChange] = useState(true);

  const load = () => api.get<Paginated<User>>('/users').then((r) => setUsers(r.items)).catch(() => {});
  useEffect(() => {
    api.get<Paginated<Company>>('/companies').then((r) => setCompanies(r.items)).catch(() => {});
    api.get<Paginated<Department>>('/departments').then((r) => setDepartments(r.items)).catch(() => {});
    load();
  }, []);
  const deptName = (id: string) => departments.find((d) => d.id === id)?.name ?? id;

  const companyName = (id?: string) => (id ? companies.find((c) => c.id === id)?.name ?? id : '—');

  // Controle dos modais (criação/edição e definição de senha).
  const [formOpen, setFormOpen] = useState(false);

  const startNew = () => { setEditing(null); setForm({ ...blank }); setFormOpen(true); };
  const startEdit = (u: User) => {
    setEditing(u);
    setForm({
      name: u.name, email: u.email, role: u.role, companyId: u.companyId ?? '',
      supportLevels: getUserSupportLevels(u), departmentIds: u.departmentIds ?? [],
      phone: u.phone ?? '', extension: u.extension ?? '', password: '', requireChange: true,
    });
    setFormOpen(true);
  };
  const closeForm = () => { setFormOpen(false); setEditing(null); setForm({ ...blank }); };
  const startSetPassword = (u: User) => { setPwUser(u); setPwValue(''); setPwRequireChange(true); };

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      if (editing) {
        const isStaffRole = form.role === UserRole.AGENT || form.role === UserRole.ADMIN;
        await api.patch(`/users/${editing.id}`, {
          name: form.name,
          role: form.role,
          companyId: form.role === UserRole.CLIENT ? form.companyId || undefined : undefined,
          phone: form.phone.trim() || undefined,
          supportLevels: isStaffRole ? form.supportLevels : [],
          departmentIds: isStaffRole ? form.departmentIds : [],
          extension: form.extension.trim() || undefined,
        });
        toast.success('Usuário atualizado');
      } else {
        const hasPassword = !!form.password.trim();
        if (hasPassword && form.password.trim().length < 10) {
          toast.error('A senha deve ter ao menos 10 caracteres.');
          return;
        }
        const isStaffRole = form.role === UserRole.AGENT || form.role === UserRole.ADMIN;
        await api.post('/users', {
          name: form.name, email: form.email, role: form.role,
          companyId: form.role === UserRole.CLIENT ? form.companyId : undefined,
          phone: form.phone.trim() || undefined,
          supportLevels: isStaffRole && form.supportLevels.length ? form.supportLevels : undefined,
          departmentIds: isStaffRole && form.departmentIds.length ? form.departmentIds : undefined,
          extension: form.extension.trim() || undefined,
          password: hasPassword ? form.password.trim() : undefined,
          requireChange: hasPassword ? form.requireChange : undefined,
        });
        toast.success(
          hasPassword
            ? (form.requireChange ? 'Usuário criado. Ele trocará a senha no primeiro acesso.' : 'Usuário criado com a senha definida.')
            : 'Usuário criado. Senha temporária enviada por e-mail.',
        );
      }
      closeForm(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  // Define a senha do usuário selecionado (painel "Definir senha").
  const submitSetPassword = async (e: FormEvent) => {
    e.preventDefault();
    if (!pwUser) return;
    if (pwValue.trim().length < 10) { toast.error('A senha deve ter ao menos 10 caracteres.'); return; }
    try {
      await api.post(`/users/${pwUser.id}/password`, { password: pwValue.trim(), requireChange: pwRequireChange });
      toast.success(pwRequireChange ? 'Senha definida. O usuário trocará no próximo acesso.' : 'Senha definida.');
      setPwUser(null); setPwValue('');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao definir senha');
    }
  };

  const toggleActive = async (u: User) => {
    try { await api.patch(`/users/${u.id}`, { active: !u.active }); load(); }
    catch (err) { toast.error(err instanceof Error ? err.message : 'Falha'); }
  };
  const remove = async (u: User) => {
    const ok = await confirm({
      title: 'Remover usuário',
      message: `Remover o usuário "${u.name}"? Esta ação não pode ser desfeita.`,
      confirmLabel: 'Remover', danger: true,
    });
    if (!ok) return;
    try { await api.delete(`/users/${u.id}`); toast.success('Usuário removido'); if (editing?.id === u.id) closeForm(); load(); }
    catch (err) { toast.error(err instanceof Error ? err.message : 'Falha ao remover'); }
  };
  const resetPassword = async (u: User) => {
    try { await api.post(`/users/${u.id}/reset-password`); toast.success('Senha redefinida — o usuário receberá um código por e-mail.'); }
    catch (err) { toast.error(err instanceof Error ? err.message : 'Falha ao redefinir'); }
  };
  const resetMfa = async (u: User) => {
    const ok = await confirm({
      title: 'Redefinir MFA',
      message: `Desvincular o app autenticador de "${u.name}"? No próximo login o usuário terá que configurar um novo autenticador.`,
      confirmLabel: 'Redefinir MFA', danger: true,
    });
    if (!ok) return;
    try { await api.post(`/users/${u.id}/reset-mfa`); toast.success('MFA redefinido — o usuário configurará um novo autenticador no próximo login.'); }
    catch (err) { toast.error(err instanceof Error ? err.message : 'Falha ao redefinir MFA'); }
  };

  const term = filter.trim().toLowerCase();
  const visible = term
    ? users.filter((u) => u.name.toLowerCase().includes(term) || u.email.toLowerCase().includes(term))
    : users;

  // Ordenação clicável. Empresa e papel usam acessores para ordenar pelo texto exibido.
  const { sorted, sort } = useSortable<User>(visible, {
    company: (u) => (u.role === 'client' ? companyName(u.companyId) : (u.departmentIds ?? []).map(deptName).join(', ')),
    role: (u) => roleLabels[u.role] ?? u.role,
    active: (u) => (u.active ? 1 : 0),
  });
  const paged = usePaged(sorted, 20);

  return (
    <div>
      <div className="flex gap-2 items-end justify-between flex-wrap" style={{ marginBottom: 'var(--s3)' }}>
        <div className="field mb-0" style={{ flex: 1, maxWidth: 320 }}>
          <label className="label">Buscar usuário</label>
          <input className="input" value={filter} onChange={(e) => { setFilter(e.target.value); paged.setPage(1); }} placeholder="nome ou e-mail" />
        </div>
        <button className="btn btn-primary" onClick={startNew}>+ Criar usuário</button>
      </div>

      <div className="card card-flush">
        {sorted.length === 0 ? <div className="empty"><div className="empty-icon">👤</div>Nenhum usuário.</div> :
          <table className="table">
            <thead><tr>
              <SortableTh<User> field="name" sort={sort}>Nome</SortableTh>
              <SortableTh<User> field="email" sort={sort}>E-mail</SortableTh>
              <SortableTh<User> field="role" sort={sort}>Papel</SortableTh>
              <SortableTh<User> field="company" sort={sort}>Empresa / Depto.</SortableTh>
              <SortableTh<User> field="active" sort={sort}>Status</SortableTh>
              <th></th>
            </tr></thead>
            <tbody>
              {paged.pageItems.map((u) => (
                <tr key={u.id}>
                  <td className="font-semibold">{u.name}{u.id === me?.id && <span className="text-dim text-xs"> (você)</span>}</td>
                  <td className="text-muted text-sm">{u.email}</td>
                  <td>
                    <span className={`badge ${u.role === 'admin' ? 'badge-urgent' : u.role === 'agent' ? 'badge-in_progress' : 'badge-normal'}`}>
                      {roleLabels[u.role] ?? u.role}
                      {getUserSupportLevels(u).length ? ` · ${getUserSupportLevels(u).map((lv) => SupportLevelLabels[lv]).join('/')}` : ''}
                    </span>
                  </td>
                  <td className="text-muted text-sm">
                    {u.role === 'client'
                      ? companyName(u.companyId)
                      : (u.departmentIds?.length ? u.departmentIds.map(deptName).join(', ') : '—')}
                  </td>
                  <td><span className={`badge ${u.active ? 'badge-resolved' : 'badge-closed'}`}>{u.active ? 'Ativo' : 'Inativo'}</span></td>
                  <td className="text-right" style={{ whiteSpace: 'nowrap' }}>
                    <button className="btn btn-sm btn-ghost" onClick={() => startEdit(u)}>Editar</button>
                    <button className="btn btn-sm btn-ghost" onClick={() => toggleActive(u)}>{u.active ? 'Desativar' : 'Ativar'}</button>
                    <button className="btn btn-sm btn-ghost" onClick={() => startSetPassword(u)} title="Definir senha">🔒</button>
                    <button className="btn btn-sm btn-ghost" onClick={() => resetPassword(u)} title="Enviar redefinição por e-mail">🔑</button>
                    <button className="btn btn-sm btn-ghost" onClick={() => resetMfa(u)} title="Redefinir MFA (desvincular autenticador)">🔓</button>
                    {u.id !== me?.id && <button className="btn btn-sm btn-ghost" onClick={() => remove(u)} title="Remover">🗑</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>}
      </div>
      <Pager paged={paged} noun="usuários" />

      {/* Modal de criação/edição de usuário */}
      <Modal
        open={formOpen}
        onClose={closeForm}
        title={editing ? 'Editar usuário' : 'Criar usuário'}
        maxWidth={520}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeForm}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="user-form">{editing ? 'Salvar' : 'Criar usuário'}</button>
          </>
        }
      >
        <form id="user-form" onSubmit={save}>
          <div className="field"><label className="label">Nome</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required autoFocus /></div>
          <div className="field"><label className="label">E-mail</label>
            <input className="input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required disabled={!!editing} />
            {editing && <p className="text-dim text-xs mt-1">O e-mail não pode ser alterado.</p>}
          </div>
          <div className="field"><label className="label">Tipo</label>
            <select className="select" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value as UserRole })}>
              <option value={UserRole.CLIENT}>Cliente</option>
              <option value={UserRole.AGENT}>Atendente</option>
              <option value={UserRole.ADMIN}>Administrador</option>
              <option value={UserRole.ACCOUNTING}>Contabilidade</option>
            </select>
          </div>
          {form.role === UserRole.CLIENT && (
            <div className="field"><label className="label">Empresa</label>
              <select className="select" value={form.companyId} onChange={(e) => setForm({ ...form, companyId: e.target.value })} required>
                <option value="">Selecione</option>
                {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
          )}
          {(form.role === UserRole.AGENT || form.role === UserRole.ADMIN) && (
            <>
              <div className="field">
                <label className="label">Níveis de suporte</label>
                <div className="flex gap-3 flex-wrap">
                  {Object.entries(SupportLevelLabels).map(([v, l]) => (
                    <label key={v} className="flex items-center gap-2" style={{ cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={form.supportLevels.includes(v as SupportLevel)}
                        onChange={() => setForm({ ...form, supportLevels: toggleInArray(form.supportLevels, v as SupportLevel) })}
                      />
                      {l}
                    </label>
                  ))}
                </div>
                <p className="text-dim text-xs mt-1">O atendente pode atuar em mais de um nível.</p>
              </div>
              <div className="field">
                <label className="label">Departamentos</label>
                {departments.length === 0 ? (
                  <p className="text-dim text-xs">Nenhum departamento cadastrado.</p>
                ) : (
                  <div className="flex gap-3 flex-wrap">
                    {departments.map((d) => (
                      <label key={d.id} className="flex items-center gap-2" style={{ cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={form.departmentIds.includes(d.id)}
                          onChange={() => setForm({ ...form, departmentIds: toggleInArray(form.departmentIds, d.id) })}
                        />
                        {d.name}
                      </label>
                    ))}
                  </div>
                )}
                <p className="text-dim text-xs mt-1">Pode pertencer a mais de um departamento.</p>
              </div>
            </>
          )}
          {/* Telefone/WhatsApp: usado para casar contatos de WhatsApp com o usuário
              (contato novo é reconhecido pelo número ao chegar mensagem). */}
          <div className="field"><label className="label">Telefone / WhatsApp (opcional)</label>
            <input className="input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="ex.: 5511999998888 (com DDI e DDD)" inputMode="tel" />
            <p className="text-dim text-xs mt-1">Número com DDI e DDD. Usado para reconhecer o contato no WhatsApp (novos e antigos).</p>
          </div>
          {/* Ramal 3CX: usado na telefonia (associa ligações a quem atende). */}
          <div className="field"><label className="label">Ramal 3CX (opcional)</label>
            <input className="input" value={form.extension} onChange={(e) => setForm({ ...form, extension: e.target.value })} placeholder="ex.: 100" inputMode="numeric" />
            <p className="text-dim text-xs mt-1">Ramal do usuário no 3CX, para o click-to-call e o registro de ligações.</p>
          </div>
          {!editing && (
            <>
              <div className="field"><label className="label">Senha (opcional)</label>
                <input className="input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Deixe em branco para enviar convite por e-mail" />
                <p className="text-dim text-xs mt-1">Se definir aqui, o convite por e-mail não é enviado.</p>
              </div>
              {form.password.trim() && (
                <label className="flex items-center gap-2 field" style={{ cursor: 'pointer' }}>
                  <input type="checkbox" checked={form.requireChange} onChange={(e) => setForm({ ...form, requireChange: e.target.checked })} />
                  Exigir troca no primeiro acesso
                </label>
              )}
            </>
          )}
        </form>
      </Modal>

      {/* Modal de definir senha */}
      <Modal
        open={!!pwUser}
        onClose={() => setPwUser(null)}
        title="Definir senha"
        maxWidth={440}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={() => setPwUser(null)}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="pw-form">Salvar senha</button>
          </>
        }
      >
        {pwUser && (
          <form id="pw-form" onSubmit={submitSetPassword}>
            <p className="text-muted text-sm mb-4">Usuário: <strong>{pwUser.name}</strong> ({pwUser.email})</p>
            <div className="field"><label className="label">Nova senha</label>
              <input className="input" type="password" value={pwValue} onChange={(e) => setPwValue(e.target.value)} placeholder="Mínimo 10 caracteres" required autoFocus />
            </div>
            <label className="flex items-center gap-2 field" style={{ cursor: 'pointer' }}>
              <input type="checkbox" checked={pwRequireChange} onChange={(e) => setPwRequireChange(e.target.checked)} />
              Exigir troca no primeiro acesso
            </label>
          </form>
        )}
      </Modal>
    </div>
  );
}

function DepartmentsTab() {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [form, setForm] = useState<{ name: string; kind: string }>({ name: '', kind: 'support' });
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState('');
  const load = () => api.get<Paginated<Department>>('/departments').then((r) => setDepartments(r.items)).catch(() => {});
  useEffect(() => { load(); }, []);
  const create = async (e: FormEvent) => {
    e.preventDefault();
    await api.post('/departments', form);
    setForm({ name: '', kind: 'support' }); setOpen(false); load();
  };
  const term = filter.trim().toLowerCase();
  const visible = term ? departments.filter((d) => `${d.name} ${d.kind}`.toLowerCase().includes(term)) : departments;
  const { sorted, sort } = useSortable<Department>(visible, { name: (d) => d.name, kind: (d) => d.kind });
  const paged = usePaged(sorted, 20);
  return (
    <div>
      <div className="flex gap-2 items-end justify-between flex-wrap mb-3">
        <div className="field mb-0" style={{ flex: 1, maxWidth: 320 }}>
          <label className="label">Buscar departamento</label>
          <input className="input" value={filter} onChange={(e) => { setFilter(e.target.value); paged.setPage(1); }} placeholder="nome ou tipo" />
        </div>
        <button className="btn btn-primary" onClick={() => { setForm({ name: '', kind: 'support' }); setOpen(true); }}>+ Novo departamento</button>
      </div>
      <div className="card card-flush">
        {visible.length === 0 ? <div className="empty"><div className="empty-icon">🗂</div>{departments.length === 0 ? 'Nenhum departamento.' : 'Nenhum departamento encontrado.'}</div> :
          <table className="table"><thead><tr>
            <SortableTh<Department> field="name" sort={sort}>Nome</SortableTh>
            <SortableTh<Department> field="kind" sort={sort}>Tipo</SortableTh>
          </tr></thead><tbody>
            {paged.pageItems.map((d) => <tr key={d.id}><td className="font-semibold">{d.name}</td><td className="text-muted text-sm">{d.kind}</td></tr>)}
          </tbody></table>}
      </div>
      <Pager paged={paged} noun="departamentos" />
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Novo departamento"
        maxWidth={440}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={() => setOpen(false)}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="dept-form">Adicionar</button>
          </>
        }
      >
        <form id="dept-form" onSubmit={create}>
          <div className="field"><label className="label">Nome</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required autoFocus /></div>
          <div className="field"><label className="label">Tipo</label>
            <select className="select" value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value })}>
              <option value="support">Suporte</option><option value="finance">Financeiro</option><option value="sales">Vendas</option>
            </select>
          </div>
        </form>
      </Modal>
    </div>
  );
}

function QueuesTab() {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [queues, setQueues] = useState<Queue[]>([]);
  const [filterDept, setFilterDept] = useState('');
  const [filter, setFilter] = useState('');
  const [open, setOpen] = useState(false);
  const emptyForm = { name: '', departmentId: '', supportLevel: SupportLevel.L1 };
  const [form, setForm] = useState<{ name: string; departmentId: string; supportLevel: SupportLevel }>({ ...emptyForm });

  useEffect(() => { api.get<Paginated<Department>>('/departments').then((r) => setDepartments(r.items)).catch(() => {}); }, []);
  useEffect(() => {
    if (!filterDept) { setQueues([]); return; }
    api.get<Paginated<Queue>>(`/departments/${filterDept}/queues`).then((r) => setQueues(r.items)).catch(() => setQueues([]));
  }, [filterDept]);

  const openNew = () => { setForm({ ...emptyForm, departmentId: filterDept }); setOpen(true); };

  const create = async (e: FormEvent) => {
    e.preventDefault();
    await api.post('/queues', form);
    setOpen(false);
    // Passa a exibir a lista do departamento onde a fila foi criada.
    setFilterDept(form.departmentId);
    if (form.departmentId === filterDept) {
      const r = await api.get<Paginated<Queue>>(`/departments/${form.departmentId}/queues`);
      setQueues(r.items);
    }
  };

  const term = filter.trim().toLowerCase();
  const visibleQueues = term ? queues.filter((q) => `${q.name} ${q.supportLevel}`.toLowerCase().includes(term)) : queues;
  const { sorted, sort } = useSortable<Queue>(visibleQueues, { name: (q) => q.name, supportLevel: (q) => q.supportLevel });

  return (
    <div>
      <div className="flex gap-2 items-end justify-between flex-wrap mb-3">
        <div className="flex gap-2 items-end flex-wrap" style={{ flex: 1 }}>
          <div className="field mb-0" style={{ minWidth: 220 }}>
            <label className="label">Departamento</label>
            <select className="select" value={filterDept} onChange={(e) => setFilterDept(e.target.value)}>
              <option value="">Selecione um departamento</option>
              {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>
          </div>
          {filterDept && (
            <div className="field mb-0" style={{ minWidth: 200 }}>
              <label className="label">Buscar fila</label>
              <input className="input" value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="nome ou nível" />
            </div>
          )}
        </div>
        <button className="btn btn-primary" onClick={openNew}>+ Nova fila</button>
      </div>
      <div className="card card-flush">
        {!filterDept ? <div className="empty"><div className="empty-icon">📋</div>Selecione um departamento para ver as filas.</div> :
          visibleQueues.length === 0 ? <div className="empty"><div className="empty-icon">📋</div>{queues.length === 0 ? 'Sem filas neste departamento.' : 'Nenhuma fila encontrada.'}</div> :
          <table className="table"><thead><tr>
            <SortableTh<Queue> field="name" sort={sort}>Fila</SortableTh>
            <SortableTh<Queue> field="supportLevel" sort={sort}>Nível</SortableTh>
          </tr></thead><tbody>
            {sorted.map((q) => <tr key={q.id}><td className="font-semibold">{q.name}</td><td><span className="badge badge-normal">{q.supportLevel}</span></td></tr>)}
          </tbody></table>}
      </div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Nova fila"
        maxWidth={440}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={() => setOpen(false)}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="queue-form" disabled={!form.departmentId}>Adicionar fila</button>
          </>
        }
      >
        <form id="queue-form" onSubmit={create}>
          <div className="field"><label className="label">Departamento</label>
            <select className="select" value={form.departmentId} onChange={(e) => setForm({ ...form, departmentId: e.target.value })} required>
              <option value="">Selecione</option>
              {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>
          </div>
          <div className="field"><label className="label">Nome da fila</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="field"><label className="label">Nível de suporte</label>
            <select className="select" value={form.supportLevel} onChange={(e) => setForm({ ...form, supportLevel: e.target.value as SupportLevel })}>
              <option value={SupportLevel.L1}>Nível 1 (N1)</option>
              <option value={SupportLevel.L2}>Nível 2 (N2)</option>
              <option value={SupportLevel.L3}>Nível 3 (N3)</option>
            </select>
          </div>
        </form>
      </Modal>
    </div>
  );
}

// Aba de Configurações: canais (e-mail/WhatsApp/Discord/MW-SCAN) e SLA. Grava no SSM.
function SettingsTab() {
  const toast = useToast();
  const [s, setS] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncMsg, setSyncMsg] = useState('');
  const [syncingContracts, setSyncingContracts] = useState(false);
  const [syncMsgContracts, setSyncMsgContracts] = useState('');
  const [normalizingPhones, setNormalizingPhones] = useState(false);
  const [normalizePhonesMsg, setNormalizePhonesMsg] = useState('');

  useEffect(() => {
    api.get<Record<string, string>>('/settings')
      .then((data) => {
        // Exibe os campos de SLA em HH:MM (converte valores antigos salvos em horas).
        const slaKeys = ['sla-low-hours', 'sla-normal-hours', 'sla-high-hours', 'sla-urgent-hours', 'fr-low-hours', 'fr-normal-hours', 'fr-high-hours', 'fr-urgent-hours'];
        const next = { ...data };
        for (const k of slaKeys) if (next[k]) next[k] = slaDisplay(next[k]);
        setS(next);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const set = (k: string, v: string) => setS((prev) => ({ ...prev, [k]: v }));

  // Normaliza um valor de SLA para exibição em HH:MM. Aceita valores antigos em horas
  // (ex.: "4" → "4:00", "1.5" → "1:30") e valores já em HH:MM (mantidos).
  const slaDisplay = (raw?: string): string => {
    const v = (raw ?? '').trim();
    if (!v) return '';
    if (/^\d+:[0-5]?\d$/.test(v)) return v; // já está em HH:MM
    const n = Number(v.replace(',', '.'));
    if (!Number.isFinite(n) || n <= 0) return '';
    const h = Math.floor(n);
    const m = Math.round((n - h) * 60);
    return `${h}:${String(m).padStart(2, '0')}`;
  };

  const save = async (e: FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/settings', s);
      toast.success('Configurações salvas');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    } finally {
      setSaving(false);
    }
  };

  // Dispara a importação de clientes da GestãoClick sob demanda.
  const syncNow = async () => {
    setSyncing(true);
    setSyncMsg('');
    try {
      const r = await api.post<{ created: number; updated: number; active: number }>('/companies/sync', {});
      setSyncMsg(`${r.created} criadas, ${r.updated} atualizadas (${r.active} ativas).`);
      toast.success('Sincronização concluída');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha na sincronização');
    } finally {
      setSyncing(false);
    }
  };

  // Dispara a importação de contratos da GestãoClick sob demanda.
  const syncContractsNow = async () => {
    setSyncingContracts(true);
    setSyncMsgContracts('');
    try {
      const r = await api.post<{ fetched: number; created: number; updated: number; unmatchedCompany: number }>('/contracts/sync', {});
      let msg = `${r.created} criados, ${r.updated} atualizados (${r.fetched} lidos).`;
      if (r.unmatchedCompany > 0) msg += ` ${r.unmatchedCompany} sem empresa associada (sincronize os clientes primeiro).`;
      setSyncMsgContracts(msg);
      toast.success('Importação de contratos concluída');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha na importação de contratos');
    } finally {
      setSyncingContracts(false);
    }
  };

  // Adiciona o DDI 55 aos telefones das empresas (para o WhatsApp).
  const normalizePhonesNow = async () => {
    setNormalizingPhones(true);
    setNormalizePhonesMsg('');
    try {
      const r = await api.post<{ scanned: number; updated: number }>('/companies/normalize-phones', {});
      setNormalizePhonesMsg(`${r.updated} telefone(s) ajustado(s) de ${r.scanned} empresa(s).`);
      toast.success('Telefones normalizados');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao normalizar telefones');
    } finally {
      setNormalizingPhones(false);
    }
  };

  // Teste de conexão com o Banco Inter (usa as credenciais já salvas no servidor).
  const [interTesting, setInterTesting] = useState(false);
  const [interResult, setInterResult] = useState<{ ok: boolean; message: string } | null>(null);
  const testInter = async () => {
    setInterTesting(true);
    setInterResult(null);
    try {
      const r = await api.post<{ ok: boolean; message: string; env: string }>('/finance/inter/test', {});
      setInterResult({ ok: r.ok, message: r.message });
    } catch (err) {
      setInterResult({ ok: false, message: err instanceof Error ? err.message : 'Falha ao testar' });
    } finally {
      setInterTesting(false);
    }
  };

  // Teste da fundação da NFS-e Nacional (certificado A1 + adesão do município).
  const [nfseTesting, setNfseTesting] = useState(false);
  const [nfseResult, setNfseResult] = useState<{ ok: boolean; message: string } | null>(null);
  const testNfse = async () => {
    setNfseTesting(true);
    setNfseResult(null);
    try {
      const r = await api.post<{ ok: boolean; message: string }>('/finance/nfse/test', {});
      setNfseResult({ ok: r.ok, message: r.message });
    } catch (err) {
      setNfseResult({ ok: false, message: err instanceof Error ? err.message : 'Falha ao testar' });
    } finally {
      setNfseTesting(false);
    }
  };

  if (loading) return <div className="flex justify-center" style={{ padding: 40 }}><span className="spinner" /></div>;

  return (
    <div style={{ maxWidth: 880 }}>
    <DepartmentVisibilityCard />
    <form onSubmit={save}>
      <div className="card mt-4">
        <h3>📧 E-mail → ticket (IMAP / Zimbra)</h3>
        <div className="form-grid">
          <div className="field field-full"><label className="label">Servidor</label><input className="input" value={s['imap-host'] ?? ''} onChange={(e) => set('imap-host', e.target.value)} placeholder="mail.makweb.com.br" /></div>
          <div className="field"><label className="label">Porta</label><input className="input" value={s['imap-port'] ?? ''} onChange={(e) => set('imap-port', e.target.value)} placeholder="993" /></div>
          <div className="field"><label className="label">Usuário</label><input className="input" value={s['imap-user'] ?? ''} onChange={(e) => set('imap-user', e.target.value)} placeholder="suporte@makweb.com.br" /></div>
          <div className="field"><label className="label">Senha</label><input className="input" type="password" value={s['imap-password'] ?? ''} onChange={(e) => set('imap-password', e.target.value)} placeholder="••••••••" /></div>
        </div>
        <div className="field field-full mt-3">
          <label className="label">🚫 Remetentes bloqueados (filtro de spam)</label>
          <textarea
            className="textarea"
            rows={3}
            value={s['blocked-senders'] ?? ''}
            onChange={(e) => set('blocked-senders', e.target.value)}
            placeholder="spam@dominio.com, outrodominio.com (um por linha ou separados por vírgula)"
          />
          <div className="text-dim text-xs mt-2">
            E-mails desses remetentes (ou domínios inteiros, ex.: <code>dominio.com</code>) são descartados e não viram chamado.
          </div>
        </div>
      </div>

      <div className="card mt-4">
        <h3>💸 Financeiro API (remetente de e-mail)</h3>
        <div className="form-grid">
          <div className="field field-full">
            <label className="label">Remetente das cobranças e notas fiscais</label>
            <input
              className="input"
              type="email"
              value={s['finance-from-address'] ?? ''}
              onChange={(e) => set('finance-from-address', e.target.value)}
              placeholder="financeiro@makweb.com.br"
            />
          </div>
          <div className="field field-full">
            <label className="label">Remetente de orçamentos e contratos (prévia e assinatura)</label>
            <input
              className="input"
              type="email"
              value={s['contracts-from-address'] ?? ''}
              onChange={(e) => set('contracts-from-address', e.target.value)}
              placeholder="sistema@makweb.com.br"
            />
          </div>
        </div>
        <div className="text-dim text-xs mt-2">
          E-mails de cobrança e de notas fiscais são enviados por este endereço. Deve pertencer a um
          domínio/identidade verificado no SES (ex.: qualquer <code>@makweb.com.br</code>). Vazio usa o
          padrão <code>financeiro@makweb.com.br</code>. Os chamados continuam saindo como <code>suporte@makweb.com.br</code>.
        </div>
      </div>

      <div className="card mt-4">
        <h3>🏦 Banco Inter (emissão de boleto)</h3>
        <p className="text-muted text-sm mt-1">
          Integração via API Cobrança (OAuth2 + certificado mTLS). Gere a integração no Internet Banking
          do Inter (Soluções para sua empresa → Nova Integração) com os escopos <code>boleto-cobranca</code>,
          baixe o certificado (.crt e .key) e cole os conteúdos abaixo.
        </p>
        <div className="form-grid mt-2">
          <div className="field">
            <label className="label">Ambiente</label>
            <select className="select" value={s['inter-env'] ?? 'sandbox'} onChange={(e) => set('inter-env', e.target.value)}>
              <option value="sandbox">Sandbox (testes)</option>
              <option value="prod">Produção</option>
            </select>
          </div>
          <div className="field">
            <label className="label" title="Com desabilitado, o painel não emite boletos (as rotas de emissão recusam).">Emissão de boleto pelo painel</label>
            <select className="select" value={s['inter-emission-enabled'] === 'true' ? 'true' : 'false'} onChange={(e) => set('inter-emission-enabled', e.target.value)}>
              <option value="false">Desabilitada</option>
              <option value="true">Habilitada</option>
            </select>
          </div>
          <div className="field">
            <label className="label">Conta corrente</label>
            <input className="input" value={s['inter-conta-corrente'] ?? ''} onChange={(e) => set('inter-conta-corrente', e.target.value)} placeholder="ex.: 123456789" inputMode="numeric" />
          </div>
          <div className="field">
            <label className="label">Client ID</label>
            <input className="input" type="password" value={s['inter-client-id'] ?? ''} onChange={(e) => set('inter-client-id', e.target.value)} placeholder="••••••••" />
          </div>
          <div className="field">
            <label className="label">Client Secret</label>
            <input className="input" type="password" value={s['inter-client-secret'] ?? ''} onChange={(e) => set('inter-client-secret', e.target.value)} placeholder="••••••••" />
          </div>
        </div>
        <div className="field field-full mt-2">
          <label className="label">Certificado (.crt) — conteúdo PEM</label>
          <textarea className="textarea" rows={4} value={s['inter-cert-crt'] ?? ''} onChange={(e) => set('inter-cert-crt', e.target.value)} placeholder="-----BEGIN CERTIFICATE-----" style={{ fontFamily: 'monospace', fontSize: 12 }} />
        </div>
        <div className="field field-full mt-2">
          <label className="label">Chave privada (.key) — conteúdo PEM</label>
          <textarea className="textarea" rows={4} value={s['inter-cert-key'] ?? ''} onChange={(e) => set('inter-cert-key', e.target.value)} placeholder="-----BEGIN PRIVATE KEY-----" style={{ fontFamily: 'monospace', fontSize: 12 }} />
        </div>
        <div className="flex items-center gap-3 mt-3">
          <button
            type="button"
            className="btn btn-ghost"
            disabled={interTesting}
            title="Salve as configurações antes de testar. O teste autentica no Inter e consulta cobranças."
            onClick={testInter}
          >
            {interTesting ? 'Testando...' : '🔌 Testar conexão'}
          </button>
          {interResult && (
            <span className="text-sm" style={{ color: interResult.ok ? 'var(--success)' : 'var(--danger)' }}>
              {interResult.ok ? '✓' : '✕'} {interResult.message}
            </span>
          )}
        </div>
        <div className="text-dim text-xs mt-2">
          Os segredos (Client ID/Secret e o certificado) são gravados de forma protegida e exibidos como
          <code> ******** </code> depois de salvos. Para testar, salve primeiro e clique em Testar conexão.
        </div>
      </div>

      <div className="card mt-4">
        <h3>🧾 NFS-e (emissão de nota)</h3>
        <div className="field mt-1">
          <label className="label">Provedor de emissão ativo</label>
          <select className="select" value={s['nfse-provider'] ?? 'nacional'} onChange={(e) => set('nfse-provider', e.target.value)} style={{ maxWidth: 320 }}>
            <option value="municipal">Municipal (GISSONLINE — Ribeirão Pires)</option>
            <option value="nacional">Padrão Nacional (SEFIN)</option>
          </select>
          <p className="text-dim text-xs mt-1">
            Ribeirão Pires ainda não aderiu ao Padrão Nacional — use <strong>Municipal</strong> por enquanto.
            Ao aderir, troque para <strong>Padrão Nacional</strong> (a configuração nacional já fica pronta abaixo).
          </p>
        </div>
      </div>

      <div className="card mt-4">
        <h3>🏛️ NFS-e Municipal (GISSONLINE — Ribeirão Pires)</h3>
        <p className="text-muted text-sm mt-1">
          Emissão pelo webservice do município. Informe a URL oficial do webservice, o padrão e as
          credenciais fornecidas pela prefeitura. Use o certificado A1 configurado na seção do Padrão
          Nacional (mesma empresa).
        </p>
        <div className="form-grid mt-2">
          <div className="field">
            <label className="label">Ambiente</label>
            <select className="select" value={s['nfse-mun-env'] ?? 'homologacao'} onChange={(e) => set('nfse-mun-env', e.target.value)}>
              <option value="homologacao">Homologação</option>
              <option value="prod">Produção</option>
            </select>
          </div>
          <div className="field">
            <label className="label">Padrão do webservice</label>
            <select className="select" value={s['nfse-mun-padrao'] ?? 'issonline'} onChange={(e) => set('nfse-mun-padrao', e.target.value)}>
              <option value="issonline">ISSONLINE / GISSONLINE</option>
              <option value="abrasf204">ABRASF 2.04</option>
              <option value="abrasf203">ABRASF 2.03</option>
            </select>
          </div>
          <div className="field field-full">
            <label className="label">URL do webservice (homologação)</label>
            <input className="input" value={s['nfse-mun-ws-homolog'] ?? ''} onChange={(e) => set('nfse-mun-ws-homolog', e.target.value)} placeholder="https://... (obtida no portal/prefeitura)" />
          </div>
          <div className="field field-full">
            <label className="label">URL do webservice (produção)</label>
            <input className="input" value={s['nfse-mun-ws-prod'] ?? ''} onChange={(e) => set('nfse-mun-ws-prod', e.target.value)} placeholder="https://..." />
          </div>
          <div className="field">
            <label className="label">Usuário / login</label>
            <input className="input" value={s['nfse-mun-usuario'] ?? ''} onChange={(e) => set('nfse-mun-usuario', e.target.value)} placeholder="login do portal" />
          </div>
          <div className="field">
            <label className="label">Senha</label>
            <input className="input" type="password" value={s['nfse-mun-senha'] ?? ''} onChange={(e) => set('nfse-mun-senha', e.target.value)} placeholder="••••••••" />
          </div>
          <div className="field">
            <label className="label">Código mobiliário</label>
            <input className="input" value={s['nfse-mun-cod-mobiliario'] ?? ''} onChange={(e) => set('nfse-mun-cod-mobiliario', e.target.value)} placeholder="inscrição mobiliária" />
          </div>
          <div className="field">
            <label className="label">Série do RPS</label>
            <input className="input" value={s['nfse-mun-serie-rps'] ?? ''} onChange={(e) => set('nfse-mun-serie-rps', e.target.value)} placeholder="1" />
          </div>
        </div>
        <div className="text-dim text-xs mt-2">
          Preciso da <strong>URL oficial do webservice de Ribeirão Pires</strong> e do padrão correto para
          habilitar a emissão. A emissão real será ativada após validar em homologação.
        </div>
      </div>

      <div className="card mt-4">
        <h3>🧾 NFS-e Nacional (SEFIN — quando o município aderir)</h3>
        <p className="text-muted text-sm mt-1">
          Emissão pelo Padrão Nacional (SEFIN), obrigatório para o Simples Nacional. Requer certificado
          digital A1 (ICP-Brasil) do prestador. Comece em <strong>Produção Restrita</strong> (homologação)
          antes de emitir notas reais. <strong>Ribeirão Pires ainda não aderiu</strong> — deixe configurado
          e ative quando a adesão ocorrer.
        </p>
        <div className="form-grid mt-2">
          <div className="field">
            <label className="label">Ambiente</label>
            <select className="select" value={s['nfse-env'] ?? 'restrita'} onChange={(e) => set('nfse-env', e.target.value)}>
              <option value="restrita">Produção Restrita (homologação)</option>
              <option value="prod">Produção</option>
            </select>
          </div>
          <div className="field">
            <label className="label">Código do município (IBGE)</label>
            <input className="input" value={s['nfse-codigo-municipio'] ?? ''} onChange={(e) => set('nfse-codigo-municipio', e.target.value)} placeholder="3543303 (Ribeirão Pires)" inputMode="numeric" />
          </div>
          <div className="field">
            <label className="label">CNPJ do prestador</label>
            <input className="input" value={s['nfse-prestador-cnpj'] ?? ''} onChange={(e) => set('nfse-prestador-cnpj', e.target.value)} placeholder="somente dígitos" inputMode="numeric" />
          </div>
          <div className="field">
            <label className="label">Inscrição municipal</label>
            <input className="input" value={s['nfse-prestador-im'] ?? ''} onChange={(e) => set('nfse-prestador-im', e.target.value)} placeholder="ex.: 1027539" />
          </div>
        </div>
        <div className="form-grid mt-2">
          <div className="field">
            <label className="label">Certificado A1 (.pfx / .p12)</label>
            <input
              type="file"
              accept=".pfx,.p12"
              className="input"
              onChange={async (e) => {
                const file = e.target.files?.[0];
                if (!file) return;
                // Lê o arquivo e converte para base64 (sem o prefixo data:).
                const buf = await file.arrayBuffer();
                let bin = '';
                const bytes = new Uint8Array(buf);
                for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
                set('nfse-cert-pfx', btoa(bin));
                toast.success(`Certificado "${file.name}" carregado. Salve para aplicar.`);
              }}
            />
            <p className="text-dim text-xs mt-1">
              {s['nfse-cert-pfx'] === '********' ? 'Certificado já salvo (envie um novo para substituir).' : 'Selecione o arquivo do certificado A1.'}
            </p>
          </div>
          <div className="field">
            <label className="label">Senha do certificado</label>
            <input className="input" type="password" value={s['nfse-cert-password'] ?? ''} onChange={(e) => set('nfse-cert-password', e.target.value)} placeholder="••••••••" />
          </div>
        </div>
        <div className="flex items-center gap-3 mt-3">
          <button
            type="button"
            className="btn btn-ghost"
            disabled={nfseTesting}
            title="Salve as configurações antes de testar. Valida o certificado e a adesão do município."
            onClick={testNfse}
          >
            {nfseTesting ? 'Verificando...' : '🔍 Testar / verificar adesão'}
          </button>
          {nfseResult && (
            <span className="text-sm" style={{ color: nfseResult.ok ? 'var(--success)' : 'var(--danger)' }}>
              {nfseResult.ok ? '✓' : '✕'} {nfseResult.message}
            </span>
          )}
        </div>
        <div className="text-dim text-xs mt-2">
          A emissão automática de notas será habilitada após a validação em homologação. Por ora, esta
          seção configura o certificado e verifica a adesão do município ao Padrão Nacional.
        </div>
      </div>

      <div className="card mt-4">
        <h3>💬 WhatsApp (Evolution API)</h3>
        <div className="form-grid">
          <div className="field field-full"><label className="label">URL da API</label><input className="input" value={s['evolution-api-url'] ?? ''} onChange={(e) => set('evolution-api-url', e.target.value)} placeholder="https://sua-evolution" /></div>
          <div className="field"><label className="label">Chave (apikey)</label><input className="input" type="password" value={s['evolution-api-key'] ?? ''} onChange={(e) => set('evolution-api-key', e.target.value)} placeholder="••••••••" /></div>
          <div className="field"><label className="label">Instância</label><input className="input" value={s['evolution-instance'] ?? ''} onChange={(e) => set('evolution-instance', e.target.value)} placeholder="minha-instancia" /></div>
        </div>
        <div className="text-dim text-xs mt-3">Aponte o webhook da Evolution para <code>/webhook/whatsapp</code>.</div>
      </div>

      <div className="card mt-4">
        <h3>🔔 Discord (alertas)</h3>
        <div className="field mb-0"><label className="label">Webhook URL</label><input className="input" type="password" value={s['discord-webhook-url'] ?? ''} onChange={(e) => set('discord-webhook-url', e.target.value)} placeholder="••••••••" /></div>
      </div>

      <div className="card mt-4">
        <h3>🖥 MW-SCAN</h3>
        <div className="field mb-0"><label className="label">Token do webhook</label><input className="input" type="password" value={s['mw-scan-token'] ?? ''} onChange={(e) => set('mw-scan-token', e.target.value)} placeholder="••••••••" /></div>
        <div className="text-dim text-xs mt-2">Use o mesmo token no MW-SCAN (header <code>x-mw-scan-token</code>).</div>
      </div>

      <div className="card mt-4">
        <h3>🏢 GestãoClick (importar clientes)</h3>
        <div className="form-grid">
          <div className="field"><label className="label">Access Token</label><input className="input" type="password" value={s['clickapp-access-token'] ?? ''} onChange={(e) => set('clickapp-access-token', e.target.value)} placeholder="••••••••" /></div>
          <div className="field"><label className="label">Secret Access Token</label><input className="input" type="password" value={s['clickapp-secret-token'] ?? ''} onChange={(e) => set('clickapp-secret-token', e.target.value)} placeholder="••••••••" /></div>
          <div className="field field-full"><label className="label">URL base da API</label><input className="input" value={s['clickapp-base-url'] ?? ''} onChange={(e) => set('clickapp-base-url', e.target.value)} placeholder="https://api.gestaoclick.com/api" /></div>
        </div>
        <label className="flex items-center gap-2 field mt-3" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={s['clickapp-sync-enabled'] === 'true'} onChange={(e) => set('clickapp-sync-enabled', e.target.checked ? 'true' : 'false')} />
          Sincronizar automaticamente 1x por dia (seg a sex)
        </label>
        <div className="flex items-center gap-2 mt-3" style={{ flexWrap: 'wrap' }}>
          <button className="btn btn-secondary" type="button" disabled={syncing} onClick={syncNow}>
            {syncing ? 'Sincronizando...' : 'Sincronizar clientes'}
          </button>
          {syncMsg && <span className="text-dim text-xs">{syncMsg}</span>}
        </div>
        <div className="text-dim text-xs mt-2">Importa os clientes ativos da GestãoClick como empresas. Salve as credenciais antes de sincronizar.</div>

        <div className="flex items-center gap-2 mt-3" style={{ flexWrap: 'wrap' }}>
          <button className="btn btn-secondary" type="button" disabled={syncingContracts} onClick={syncContractsNow}>
            {syncingContracts ? 'Importando contratos...' : 'Importar contratos'}
          </button>
          {syncMsgContracts && <span className="text-dim text-xs">{syncMsgContracts}</span>}
        </div>
        <div className="text-dim text-xs mt-2">Importa todos os contratos da GestãoClick (todos os tipos). Cada contrato é associado à empresa pelo cliente de origem — sincronize os clientes antes para o vínculo ser feito automaticamente.</div>

        <div className="flex items-center gap-2 mt-3" style={{ flexWrap: 'wrap' }}>
          <button className="btn btn-secondary" type="button" disabled={normalizingPhones} onClick={normalizePhonesNow}>
            {normalizingPhones ? 'Ajustando telefones...' : 'Adicionar DDI 55 aos telefones'}
          </button>
          {normalizePhonesMsg && <span className="text-dim text-xs">{normalizePhonesMsg}</span>}
        </div>
        <div className="text-dim text-xs mt-2">Normaliza os telefones das empresas para o formato internacional com DDI 55 (necessário para o envio pelo WhatsApp). Idempotente: quem já tem 55 não é alterado.</div>
      </div>

      <div className="card mt-4">
        <h3>📞 Telefonia (3CX)</h3>
        <div className="field"><label className="label">URL do 3CX</label>
          <input className="input" value={s['3cx-base-url'] ?? ''} onChange={(e) => set('3cx-base-url', e.target.value)} placeholder="https://makweb.my3cx.com.br" />
          <div className="text-dim text-xs mt-1">Endereço do seu 3CX (usado como referência; o click-to-call usa o app 3CX Desktop via <code>tel:</code>).</div>
        </div>
        <label className="flex items-center gap-2 field mb-0" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={(s['3cx-call-link-enabled'] ?? 'true') !== 'false'} onChange={(e) => set('3cx-call-link-enabled', e.target.checked ? 'true' : 'false')} />
          Registrar a ligação como nota no chamado ao clicar para ligar
        </label>
        <div className="text-dim text-xs mt-2">Desligue para não vincular ligações aos chamados. O botão de ligar continua funcionando.</div>
      </div>

      <div className="card mt-4">
        <h3>⏱ SLA de resolução (HH:MM até o prazo)</h3>
        <div className="field-row">
          {[['sla-urgent-hours', 'Urgente'], ['sla-high-hours', 'Alta'], ['sla-normal-hours', 'Normal'], ['sla-low-hours', 'Baixa']].map(([k, label]) => (
            <div className="field" key={k}>
              <label className="label">{label}</label>
              <input className="input" inputMode="numeric" value={s[k] ?? ''} onChange={(e) => set(k, e.target.value)} placeholder="HH:MM (ex.: 4:00)" />
            </div>
          ))}
        </div>
        <div className="text-dim text-xs mt-3">Use o formato HH:MM (ex.: <code>1:30</code> = 1h30). Vazio ou <code>0:00</code> = sem prazo. O prazo define o alerta de vencimento (Discord/e-mail).</div>
      </div>

      <div className="card mt-4">
        <h3>⚡ SLA de primeira resposta (HH:MM)</h3>
        <div className="field-row">
          {[['fr-urgent-hours', 'Urgente'], ['fr-high-hours', 'Alta'], ['fr-normal-hours', 'Normal'], ['fr-low-hours', 'Baixa']].map(([k, label]) => (
            <div className="field" key={k}>
              <label className="label">{label}</label>
              <input className="input" inputMode="numeric" value={s[k] ?? ''} onChange={(e) => set(k, e.target.value)} placeholder="HH:MM (ex.: 0:30)" />
            </div>
          ))}
        </div>
        <div className="text-dim text-xs mt-3">Meta de tempo (HH:MM) até a equipe dar a primeira resposta ao cliente.</div>
      </div>

      <div className="card mt-4">
        <h3>🗓 Horário comercial (calendário de SLA)</h3>
        <label className="flex items-center gap-2 field" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={s['biz-enabled'] === 'true'} onChange={(e) => set('biz-enabled', e.target.checked ? 'true' : 'false')} />
          Considerar apenas horário comercial no cálculo dos prazos de SLA
        </label>
        <div className="field-row">
          <div className="field"><label className="label">Início</label><input className="input" type="time" value={s['biz-start'] ?? '08:00'} onChange={(e) => set('biz-start', e.target.value)} /></div>
          <div className="field"><label className="label">Fim</label><input className="input" type="time" value={s['biz-end'] ?? '18:00'} onChange={(e) => set('biz-end', e.target.value)} /></div>
          <div className="field"><label className="label">Fuso (min. UTC)</label><input className="input" type="number" value={s['biz-tz-offset'] ?? '-180'} onChange={(e) => set('biz-tz-offset', e.target.value)} placeholder="-180" /></div>
        </div>
        <div className="field mt-4">
          <label className="label">Dias úteis</label>
          <div className="flex gap-2 flex-wrap">
            {[['0', 'Dom'], ['1', 'Seg'], ['2', 'Ter'], ['3', 'Qua'], ['4', 'Qui'], ['5', 'Sex'], ['6', 'Sáb']].map(([d, label]) => {
              const days = s['biz-days'] ?? '12345';
              const on = days.includes(d);
              return (
                <button
                  key={d} type="button"
                  className={`btn btn-sm ${on ? 'btn-primary' : 'btn-ghost'}`}
                  onClick={() => {
                    const set2 = new Set((s['biz-days'] ?? '12345').split(''));
                    if (on) set2.delete(d); else set2.add(d);
                    set('biz-days', [...set2].sort().join(''));
                  }}
                >{label}</button>
              );
            })}
          </div>
        </div>
        <div className="text-dim text-xs">Fuso em minutos de offset do UTC (BRT = -180). Desligado = SLA em relógio corrido (24x7).</div>
      </div>

      <div className="card mt-4">
        <h3>⭐ Satisfação e operação</h3>
        <label className="flex items-center gap-2 field" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={(s['csat-enabled'] ?? 'true') !== 'false'} onChange={(e) => set('csat-enabled', e.target.checked ? 'true' : 'false')} />
          Enviar pesquisa de satisfação ao resolver o chamado
        </label>
        <label className="flex items-center gap-2 field" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={s['require-solution'] === 'true'} onChange={(e) => set('require-solution', e.target.checked ? 'true' : 'false')} />
          Exigir solução preenchida antes de resolver ou fechar
        </label>
        <label className="flex items-center gap-2 field" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={(s['notify-email-updates'] ?? 'true') !== 'false'} onChange={(e) => set('notify-email-updates', e.target.checked ? 'true' : 'false')} />
          Avisar o cliente por e-mail em respostas e mudanças de status
        </label>
        <div className="field mb-0"><label className="label">URL pública do portal (links enviados ao cliente)</label>
          <input className="input" value={s['public-base-url'] ?? ''} onChange={(e) => set('public-base-url', e.target.value)} placeholder="https://d2sl68l6j7dlsc.cloudfront.net" />
          <div className="text-dim text-xs mt-1">Usada no link da pesquisa de satisfação. Deixe em branco para usar o padrão.</div>
        </div>
      </div>

      <div className="mt-4">
        <button className="btn btn-primary btn-lg" type="submit" disabled={saving}>{saving ? 'Salvando...' : 'Salvar configurações'}</button>
        <div className="text-dim text-xs mt-2">Segredos aparecem mascarados. Deixe em branco para manter o valor atual.</div>
      </div>
    </form>
    </div>
  );
}

// Card informativo: a visibilidade de chamados por departamento agora é definida
// pelo pertencimento do atendente (Administração > Usuários → Departamentos). Não há
// mais configuração por-usuário aqui (escala melhor com muitos usuários).
function DepartmentVisibilityCard() {
  return (
    <div className="card">
      <h3>👁 Visibilidade de chamados por departamento</h3>
      <p className="text-muted text-sm mt-1">
        Cada <strong>atendente</strong> vê os chamados dos <strong>departamentos aos quais pertence</strong>.
        Defina os departamentos de cada atendente no cadastro dele em{' '}
        <strong>Administração &gt; Usuários</strong> (campo “Departamentos”).
      </p>
      <ul className="text-muted text-sm mt-2" style={{ paddingLeft: 18, lineHeight: 1.7 }}>
        <li>Administradores sempre veem todos os chamados.</li>
        <li>Chamado aberto <strong>sem departamento</strong> entra no <strong>Suporte</strong> automaticamente.</li>
        <li>Para um atendente ver os chamados novos do Suporte, inclua o <strong>Suporte</strong> nos departamentos dele.</li>
        <li>Atendente sem departamento cadastrado só vê os chamados atribuídos a ele.</li>
      </ul>
    </div>
  );
}

// Aba de Contratos: planos de suporte por empresa (admin).
// Formulário do contrato (estruturado e editável). Strings para os inputs; os
// itens de serviço são uma lista à parte (editável).
type ContractForm = {
  companyId: string; name: string; type: string;
  monthlyHours: string; monthlyFee: string; hourlyRate: string;
  startDate: string; endDate: string; notes: string;
  sellerName: string; salesChannel: string; storeName: string;
  paymentMethod: string; paymentTerms: string; chartAccount: string; costCenter: string;
  periodicity: string; dueDay: string; nextDueDate: string; totalValue: string; active: boolean;
  autoSendBilling: boolean;
};

const emptyContractForm: ContractForm = {
  companyId: '', name: '', type: ContractType.HOURS_BANK,
  monthlyHours: '', monthlyFee: '', hourlyRate: '',
  startDate: '', endDate: '', notes: '',
  sellerName: '', salesChannel: '', storeName: '',
  paymentMethod: '', paymentTerms: '', chartAccount: '', costCenter: '',
  periodicity: '', dueDay: '', nextDueDate: '', totalValue: '', active: true,
  autoSendBilling: true,
};

// Opções de periodicidade da recorrência (rótulos em português). O valor armazenado
// é o próprio rótulo (a cadência de faturamento é mensal; este campo é descritivo).
const PERIODICITY_OPTIONS = [
  '1 mês', '2 meses', '3 meses', '6 meses', '1 ano', '2 anos', '3 anos',
];

// Converte valores legados/importados em inglês (ex.: "1 month", "12 months") para o
// rótulo em português equivalente, para casar com as opções do select. Mantém o valor
// original quando não reconhece o formato.
function normalizePeriodicity(raw?: string): string {
  const v = (raw ?? '').trim().toLowerCase();
  if (!v) return '';
  const m = /^(\d+)\s*(month|months|mes|meses|m[êe]s|year|years|ano|anos|a)$/i.exec(v);
  if (!m) return raw ?? '';
  const n = Number(m[1]);
  const unit = m[2];
  const isYear = /year|years|ano|anos|^a$/i.test(unit);
  if (isYear) return n === 1 ? '1 ano' : `${n} anos`;
  // Converte 12/24/36 meses em anos quando exato (melhor leitura).
  if (n % 12 === 0 && n >= 12) { const y = n / 12; return y === 1 ? '1 ano' : `${y} anos`; }
  return n === 1 ? '1 mês' : `${n} meses`;
}

function ContractsTab() {
  const toast = useToast();
  const { confirm } = useDialog();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [services, setServices] = useState<CommercialService[]>([]);
  const [items, setItems] = useState<Contract[]>([]);
  const [filter, setFilter] = useState(''); // busca instantânea por texto
  const [page, setPage] = useState(1); // página atual da lista
  const pageSize = 20; // contratos por página
  const [editing, setEditing] = useState<string | null>(null);
  // Contrato completo em edição (dá acesso ao payload de origem `raw` da GestãoClick).
  const [editingContract, setEditingContract] = useState<Contract | null>(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState<ContractForm>({ ...emptyContractForm });
  // Itens de serviço do contrato (editável: adicionar/remover).
  const [serviceItems, setServiceItems] = useState<ContractServiceItem[]>([]);
  // Itens de cobrança temporária (mês único): faturados uma vez e removidos depois.
  const [oneTimeItems, setOneTimeItems] = useState<OneTimeChargeItem[]>([]);

  const openNew = () => { setEditing(null); setEditingContract(null); setForm({ ...emptyContractForm }); setServiceItems([]); setOneTimeItems([]); setOpen(true); };
  const closeModal = () => { setOpen(false); setEditing(null); setEditingContract(null); setForm({ ...emptyContractForm }); setServiceItems([]); setOneTimeItems([]); };

  const load = () => api.get<Paginated<Contract>>('/contracts').then((r) => setItems(r.items)).catch(() => {});
  useEffect(() => {
    api.get<Paginated<Company>>('/companies').then((r) => setCompanies(r.items)).catch(() => {});
    api.get<Paginated<CommercialService>>('/services').then((r) => setServices(r.items)).catch(() => {});
    load();
  }, []);

  const companyName = (id: string) => companies.find((c) => c.id === id)?.name ?? id;

  // Soma dos itens de serviço (usada como sugestão do valor total).
  const itemsTotal = serviceItems.reduce((sum, it) => sum + (it.totalValue ?? 0), 0);

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const num = (v: string) => (v ? Number(v) : undefined);
      const payload = {
        companyId: form.companyId,
        name: form.name,
        type: form.type as ContractType,
        monthlyHours: num(form.monthlyHours),
        monthlyFee: num(form.monthlyFee),
        hourlyRate: num(form.hourlyRate),
        startDate: form.startDate || undefined,
        endDate: form.endDate || undefined,
        notes: form.notes || undefined,
        active: form.active,
        autoSendBilling: form.autoSendBilling,
        // Campos comerciais/financeiros estruturados.
        serviceItems,
        // Itens de cobrança temporária (mês único); id vazio deixa o backend gerar.
        oneTimeItems,
        sellerName: form.sellerName || undefined,
        salesChannel: form.salesChannel || undefined,
        storeName: form.storeName || undefined,
        paymentMethod: form.paymentMethod || undefined,
        paymentTerms: form.paymentTerms || undefined,
        chartAccount: form.chartAccount || undefined,
        costCenter: form.costCenter || undefined,
        periodicity: form.periodicity || undefined,
        dueDay: num(form.dueDay),
        nextDueDate: form.nextDueDate || undefined,
        totalValue: form.totalValue ? Number(form.totalValue) : (itemsTotal || undefined),
      };
      if (editing) await api.patch(`/contracts/${editing}`, payload);
      else await api.post('/contracts', payload);
      toast.success(editing ? 'Contrato atualizado' : 'Contrato criado');
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  const remove = async (c: Contract) => {
    if (!(await confirm({ title: 'Excluir contrato', message: `Remover "${c.name}"?`, confirmLabel: 'Excluir', danger: true }))) return;
    await api.delete(`/contracts/${c.id}`);
    toast.success('Contrato removido');
    if (editing === c.id) closeModal();
    load();
  };

  // Converte uma data ISO em "AAAA-MM-DD" para inputs date.
  const dateInput = (iso?: string) => (iso ? iso.slice(0, 10) : '');

  const edit = (c: Contract) => {
    setEditing(c.id);
    setEditingContract(c);
    setForm({
      companyId: c.companyId, name: c.name, type: c.type,
      monthlyHours: c.monthlyHours?.toString() ?? '', monthlyFee: c.monthlyFee?.toString() ?? '',
      hourlyRate: c.hourlyRate?.toString() ?? '', startDate: dateInput(c.startDate), endDate: dateInput(c.endDate),
      notes: c.notes ?? '',
      sellerName: c.sellerName ?? '', salesChannel: c.salesChannel ?? '', storeName: c.storeName ?? '',
      paymentMethod: c.paymentMethod ?? '', paymentTerms: c.paymentTerms ?? '',
      chartAccount: c.chartAccount ?? '', costCenter: c.costCenter ?? '',
      periodicity: c.periodicity ?? '', dueDay: c.dueDay?.toString() ?? '',
      // Quando há itens de serviço, o valor total passa a refletir a soma deles (mantém
      // o total sincronizado com os itens). Sem itens, preserva o totalValue salvo.
      nextDueDate: dateInput(c.nextDueDate),
      totalValue: (c.serviceItems && c.serviceItems.length)
        ? c.serviceItems.reduce((s, it) => s + (it.totalValue ?? 0), 0).toFixed(2)
        : (c.totalValue?.toString() ?? ''),
      active: c.active,
      autoSendBilling: c.autoSendBilling !== false,
    });
    setServiceItems(c.serviceItems ? c.serviceItems.map((it) => ({ ...it })) : []);
    setOneTimeItems(c.oneTimeItems ? c.oneTimeItems.map((it) => ({ ...it })) : []);
    setOpen(true);
  };

  // --- Editor de itens de serviço ---
  // Aplica a nova lista de itens E sincroniza o "Valor total" do contrato com a soma
  // dos itens — assim todo item adicionado/alterado/removido é refletido na seção
  // "Recorrência e faturamento" automaticamente.
  const applyServiceItems = (next: ContractServiceItem[]) => {
    setServiceItems(next);
    const sum = next.reduce((s, it) => s + (it.totalValue ?? 0), 0);
    setForm((f) => ({ ...f, totalValue: sum ? sum.toFixed(2) : '' }));
  };
  const addServiceItem = () => applyServiceItems([...serviceItems, { name: '', quantity: 1 }]);
  const removeServiceItem = (idx: number) => applyServiceItems(serviceItems.filter((_, i) => i !== idx));
  const updateServiceItem = (idx: number, patch: Partial<ContractServiceItem>) =>
    applyServiceItems(serviceItems.map((it, i) => {
      if (i !== idx) return it;
      const next = { ...it, ...patch };
      // Recalcula o total da linha quando quantidade/valor/desconto mudam.
      const qty = next.quantity ?? 0;
      const price = next.unitPrice ?? 0;
      const discount = next.discountValue ?? 0;
      next.totalValue = Math.max(0, qty * price - discount);
      return next;
    }));

  // --- Editor de itens de cobrança temporária (mês único) ---
  // Competência padrão: mês corrente no formato AAAA-MM.
  const currentCompetence = () => new Date().toISOString().slice(0, 7);
  const addOneTimeItem = () => setOneTimeItems((prev) => [...prev, { id: '', name: '', quantity: 1, competence: currentCompetence() }]);
  const removeOneTimeItem = (idx: number) => setOneTimeItems((prev) => prev.filter((_, i) => i !== idx));
  const updateOneTimeItem = (idx: number, patch: Partial<OneTimeChargeItem>) =>
    setOneTimeItems((prev) => prev.map((it, i) => {
      if (i !== idx) return it;
      const next = { ...it, ...patch };
      // Recalcula o total da linha quando quantidade/valor mudam.
      const qty = next.quantity ?? 0;
      const price = next.unitPrice ?? 0;
      next.totalValue = Math.max(0, qty * price);
      return next;
    }));

  // Soma dos itens de cobrança temporária (apenas informativo no editor).
  const oneTimeTotal = oneTimeItems.reduce((sum, it) => sum + (it.totalValue ?? 0), 0);


  // Rótulo da empresa: nome local quando associada; senão, o cliente de origem
  // (contrato importado ainda sem empresa vinculada no portal).
  const companyLabel = (c: Contract) => {
    if (c.companyId) return companyName(c.companyId);
    if (c.externalClientName) return `${c.externalClientName} (origem)`;
    return 'Sem empresa';
  };

  // Formata um valor em reais (ou "—").
  const fmtMoney = (v?: number) => (v == null ? '—' : v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));

  // Busca instantânea: filtra por nome, empresa, tipo, situação e código externo.
  const term = filter.trim().toLowerCase();
  const filtered = term
    ? items.filter((c) => {
        const haystack = [
          c.name,
          companyLabel(c),
          c.externalType ?? ContractTypeLabels[c.type],
          c.externalStatus ?? (c.active ? 'Ativo' : 'Inativo'),
          c.externalCode ?? '',
        ]
          .join(' ')
          .toLowerCase();
        return haystack.includes(term);
      })
    : items;

  const { sorted: sortedContracts, sort } = useSortable<Contract>(filtered, {
    name: (c) => c.name,
    company: (c) => companyLabel(c),
    type: (c) => c.externalType ?? ContractTypeLabels[c.type],
    status: (c) => c.externalStatus ?? (c.active ? 'Ativo' : 'Inativo'),
    value: (c) => c.totalValue ?? c.monthlyFee ?? -1,
  });

  // Paginação client-side sobre a lista filtrada/ordenada.
  const totalPages = Math.max(1, Math.ceil(sortedContracts.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pageStart = (currentPage - 1) * pageSize;
  const pageContracts = sortedContracts.slice(pageStart, pageStart + pageSize);
  // Volta para a primeira página quando o filtro muda o tamanho do resultado.
  useEffect(() => { setPage(1); }, [term]);

  return (
    <div>
      <div className="flex gap-2 items-end justify-between flex-wrap mb-3">
        <div className="field mb-0" style={{ flex: 1, maxWidth: 360 }}>
          <label className="label">Buscar contrato</label>
          <input className="input" value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="nome, empresa, tipo, situação ou código" />
        </div>
        <button className="btn btn-primary" onClick={openNew}>+ Novo contrato</button>
      </div>
      <div className="card card-flush">
        {sortedContracts.length === 0 ? (
          <div className="empty"><div className="empty-icon">📄</div>{items.length === 0 ? 'Nenhum contrato.' : 'Nenhum contrato encontrado para a busca.'}</div>
        ) : (
          <table className="table"><thead><tr>
            <SortableTh<Contract> field="name" sort={sort}>Contrato</SortableTh>
            <SortableTh<Contract> field="company" sort={sort}>Empresa</SortableTh>
            <SortableTh<Contract> field="type" sort={sort}>Tipo</SortableTh>
            <SortableTh<Contract> field="status" sort={sort}>Situação</SortableTh>
            <SortableTh<Contract> field="value" sort={sort}>Valor</SortableTh>
            <th></th>
          </tr></thead><tbody>
            {pageContracts.map((c) => (
              <tr key={c.id}>
                <td className="font-semibold">
                  {c.name}
                  {c.externalCode && <span className="text-dim text-xs" style={{ marginLeft: 6 }}>#{c.externalCode}</span>}
                  {!c.active && <span className="badge badge-closed" style={{ marginLeft: 6 }}>Inativo</span>}
                </td>
                <td className="text-muted text-sm">{companyLabel(c)}</td>
                <td><span className="badge badge-normal">{c.externalType ?? ContractTypeLabels[c.type]}</span></td>
                <td className="text-muted text-sm">{c.externalStatus ?? (c.active ? 'Ativo' : 'Inativo')}</td>
                <td className="text-muted text-sm">{fmtMoney(c.totalValue ?? c.monthlyFee)}</td>
                <td className="text-right">
                  <button className="btn btn-sm btn-ghost" onClick={() => edit(c)}>Editar</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => remove(c)}>Excluir</button>
                </td>
              </tr>
            ))}
          </tbody></table>
        )}
      </div>

      {/* Paginação (Início / Anterior / Próxima / Fim) sobre o resultado filtrado. */}
      {sortedContracts.length > pageSize && (
        <div className="flex items-center justify-between flex-wrap gap-2 mt-3">
          <span className="text-dim text-sm">
            Mostrando {pageStart + 1}–{Math.min(pageStart + pageSize, sortedContracts.length)} de {sortedContracts.length}
          </span>
          <div className="flex items-center gap-2">
            <button className="btn btn-sm btn-ghost" disabled={currentPage <= 1} onClick={() => setPage(1)} title="Primeira página">« Início</button>
            <button className="btn btn-sm btn-ghost" disabled={currentPage <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>‹ Anterior</button>
            <span className="text-sm">Página {currentPage} de {totalPages}</span>
            <button className="btn btn-sm btn-ghost" disabled={currentPage >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>Próxima ›</button>
            <button className="btn btn-sm btn-ghost" disabled={currentPage >= totalPages} onClick={() => setPage(totalPages)} title="Última página">Fim »</button>
          </div>
        </div>
      )}
      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? 'Editar contrato' : 'Novo contrato'}
        maxWidth={920}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="contract-form">{editing ? 'Salvar' : 'Adicionar'}</button>
          </>
        }
      >
        <form id="contract-form" onSubmit={save}>
          {/* Identificação */}
          <div>
            <h4 className="mb-2">📄 Identificação</h4>
            <div className="field-pair">
              <div className="field mb-0"><label className="label">Empresa</label>
                <select className="select" value={form.companyId} onChange={(e) => setForm({ ...form, companyId: e.target.value })}>
                  <option value="">Sem empresa (associar depois)</option>
                  {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div className="field mb-0"><label className="label">Tipo</label>
                <select className="select" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                  {Object.entries(ContractTypeLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
            </div>
            <div className="field mb-0 mt-3"><label className="label">Nome do contrato</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          </div>

          {/* Itens de serviço (editável) */}
          <div className="mt-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <div className="flex items-center justify-between mb-2">
              <h4 className="mb-0">🧾 Serviços do contrato</h4>
              <button type="button" className="btn btn-sm btn-secondary" onClick={addServiceItem}>+ Adicionar serviço</button>
            </div>
            {serviceItems.length === 0 ? (
              <div className="text-dim text-xs">Nenhum serviço. Clique em “Adicionar serviço” para incluir itens faturáveis.</div>
            ) : (
              <div className="flex flex-col gap-2">
                {serviceItems.map((it, idx) => (
                  <div key={idx} className="card" style={{ padding: 'var(--s3)', background: 'var(--surface-2)' }}>
                    <div className="flex items-center justify-between mb-2">
                      <span className="badge badge-closed text-xs">Item {idx + 1}</span>
                      <button type="button" className="btn btn-sm btn-ghost" onClick={() => removeServiceItem(idx)}>Remover</button>
                    </div>
                    <div className="field-pair">
                      <div className="field mb-0">
                        <label className="label" style={{ fontSize: 11 }}>Serviço cadastrado</label>
                        <ServiceCombobox
                          services={services}
                          value={it.serviceId}
                          onSelect={(svc) => {
                            if (!svc) { updateServiceItem(idx, { serviceId: undefined }); return; }
                            updateServiceItem(idx, { serviceId: svc.id, name: svc.name, unitPrice: svc.salePrice ?? 0 });
                          }}
                          onServiceCreated={(svc) => setServices((prev) => [...prev, svc])}
                        />
                      </div>
                      <div className="field mb-0">
                        <label className="label" style={{ fontSize: 11 }}>Descrição</label>
                        <input className="input" value={it.name} onChange={(e) => updateServiceItem(idx, { name: e.target.value })} placeholder="Nome do serviço" />
                      </div>
                    </div>
                    <div className="field-pair mt-2">
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Qtd.</label><input className="input" type="number" min="0" step="0.01" value={it.quantity ?? ''} onChange={(e) => updateServiceItem(idx, { quantity: e.target.value ? Number(e.target.value) : undefined })} /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Valor unit. (R$)</label><input className="input" type="number" min="0" step="0.01" value={it.unitPrice ?? ''} onChange={(e) => updateServiceItem(idx, { unitPrice: e.target.value ? Number(e.target.value) : undefined })} /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Desconto (R$)</label><input className="input" type="number" min="0" step="0.01" value={it.discountValue ?? ''} onChange={(e) => updateServiceItem(idx, { discountValue: e.target.value ? Number(e.target.value) : undefined })} /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Total (R$)</label><input className="input" type="number" value={it.totalValue?.toFixed(2) ?? ''} readOnly style={{ background: 'var(--surface-3)' }} /></div>
                    </div>
                  </div>
                ))}
                <div className="flex justify-end text-sm" style={{ fontWeight: 600 }}>
                  Soma dos serviços: {itemsTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </div>
              </div>
            )}
          </div>

          {/* Cobrança temporária (mês único) — itens one-shot/virada de mês */}
          <div className="mt-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <div className="flex items-center justify-between mb-2">
              <h4 className="mb-0">⏳ Cobrança temporária (mês único)</h4>
              <button type="button" className="btn btn-sm btn-secondary" onClick={addOneTimeItem}>+ Adicionar item</button>
            </div>
            <div className="text-dim text-xs mb-2">
              Itens avulsos cobrados apenas no faturamento da competência-alvo (padrão: mês corrente).
              Após a emissão da cobrança eles são removidos automaticamente, não indo para o próximo mês.
            </div>
            {oneTimeItems.length === 0 ? (
              <div className="text-dim text-xs">Nenhum item temporário. Clique em “Adicionar item” para incluir uma cobrança avulsa deste mês.</div>
            ) : (
              <div className="flex flex-col gap-2">
                {oneTimeItems.map((it, idx) => (
                  <div key={idx} className="card" style={{ padding: 'var(--s3)', background: 'var(--surface-2)' }}>
                    <div className="flex items-center justify-between mb-2">
                      <span className="badge badge-closed text-xs">Item {idx + 1}</span>
                      <button type="button" className="btn btn-sm btn-ghost" onClick={() => removeOneTimeItem(idx)}>Remover</button>
                    </div>
                    <div className="field mb-0">
                      <label className="label" style={{ fontSize: 11 }}>Descrição</label>
                      <input className="input" value={it.name} onChange={(e) => updateOneTimeItem(idx, { name: e.target.value })} placeholder="Ex.: Serviço avulso de outubro" />
                    </div>
                    <div className="field-pair mt-2">
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Qtd.</label><input className="input" type="number" min="0" step="0.01" value={it.quantity ?? ''} onChange={(e) => updateOneTimeItem(idx, { quantity: e.target.value ? Number(e.target.value) : undefined })} /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Valor unit. (R$)</label><input className="input" type="number" min="0" step="0.01" value={it.unitPrice ?? ''} onChange={(e) => updateOneTimeItem(idx, { unitPrice: e.target.value ? Number(e.target.value) : undefined })} /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Total (R$)</label><input className="input" type="number" value={it.totalValue?.toFixed(2) ?? ''} readOnly style={{ background: 'var(--surface-3)' }} /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Competência-alvo</label><input className="input" type="month" value={it.competence ?? ''} onChange={(e) => updateOneTimeItem(idx, { competence: e.target.value || undefined })} /></div>
                    </div>
                  </div>
                ))}
                <div className="flex justify-end text-sm" style={{ fontWeight: 600 }}>
                  Soma dos itens temporários: {oneTimeTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </div>
              </div>
            )}
          </div>

          {/* Recorrência e faturamento */}
          <div className="mt-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">💰 Recorrência e faturamento</h4>
            <div className="field-pair">
              <div className="field mb-0"><label className="label">Valor total (R$)</label><input className="input" type="number" min="0" step="0.01" value={form.totalValue} onChange={(e) => setForm({ ...form, totalValue: e.target.value })} placeholder={itemsTotal ? itemsTotal.toFixed(2) : ''} /></div>
              <div className="field mb-0"><label className="label">Mensalidade (R$)</label><input className="input" type="number" min="0" step="0.01" value={form.monthlyFee} onChange={(e) => setForm({ ...form, monthlyFee: e.target.value })} /></div>
            </div>
            <div className="field-pair mt-3">
              <div className="field mb-0">
                <label className="label">Periodicidade</label>
                <select className="select" value={normalizePeriodicity(form.periodicity)} onChange={(e) => setForm({ ...form, periodicity: e.target.value })}>
                  <option value="">—</option>
                  {PERIODICITY_OPTIONS.map((p) => <option key={p} value={p}>{p}</option>)}
                  {/* Preserva valor legado/importado fora da lista (ex.: "1 month") para não perdê-lo na edição. */}
                  {form.periodicity && !PERIODICITY_OPTIONS.includes(normalizePeriodicity(form.periodicity)) && (
                    <option value={form.periodicity}>{form.periodicity}</option>
                  )}
                </select>
              </div>
              <div className="field mb-0"><label className="label">Dia de vencimento</label><input className="input" type="number" min="1" max="31" value={form.dueDay} onChange={(e) => setForm({ ...form, dueDay: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Próxima emissão</label><input className="input" type="date" value={form.nextDueDate} onChange={(e) => setForm({ ...form, nextDueDate: e.target.value })} /></div>
            </div>
            <div className="field-pair mt-3">
              <div className="field mb-0"><label className="label">Forma de pagamento</label><input className="input" value={form.paymentMethod} onChange={(e) => setForm({ ...form, paymentMethod: e.target.value })} placeholder="ex.: Boleto, Cartão" /></div>
              <div className="field mb-0"><label className="label">Condição de pagamento</label><input className="input" value={form.paymentTerms} onChange={(e) => setForm({ ...form, paymentTerms: e.target.value })} /></div>
            </div>
            <div className="field-pair mt-3">
              <div className="field mb-0"><label className="label">Plano de contas</label><input className="input" value={form.chartAccount} onChange={(e) => setForm({ ...form, chartAccount: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Centro de custo</label><input className="input" value={form.costCenter} onChange={(e) => setForm({ ...form, costCenter: e.target.value })} /></div>
            </div>
          </div>

          {/* Banco de horas (suporte) */}
          <div className="mt-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">⏱ Suporte (banco de horas)</h4>
            <div className="field-pair">
              <div className="field mb-0"><label className="label">Horas/mês</label><input className="input" type="number" min="0" value={form.monthlyHours} onChange={(e) => setForm({ ...form, monthlyHours: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Hora excedente (R$)</label><input className="input" type="number" min="0" step="0.01" value={form.hourlyRate} onChange={(e) => setForm({ ...form, hourlyRate: e.target.value })} /></div>
            </div>
          </div>

          {/* Comercial e vigência */}
          <div className="mt-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">📇 Comercial e vigência</h4>
            <div className="field-pair">
              <div className="field mb-0"><label className="label">Vendedor</label><input className="input" value={form.sellerName} onChange={(e) => setForm({ ...form, sellerName: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Canal de venda</label><input className="input" value={form.salesChannel} onChange={(e) => setForm({ ...form, salesChannel: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Loja</label><input className="input" value={form.storeName} onChange={(e) => setForm({ ...form, storeName: e.target.value })} /></div>
            </div>
            <div className="field-pair mt-3">
              <div className="field mb-0"><label className="label">Início da vigência</label><input className="input" type="date" value={form.startDate} onChange={(e) => setForm({ ...form, startDate: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Fim da vigência</label><input className="input" type="date" value={form.endDate} onChange={(e) => setForm({ ...form, endDate: e.target.value })} /></div>
            </div>
            <label className="flex items-center gap-2 field mb-0 mt-3" style={{ cursor: 'pointer' }}>
              <input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} /> Contrato ativo
            </label>
            <label className="flex items-center gap-2 field mb-0 mt-2" style={{ cursor: 'pointer' }} title="Enviar o e-mail de cobrança ao cliente automaticamente quando a fatura recorrente for emitida.">
              <input type="checkbox" checked={form.autoSendBilling} onChange={(e) => setForm({ ...form, autoSendBilling: e.target.checked })} /> Enviar cobrança por e-mail automaticamente
            </label>
          </div>

          {/* Observações */}
          <div className="mt-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">📝 Observações</h4>
            <div className="field mb-0"><label className="label">Anotações internas</label><textarea className="textarea" rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></div>
          </div>
        </form>

        {editingContract?.raw && <GestaoClickContractDetails raw={editingContract.raw} />}
      </Modal>
    </div>
  );
}

// Painel de detalhes de origem (GestãoClick): mostra TODOS os campos do contrato
// exatamente como vieram da API — escalares como pares rótulo/valor e as listas
// (serviços, produtos, pagamentos, histórico) como tabelas. Somente leitura.
function GestaoClickContractDetails({ raw }: { raw: Record<string, unknown> }) {
  // Separa campos escalares (string/número) das listas (arrays).
  const scalarEntries: [string, string][] = [];
  const arrayEntries: [string, unknown[]][] = [];
  for (const [key, value] of Object.entries(raw)) {
    if (Array.isArray(value)) {
      arrayEntries.push([key, value]);
    } else if (value != null && value !== '' && typeof value !== 'object') {
      scalarEntries.push([key, String(value)]);
    }
  }

  // Rótulos amigáveis para os campos mais relevantes (os demais usam a própria chave).
  const LABELS: Record<string, string> = {
    codigo: 'Código', tipo: 'Tipo', nome_cliente: 'Cliente', nome_vendedor: 'Vendedor',
    nome_canal_venda: 'Canal de venda', nome_loja: 'Loja', nome_situacao: 'Situação',
    nome_centro_custo: 'Centro de custo', nome_plano_conta: 'Plano de contas',
    condicao_pagamento: 'Condição de pagamento', nome_forma_pagamento: 'Forma de pagamento',
    valor_produtos: 'Valor produtos', acrescimo: 'Acréscimo', desconto_valor: 'Desconto (R$)',
    desconto_porcentagem: 'Desconto (%)', valor_frete: 'Frete', valor_total: 'Valor total',
    observacoes: 'Observações', observacoes_fatura: 'Observações da fatura',
    cadastrado_em: 'Cadastrado em', modificado_em: 'Modificado em', data: 'Data do contrato',
    periodicidade: 'Periodicidade', dia_vencimento: 'Dia de vencimento',
    proximo_vencimento: 'Próxima emissão/vencimento', gerar_recebimento: 'Gerar recebimento',
    nome_plano: 'Plano', data_entrega: 'Data de entrega', data_retirada: 'Data de retirada',
    vigencia_locacao: 'Vigência da locação', tipo_periodo_locacao: 'Tipo de período (locação)',
  };
  const ARRAY_LABELS: Record<string, string> = {
    servicos: 'Serviços', produtos: 'Produtos', pagamentos: 'Pagamentos',
    historico: 'Histórico', atributos: 'Atributos', anexos: 'Anexos',
  };
  const label = (k: string) => LABELS[k] ?? k;

  return (
    <div className="mt-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
      <h4 className="mb-2">📋 Dados da GestãoClick (origem)</h4>
      <div className="text-dim text-xs mb-3">Campos importados exatamente como vieram da API. Somente leitura.</div>

      <div className="field-pair">
        {scalarEntries.map(([k, v]) => (
          <div key={k} className="field mb-0">
            <label className="label" style={{ fontSize: 11 }}>{label(k)}</label>
            <div className="text-sm" style={{ wordBreak: 'break-word' }}>{v}</div>
          </div>
        ))}
      </div>

      {arrayEntries.map(([k, list]) => (
        <div key={k} className="mt-3">
          <div className="label" style={{ fontSize: 11 }}>{ARRAY_LABELS[k] ?? k} ({list.length})</div>
          {list.length === 0 ? (
            <div className="text-dim text-xs">Nenhum item.</div>
          ) : (
            <GestaoClickList items={list} />
          )}
        </div>
      ))}
    </div>
  );
}

// Renderiza uma lista de itens da GestãoClick como tabela. Cada item pode ser um
// objeto simples ou vir aninhado em uma única chave (ex.: { servico: {...} }).
function GestaoClickList({ items }: { items: unknown[] }) {
  // Normaliza cada item para um objeto plano (desembrulha { servico: {...} } etc.).
  const rows = items.map((item) => {
    if (item && typeof item === 'object' && !Array.isArray(item)) {
      const values = Object.values(item as Record<string, unknown>);
      // Item com uma única chave-objeto (padrão da API): usa o objeto interno.
      if (values.length === 1 && values[0] && typeof values[0] === 'object') {
        return values[0] as Record<string, unknown>;
      }
      return item as Record<string, unknown>;
    }
    return { valor: String(item) };
  });
  // Colunas = união das chaves (mantém campos vazios para ficar "igual" à origem).
  const columns = Array.from(new Set(rows.flatMap((r) => Object.keys(r))));

  return (
    <div style={{ overflowX: 'auto' }}>
      <table className="table" style={{ fontSize: 12 }}>
        <thead>
          <tr>{columns.map((col) => <th key={col}>{col}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              {columns.map((col) => {
                const cell = r[col];
                const text = cell == null || typeof cell === 'object' ? (cell == null ? '' : JSON.stringify(cell)) : String(cell);
                return <td key={col}>{text}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Rótulos de situação do orçamento.
const QUOTE_STATUS_LABELS: Record<string, string> = {
  draft: 'Rascunho', ready: 'Pronto', sent: 'Enviado', signed: 'Assinado', declined: 'Recusado', canceled: 'Cancelado', expired: 'Expirado',
};

// Formulário do orçamento (strings para inputs; listas à parte).
type QuoteFormState = {
  title: string; companyId: string;
  clientName: string; clientDocument: string; clientAddress: string; clientBillingEmail: string;
  scope: string; slaAvailability: string; slaWindow: string;
  termMonths: string; adhesionDate: string; autoRenew: boolean;
  billingIssueDay: string; billingDueDay: string; jurisdiction: string; notes: string;
  signatureDeadlineDays: string; // prazo de assinatura em dias (vazio = padrão do sistema)
};

const emptyQuoteForm: QuoteFormState = {
  title: '', companyId: '',
  clientName: '', clientDocument: '', clientAddress: '', clientBillingEmail: '',
  scope: '', slaAvailability: '99,5%', slaWindow: 'segunda a sexta-feira, das 08h00 às 18h00',
  termMonths: '12', adhesionDate: '', autoRenew: true,
  billingIssueDay: '1', billingDueDay: '10', jurisdiction: 'Ribeirão Pires - SP', notes: '',
  signatureDeadlineDays: '',
};

// Aba de Orçamento: monta propostas/contratos a partir da minuta Makweb, gera o PDF
// e (na Fase 3) envia para assinatura eletrônica. Formulário seccionado + preview.
function QuotesTab() {
  const toast = useToast();
  const { confirm } = useDialog();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [services, setServices] = useState<CommercialService[]>([]);
  const [items, setItems] = useState<Quote[]>([]);
  const [editing, setEditing] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState<QuoteFormState>({ ...emptyQuoteForm });
  const [setupItems, setSetupItems] = useState<QuoteLineItem[]>([]);
  const [monthlyItems, setMonthlyItems] = useState<QuoteLineItem[]>([]);
  const [signers, setSigners] = useState<QuoteSigner[]>([]);

  const load = () => api.get<Paginated<Quote>>('/quotes').then((r) => setItems(r.items)).catch(() => {});
  useEffect(() => {
    api.get<Paginated<Company>>('/companies').then((r) => setCompanies(r.items)).catch(() => {});
    api.get<Paginated<CommercialService>>('/services').then((r) => setServices(r.items)).catch(() => {});
    load();
  }, []);

  const openNew = () => {
    setEditing(null); setForm({ ...emptyQuoteForm }); setSetupItems([]); setMonthlyItems([]);
    setSigners([{ name: '', email: '', role: 'Contratante', order: 1 }]);
    setOpen(true);
  };
  const closeModal = () => {
    setOpen(false); setEditing(null); setForm({ ...emptyQuoteForm });
    setSetupItems([]); setMonthlyItems([]); setSigners([]);
  };

  const dateInput = (iso?: string) => (iso ? iso.slice(0, 10) : '');

  const edit = (q: Quote) => {
    setEditing(q.id);
    setForm({
      title: q.title, companyId: q.companyId ?? '',
      clientName: q.clientName, clientDocument: q.clientDocument ?? '', clientAddress: q.clientAddress ?? '',
      clientBillingEmail: q.clientBillingEmail ?? '',
      scope: q.scope ?? '', slaAvailability: q.slaAvailability ?? '', slaWindow: q.slaWindow ?? '',
      termMonths: q.termMonths?.toString() ?? '', adhesionDate: dateInput(q.adhesionDate), autoRenew: q.autoRenew ?? true,
      billingIssueDay: q.billingIssueDay?.toString() ?? '', billingDueDay: q.billingDueDay?.toString() ?? '',
      jurisdiction: q.jurisdiction ?? '', notes: q.notes ?? '',
      signatureDeadlineDays: q.signatureDeadlineDays?.toString() ?? '',
    });
    setSetupItems(q.setupItems ? q.setupItems.map((it) => ({ ...it })) : []);
    setMonthlyItems(q.monthlyItems ? q.monthlyItems.map((it) => ({ ...it })) : []);
    setSigners(q.signers ? q.signers.map((s) => ({ ...s })) : []);
    setOpen(true);
  };

  // Preenche a empresa a partir do cadastro (autopreenche contratante).
  const pickCompany = (companyId: string) => {
    const c = companies.find((x) => x.id === companyId);
    setForm((prev) => ({
      ...prev,
      companyId,
      clientName: c?.name ?? prev.clientName,
      clientDocument: c?.document ?? prev.clientDocument,
      clientAddress: c ? [c.street, c.number, c.neighborhood, c.city, c.state, c.cep].filter(Boolean).join(', ') : prev.clientAddress,
    }));
  };

  const num = (v: string) => (v ? Number(v) : undefined);
  const buildPayload = () => ({
    title: form.title,
    companyId: form.companyId || undefined,
    clientName: form.clientName,
    clientDocument: form.clientDocument || undefined,
    clientAddress: form.clientAddress || undefined,
    clientBillingEmail: form.clientBillingEmail || undefined,
    scope: form.scope || undefined,
    slaAvailability: form.slaAvailability || undefined,
    slaWindow: form.slaWindow || undefined,
    termMonths: num(form.termMonths),
    adhesionDate: form.adhesionDate || undefined,
    autoRenew: form.autoRenew,
    billingIssueDay: num(form.billingIssueDay),
    billingDueDay: num(form.billingDueDay),
    jurisdiction: form.jurisdiction || undefined,
    notes: form.notes || undefined,
    signatureDeadlineDays: num(form.signatureDeadlineDays),
    setupItems,
    monthlyItems,
    signers: signers.filter((s) => s.name || s.email),
  });

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const payload = buildPayload();
      if (editing) await api.patch(`/quotes/${editing}`, payload);
      else await api.post('/quotes', payload);
      toast.success(editing ? 'Orçamento atualizado' : 'Orçamento criado');
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  const remove = async (q: Quote) => {
    if (!(await confirm({ title: 'Excluir orçamento', message: `Remover "${q.title}"?`, confirmLabel: 'Excluir', danger: true }))) return;
    await api.delete(`/quotes/${q.id}`);
    toast.success('Orçamento removido');
    if (editing === q.id) closeModal();
    load();
  };

  // Gera e baixa o PDF a partir do orçamento (pré-visualização local).
  const downloadPdf = async (q: Quote) => {
    try { await generateContractPdf(q); } catch (err) { toast.error(err instanceof Error ? err.message : 'Falha ao gerar PDF'); }
  };

  // Visualiza o contrato numa janela ao lado. Se o orçamento já foi enviado para
  // assinatura, abre o PDF oficial arquivado (streaming autenticado, sem expor o S3);
  // caso contrário, gera a prévia local.
  const [viewingId, setViewingId] = useState<string | null>(null);
  const viewContract = async (q: Quote) => {
    setViewingId(q.id);
    try {
      if (q.status === 'draft' || q.status === 'ready') {
        await generateContractPdf(q);
        return;
      }
      // Busca o PDF oficial via API autenticada e abre como blob (sem URL do S3).
      const token = await getToken();
      const res = await fetch(`${config.apiUrl}/quotes/${q.id}/document`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error('Não foi possível carregar o documento.');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener,noreferrer');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao abrir o contrato');
    } finally {
      setViewingId(null);
    }
  };

  // Reenvia o e-mail de assinatura aos signatários pendentes.
  const [resendingId, setResendingId] = useState<string | null>(null);
  const resendEmail = async (q: Quote) => {
    setResendingId(q.id);
    try {
      const r = await api.post<{ resent: number }>(`/quotes/${q.id}/resend-signature`, {});
      toast.success(`E-mail reenviado para ${r.resent} signatário(s) pendente(s)`);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao reenviar e-mail');
    } finally {
      setResendingId(null);
    }
  };

  // Status de assinatura (quem visualizou, assinou ou recusou) — painel de acompanhamento.
  type SignRecipientView = { name: string; email: string; role?: string; state: string; viewedAt?: string; signedAt?: string; declinedAt?: string; declineReason?: string; ip?: string; userAgent?: string };
  type SignReqView = { status: string; recipients: SignRecipientView[]; expiresAt?: string } | null;
  const [signStatus, setSignStatus] = useState<SignReqView>(null);
  const [signStatusTitle, setSignStatusTitle] = useState('');
  const [signStatusOpen, setSignStatusOpen] = useState(false);
  // Guarda o id do orçamento aberto no painel para a chamada de reemissão.
  const [signStatusQuoteId, setSignStatusQuoteId] = useState<string | null>(null);
  const openSignatureStatus = async (q: Quote) => {
    setSignStatusTitle(q.title);
    setSignStatusQuoteId(q.id);
    setSignStatus(null);
    setSignStatusOpen(true);
    try {
      const r = await api.get<SignReqView>(`/quotes/${q.id}/signature`);
      setSignStatus(r);
    } catch {
      setSignStatus({ status: 'none', recipients: [] });
    }
  };

  // Reemite a assinatura (recalcula o vencimento e reenvia os convites pendentes).
  const [reissuingId, setReissuingId] = useState<string | null>(null);
  const reissueSignature = async (q: Quote) => {
    if (!(await confirm({
      title: 'Reemitir assinatura',
      message: `O prazo de assinatura do contrato "${q.title}" será renovado e os convites serão reenviados aos signatários pendentes. Continuar?`,
      confirmLabel: 'Reemitir',
    }))) return;
    setReissuingId(q.id);
    try {
      // Reaproveita o prazo definido no orçamento; se vazio, o backend usa o padrão SSM.
      const deadlineDays = q.signatureDeadlineDays;
      await api.post(`/quotes/${q.id}/reissue-signature`, deadlineDays ? { deadlineDays } : {});
      toast.success('Assinatura reemitida');
      load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao reemitir assinatura');
    } finally {
      setReissuingId(null);
    }
  };

  // Prévia/resumo do orçamento (visualização + envio por e-mail para análise).
  const [previewQuote, setPreviewQuote] = useState<Quote | null>(null);
  const [previewEmail, setPreviewEmail] = useState('');
  const [sendingPreview, setSendingPreview] = useState(false);
  const openPreview = (q: Quote) => { setPreviewQuote(q); setPreviewEmail(q.clientBillingEmail ?? ''); };
  const sendPreview = async () => {
    if (!previewQuote) return;
    setSendingPreview(true);
    try {
      const r = await api.post<{ sentTo: string }>(`/quotes/${previewQuote.id}/send-preview`, { to: previewEmail || undefined });
      toast.success(`Prévia enviada para ${r.sentTo}`);
      setPreviewQuote(null);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao enviar prévia');
    } finally {
      setSendingPreview(false);
    }
  };

  // Envia o orçamento para assinatura eletrônica (gera PDF no servidor, arquiva no
  // S3 e dispara os e-mails aos signatários).
  const [sendingSign, setSendingSign] = useState<string | null>(null);
  const sendForSignature = async (q: Quote) => {
    const signers = (q.signers ?? []).filter((s) => s.name && s.email);
    if (signers.length === 0) {
      toast.error('Adicione ao menos um signatário com nome e e-mail antes de enviar.');
      return;
    }
    const names = signers.map((s) => `${s.name} (${s.email})`).join(', ');
    if (!(await confirm({
      title: 'Enviar para assinatura',
      message: `O contrato "${q.title}" será enviado por e-mail para: ${names}. Continuar?`,
      confirmLabel: 'Enviar',
    }))) return;
    setSendingSign(q.id);
    try {
      await api.post(`/quotes/${q.id}/send-signature`, {});
      toast.success('Contrato enviado para assinatura');
      load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao enviar para assinatura');
    } finally {
      setSendingSign(null);
    }
  };

  // --- Editor de linhas do Anexo I ---
  const lineTotal = (it: QuoteLineItem) => (it.unitPrice ?? 0) * (it.quantity ?? 0);
  const addLine = (setter: Dispatch<SetStateAction<QuoteLineItem[]>>) =>
    setter((prev) => [...prev, { description: '', quantity: 1, unitPrice: 0, totalValue: 0 }]);
  const updateLine = (
    setter: Dispatch<SetStateAction<QuoteLineItem[]>>,
    idx: number,
    patch: Partial<QuoteLineItem>,
  ) => setter((prev) => prev.map((it, i) => {
    if (i !== idx) return it;
    const next = { ...it, ...patch };
    next.totalValue = lineTotal(next);
    return next;
  }));
  const removeLine = (setter: Dispatch<SetStateAction<QuoteLineItem[]>>, idx: number) =>
    setter((prev) => prev.filter((_, i) => i !== idx));

  // --- Editor de signatários ---
  const addSigner = () => setSigners((prev) => [...prev, { name: '', email: '', role: 'Signatário', order: prev.length + 1 }]);
  const updateSigner = (idx: number, patch: Partial<QuoteSigner>) =>
    setSigners((prev) => prev.map((s, i) => (i === idx ? { ...s, ...patch } : s)));
  const removeSigner = (idx: number) => setSigners((prev) => prev.filter((_, i) => i !== idx));

  const setupTotal = setupItems.reduce((s, it) => s + (it.totalValue ?? lineTotal(it)), 0);
  const monthlyTotal = monthlyItems.reduce((s, it) => s + (it.totalValue ?? lineTotal(it)), 0);
  const money = (v?: number) => (v ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const { sorted, sort } = useSortable<Quote>(items, {
    number: (q) => q.number,
    title: (q) => q.title,
    client: (q) => q.clientName,
    status: (q) => QUOTE_STATUS_LABELS[q.status] ?? q.status,
    monthly: (q) => q.monthlyTotal ?? -1,
  });

  // Linhas de itens reutilizáveis (adesão/mensalidade).
  const renderLines = (
    heading: string,
    list: QuoteLineItem[],
    setter: Dispatch<SetStateAction<QuoteLineItem[]>>,
    total: number,
    totalLabel: string,
  ) => (
    <div className="mt-3">
      <div className="flex items-center justify-between mb-2">
        <strong style={{ fontSize: 13 }}>{heading}</strong>
        <button type="button" className="btn btn-sm btn-secondary" onClick={() => addLine(setter)}>+ Adicionar linha</button>
      </div>
      {list.length === 0 ? (
        <div className="text-dim text-xs">Nenhuma linha.</div>
      ) : (
        <div className="flex flex-col gap-2">
          {list.map((it, idx) => (
            <div key={idx} className="card" style={{ padding: 'var(--s3)', background: 'var(--surface-2)' }}>
              <div className="field-pair">
                <div className="field mb-0">
                  <label className="label" style={{ fontSize: 11 }}>Serviço</label>
                  <ServiceCombobox
                    services={services}
                    value={it.serviceId}
                    onSelect={(svc) => {
                      if (!svc) { updateLine(setter, idx, { serviceId: undefined }); return; }
                      updateLine(setter, idx, { serviceId: svc.id, description: svc.name, unitPrice: svc.salePrice ?? 0 });
                    }}
                    onServiceCreated={(svc) => setServices((prev) => [...prev, svc])}
                  />
                </div>
                <div className="field mb-0">
                  <label className="label" style={{ fontSize: 11 }}>Descrição</label>
                  <input className="input" value={it.description} onChange={(e) => updateLine(setter, idx, { description: e.target.value })} />
                </div>
              </div>
              <div className="field-pair mt-2">
                <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Unitário R$</label><input className="input" type="number" min="0" step="0.01" value={it.unitPrice ?? ''} onChange={(e) => updateLine(setter, idx, { unitPrice: e.target.value ? Number(e.target.value) : undefined })} /></div>
                <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Qtd.</label><input className="input" type="number" min="0" step="0.01" value={it.quantity ?? ''} onChange={(e) => updateLine(setter, idx, { quantity: e.target.value ? Number(e.target.value) : undefined })} /></div>
                <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Total R$</label><input className="input" value={money(it.totalValue)} readOnly style={{ background: 'var(--surface-3)' }} /></div>
              </div>
              <div className="flex justify-end mt-2"><button type="button" className="btn btn-sm btn-ghost" onClick={() => removeLine(setter, idx)}>Remover</button></div>
            </div>
          ))}
          <div className="flex justify-end text-sm" style={{ fontWeight: 600 }}>{totalLabel}: {money(total)}</div>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button className="btn btn-primary" onClick={openNew}>+ Novo orçamento</button>
      </div>
      <div className="card card-flush">
        {items.length === 0 ? (
          <div className="empty"><div className="empty-icon">📝</div>Nenhum orçamento. Crie o primeiro para gerar um contrato.</div>
        ) : (
          <table className="table"><thead><tr>
            <SortableTh<Quote> field="number" sort={sort}>Nº</SortableTh>
            <SortableTh<Quote> field="title" sort={sort}>Título</SortableTh>
            <SortableTh<Quote> field="client" sort={sort}>Contratante</SortableTh>
            <SortableTh<Quote> field="status" sort={sort}>Situação</SortableTh>
            <SortableTh<Quote> field="monthly" sort={sort}>Mensal</SortableTh>
            <th></th>
          </tr></thead><tbody>
            {sorted.map((q) => (
              <tr key={q.id}>
                <td className="text-muted text-sm">#{q.number}</td>
                <td className="font-semibold">{q.title}</td>
                <td className="text-muted text-sm">{q.clientName}</td>
                <td><span className="badge badge-normal">{QUOTE_STATUS_LABELS[q.status] ?? q.status}</span></td>
                <td className="text-muted text-sm">{money(q.monthlyTotal)}</td>
                <td className="text-right" style={{ whiteSpace: 'nowrap' }}>
                  <button className="btn btn-sm btn-ghost" onClick={() => openPreview(q)} title="Prévia / resumo para análise">📋 Prévia</button>
                  <button className="btn btn-sm btn-ghost" disabled={viewingId === q.id} onClick={() => viewContract(q)} title={q.status === 'signed' ? 'Ver contrato assinado' : 'Visualizar contrato'}>
                    {viewingId === q.id ? '...' : (q.status === 'signed' ? '✅ Assinado' : '👁 Ver')}
                  </button>
                  <button className="btn btn-sm btn-ghost" onClick={() => downloadPdf(q)} title="Baixar contrato em PDF">📄 PDF</button>
                  {q.status !== 'signed' && (
                    <button className="btn btn-sm btn-ghost" disabled={sendingSign === q.id} onClick={() => sendForSignature(q)} title="Enviar para assinatura eletrônica">
                      {sendingSign === q.id ? 'Enviando...' : '✍️ Assinar'}
                    </button>
                  )}
                  {(q.status === 'sent' || q.status === 'signed' || q.status === 'declined') && (
                    <button className="btn btn-sm btn-ghost" onClick={() => openSignatureStatus(q)} title="Status das assinaturas">📊 Status</button>
                  )}
                  {(q.status === 'sent') && (
                    <button className="btn btn-sm btn-ghost" disabled={resendingId === q.id} onClick={() => resendEmail(q)} title="Reenviar e-mail de assinatura">
                      {resendingId === q.id ? '...' : '✉️ Reenviar'}
                    </button>
                  )}
                  {(q.status === 'expired') && (
                    <button className="btn btn-sm btn-ghost" disabled={reissuingId === q.id} onClick={() => reissueSignature(q)} title="Reemitir assinatura (renova o prazo e reenvia os convites)">
                      {reissuingId === q.id ? '...' : '🔄 Reemitir'}
                    </button>
                  )}
                  <button className="btn btn-sm btn-ghost" onClick={() => edit(q)}>Editar</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => remove(q)}>Excluir</button>
                </td>
              </tr>
            ))}
          </tbody></table>
        )}
      </div>

      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? `Editar orçamento` : 'Novo orçamento'}
        maxWidth={860}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            {editing && <button className="btn btn-secondary" type="button" onClick={() => { const q = items.find((x) => x.id === editing); if (q) downloadPdf(q); }}>📄 Baixar PDF</button>}
            <button className="btn btn-primary" type="submit" form="quote-form">{editing ? 'Salvar' : 'Criar'}</button>
          </>
        }
      >
        <form id="quote-form" onSubmit={save}>
          {/* Identificação */}
          <div className="field"><label className="label">Título interno da proposta</label><input className="input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="ex.: Proposta Globalfood 2026" required /></div>

          {/* Contratante */}
          <div className="mt-3" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">🏢 Contratante</h4>
            <div className="field"><label className="label">Empresa cadastrada (autopreenche)</label>
              <select className="select" value={form.companyId} onChange={(e) => pickCompany(e.target.value)}>
                <option value="">— preencher manualmente —</option>
                {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="field mt-2"><label className="label">Razão social</label><input className="input" value={form.clientName} onChange={(e) => setForm({ ...form, clientName: e.target.value })} required /></div>
            <div className="field-pair mt-2">
              <div className="field mb-0"><label className="label">CNPJ/CPF</label><input className="input" value={form.clientDocument} onChange={(e) => setForm({ ...form, clientDocument: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">E-mail para NF/boleto</label><input className="input" type="email" value={form.clientBillingEmail} onChange={(e) => setForm({ ...form, clientBillingEmail: e.target.value })} /></div>
            </div>
            <div className="field mt-2"><label className="label">Endereço completo</label><input className="input" value={form.clientAddress} onChange={(e) => setForm({ ...form, clientAddress: e.target.value })} placeholder="logradouro, nº, bairro, cidade/UF, CEP" /></div>
          </div>

          {/* Escopo */}
          <div className="mt-3" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">🧩 Escopo dos serviços</h4>
            <div className="field mb-0"><label className="label">A CONTRATADA provê</label><textarea className="textarea" rows={3} value={form.scope} onChange={(e) => setForm({ ...form, scope: e.target.value })} placeholder="Descreva o escopo (um item por linha)" /></div>
          </div>

          {/* SLA */}
          <div className="mt-3" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">⏱ SLA</h4>
            <div className="field-pair">
              <div className="field mb-0"><label className="label">Disponibilidade</label><input className="input" value={form.slaAvailability} onChange={(e) => setForm({ ...form, slaAvailability: e.target.value })} placeholder="99,5%" /></div>
              <div className="field mb-0"><label className="label">Janela de atendimento</label><input className="input" value={form.slaWindow} onChange={(e) => setForm({ ...form, slaWindow: e.target.value })} /></div>
            </div>
          </div>

          {/* Vigência e pagamento */}
          <div className="mt-3" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-2">📅 Vigência e pagamento</h4>
            <div className="field-pair">
              <div className="field mb-0"><label className="label">Prazo (meses)</label><input className="input" type="number" min="1" value={form.termMonths} onChange={(e) => setForm({ ...form, termMonths: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Data de adesão</label><input className="input" type="date" value={form.adhesionDate} onChange={(e) => setForm({ ...form, adhesionDate: e.target.value })} /></div>
            </div>
            <div className="field-pair mt-2">
              <div className="field mb-0"><label className="label">Dia de emissão</label><input className="input" type="number" min="1" max="31" value={form.billingIssueDay} onChange={(e) => setForm({ ...form, billingIssueDay: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Dia de vencimento</label><input className="input" type="number" min="1" max="31" value={form.billingDueDay} onChange={(e) => setForm({ ...form, billingDueDay: e.target.value })} /></div>
              <div className="field mb-0"><label className="label">Foro</label><input className="input" value={form.jurisdiction} onChange={(e) => setForm({ ...form, jurisdiction: e.target.value })} /></div>
            </div>
            <div className="field mb-0 mt-2"><label className="label">Prazo de assinatura (dias)</label><input className="input" type="number" min="1" value={form.signatureDeadlineDays} onChange={(e) => setForm({ ...form, signatureDeadlineDays: e.target.value })} placeholder="padrão do sistema (7)" /></div>
            <label className="flex items-center gap-2 field mb-0 mt-2" style={{ cursor: 'pointer' }}>
              <input type="checkbox" checked={form.autoRenew} onChange={(e) => setForm({ ...form, autoRenew: e.target.checked })} /> Renovação automática
            </label>
          </div>

          {/* Anexo I */}
          <div className="mt-3" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <h4 className="mb-0">💰 Anexo I — Valores</h4>
            {renderLines('Adesão / Setup', setupItems, setSetupItems, setupTotal, 'Total adesão')}
            {renderLines('Mensalidade', monthlyItems, setMonthlyItems, monthlyTotal, 'Total mensal')}
          </div>

          {/* Signatários */}
          <div className="mt-3" style={{ borderTop: '1px solid var(--border)', paddingTop: 'var(--s3)' }}>
            <div className="flex items-center justify-between mb-2">
              <h4 className="mb-0">✍️ Signatários (assinatura eletrônica)</h4>
              <button type="button" className="btn btn-sm btn-secondary" onClick={addSigner}>+ Adicionar destinatário</button>
            </div>
            <div className="text-dim text-xs mb-2">O primeiro é o contratante. Adicione destinatários que também receberão o contrato para assinar por e-mail.</div>
            {signers.length === 0 ? (
              <div className="text-dim text-xs">Nenhum signatário.</div>
            ) : (
              <div className="flex flex-col gap-2">
                {signers.map((s, idx) => (
                  <div key={idx} className="card" style={{ padding: 'var(--s3)', background: 'var(--surface-2)' }}>
                    <div className="field-pair">
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Nome</label><input className="input" value={s.name} onChange={(e) => updateSigner(idx, { name: e.target.value })} /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>E-mail</label><input className="input" type="email" value={s.email} onChange={(e) => updateSigner(idx, { email: e.target.value })} /></div>
                    </div>
                    <div className="field-pair mt-2">
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>CPF/CNPJ</label><input className="input" value={s.document ?? ''} onChange={(e) => updateSigner(idx, { document: e.target.value })} /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Papel</label><input className="input" value={s.role ?? ''} onChange={(e) => updateSigner(idx, { role: e.target.value })} placeholder="Contratante, Testemunha..." /></div>
                      <div className="field mb-0"><label className="label" style={{ fontSize: 11 }}>Ordem</label><input className="input" type="number" min="1" value={s.order ?? ''} onChange={(e) => updateSigner(idx, { order: e.target.value ? Number(e.target.value) : undefined })} /></div>
                    </div>
                    <div className="flex justify-end mt-2"><button type="button" className="btn btn-sm btn-ghost" onClick={() => removeSigner(idx)}>Remover</button></div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="field mb-0 mt-3"><label className="label">Observações internas</label><textarea className="textarea" rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></div>
        </form>
      </Modal>

      {/* Prévia / resumo do orçamento para análise (visualizar + enviar por e-mail). */}
      <Modal
        open={!!previewQuote}
        onClose={() => setPreviewQuote(null)}
        title="Prévia da proposta"
        maxWidth={720}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={() => setPreviewQuote(null)}>Fechar</button>
            <div className="flex items-center gap-2" style={{ flexWrap: 'wrap' }}>
              <input
                className="input"
                style={{ minWidth: 220 }}
                type="email"
                value={previewEmail}
                onChange={(e) => setPreviewEmail(e.target.value)}
                placeholder="e-mail do cliente"
              />
              <button className="btn btn-primary" type="button" disabled={sendingPreview} onClick={sendPreview}>
                {sendingPreview ? 'Enviando...' : '✉️ Enviar prévia'}
              </button>
            </div>
          </>
        }
      >
        {previewQuote && <QuotePreviewContent q={previewQuote} money={money} />}
      </Modal>

      {/* Status das assinaturas: quem visualizou, assinou ou recusou (com motivo). */}
      <Modal
        open={signStatusOpen}
        onClose={() => setSignStatusOpen(false)}
        title={`Status das assinaturas — ${signStatusTitle}`}
        maxWidth={620}
        footer={<button className="btn btn-ghost" type="button" onClick={() => setSignStatusOpen(false)}>Fechar</button>}
      >
        {!signStatus ? (
          <div className="flex justify-center" style={{ padding: 24 }}><span className="spinner" /></div>
        ) : signStatus.recipients.length === 0 ? (
          <div className="empty"><div className="empty-icon">✍️</div>Este orçamento ainda não foi enviado para assinatura.</div>
        ) : (
          <div className="flex flex-col gap-2">
            {/* Vencimento da solicitação e aviso/ação de reemissão quando expirada. */}
            {(() => {
              const q = items.find((x) => x.id === signStatusQuoteId);
              const expiresAt = signStatus.expiresAt;
              const expired = signStatus.status === 'expired'
                || (!!expiresAt && new Date(expiresAt) < new Date() && signStatus.status !== 'signed' && signStatus.status !== 'completed');
              return (
                <>
                  {expiresAt && (
                    <div className="text-dim text-sm">Vencimento: {new Date(expiresAt).toLocaleString('pt-BR')}</div>
                  )}
                  {expired && (
                    <div className="card" style={{ padding: 'var(--s3)', background: 'var(--surface-2)', borderLeft: '3px solid var(--danger)' }}>
                      <div className="flex items-center justify-between gap-2" style={{ flexWrap: 'wrap' }}>
                        <div className="font-semibold" style={{ color: 'var(--danger)' }}>⏰ Assinatura expirada</div>
                        {q && (
                          <button className="btn btn-sm btn-primary" type="button" disabled={reissuingId === q.id} onClick={() => reissueSignature(q)}>
                            {reissuingId === q.id ? '...' : '🔄 Reemitir'}
                          </button>
                        )}
                      </div>
                      <div className="text-dim text-xs mt-1">O prazo de assinatura venceu. Reemita para renovar o prazo e reenviar os convites aos pendentes.</div>
                    </div>
                  )}
                </>
              );
            })()}
            {signStatus.recipients.map((r, i) => {
              const badge = r.state === 'signed' ? { t: '✅ Assinado', c: 'badge-resolved' }
                : r.state === 'declined' ? { t: '🚫 Recusado', c: 'badge-urgent' }
                : r.viewedAt ? { t: '👁 Visualizado', c: 'badge-normal' }
                : { t: '⏳ Aguardando', c: 'badge-closed' };
              const when = r.signedAt ?? r.declinedAt ?? r.viewedAt;
              // Data/hora da visualização com o IP ao lado (quando o cliente acessou o link).
              const viewedLine = r.viewedAt
                ? `Visualizado em ${new Date(r.viewedAt).toLocaleString('pt-BR')}${r.ip ? ` · IP ${r.ip}` : ''}`
                : null;
              // Dispositivo resumido a partir do user agent (primeiros ~60 caracteres).
              const device = r.userAgent ? r.userAgent.slice(0, 60) : null;
              return (
                <div key={i} className="card" style={{ padding: 'var(--s3)', background: 'var(--surface-2)' }}>
                  <div className="flex items-center justify-between gap-2" style={{ flexWrap: 'wrap' }}>
                    <div>
                      <div className="font-semibold">{r.name} {r.role && <span className="text-dim text-xs">({r.role})</span>}</div>
                      <div className="text-dim text-sm">{r.email}</div>
                    </div>
                    <span className={`badge ${badge.c}`}>{badge.t}</span>
                  </div>
                  {viewedLine && <div className="text-dim text-xs mt-1">{viewedLine}</div>}
                  {device && <div className="text-dim text-xs">Dispositivo: {device}</div>}
                  {when && r.viewedAt !== when && <div className="text-dim text-xs mt-1">{new Date(when).toLocaleString('pt-BR')}</div>}
                  {r.state === 'declined' && r.declineReason && (
                    <div className="text-sm mt-2" style={{ color: 'var(--danger)' }}>Motivo: {r.declineReason}</div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </Modal>
    </div>
  );
}

// Conteúdo do resumo/prévia do orçamento (visão executiva para análise).
function QuotePreviewContent({ q, money }: { q: Quote; money: (v?: number) => string }) {
  const fmtDate = (iso?: string) => {
    if (!iso) return '—';
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('pt-BR');
  };
  const Row = ({ label, value }: { label: string; value?: string }) => (
    <div className="flex justify-between" style={{ padding: '4px 0', borderBottom: '1px solid var(--border)', gap: 12 }}>
      <span className="text-dim text-sm">{label}</span>
      <span className="text-sm" style={{ textAlign: 'right', fontWeight: 500 }}>{value || '—'}</span>
    </div>
  );
  const ItemsTable = ({ title, items }: { title: string; items?: QuoteLineItem[] }) => {
    if (!items || items.length === 0) return null;
    return (
      <div className="mt-3">
        <strong style={{ fontSize: 13 }}>{title}</strong>
        <table className="table" style={{ fontSize: 12, marginTop: 4 }}>
          <thead><tr><th>Descrição</th><th className="text-right">Qtd.</th><th className="text-right">Unitário</th><th className="text-right">Total</th></tr></thead>
          <tbody>
            {items.map((it, i) => (
              <tr key={i}>
                <td>{it.description || '—'}</td>
                <td className="text-right">{it.quantity ?? ''}</td>
                <td className="text-right">{money(it.unitPrice)}</td>
                <td className="text-right">{money(it.totalValue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div>
      <div className="text-dim text-sm">Resumo para análise</div>
      <h3 style={{ margin: '2px 0 12px' }}>{q.title}</h3>

      <div className="field-pair">
        <div>
          <strong style={{ fontSize: 13 }}>Contratada</strong>
          <div className="text-sm mt-1" style={{ lineHeight: 1.5 }}>
            MAKWEB SOLUÇÕES DIGITAIS LTDA<br />
            CNPJ 41.923.493/0001-19<br />
            Rua João de Barros, 229 — Ribeirão Pires/SP<br />
            suporte@makweb.com.br
          </div>
        </div>
        <div>
          <strong style={{ fontSize: 13 }}>Contratante</strong>
          <div className="text-sm mt-1" style={{ lineHeight: 1.5 }}>
            {q.clientName}<br />
            {q.clientDocument && <>{q.clientDocument}<br /></>}
            {q.clientAddress && <>{q.clientAddress}<br /></>}
            {q.clientBillingEmail}
          </div>
        </div>
      </div>

      {q.scope && (
        <div className="mt-3">
          <strong style={{ fontSize: 13 }}>Escopo</strong>
          <div className="text-sm mt-1" style={{ whiteSpace: 'pre-wrap' }}>{q.scope}</div>
        </div>
      )}

      <ItemsTable title="Itens de adesão" items={q.setupItems} />
      <ItemsTable title="Itens de mensalidade" items={q.monthlyItems} />

      <div className="field-pair mt-4">
        <div>
          <strong style={{ fontSize: 13 }}>Valores</strong>
          <div className="mt-1">
            <Row label="Total de adesão" value={money(q.setupTotal)} />
            <Row label="Total mensal" value={money(q.monthlyTotal)} />
          </div>
        </div>
        <div>
          <strong style={{ fontSize: 13 }}>Condições</strong>
          <div className="mt-1">
            <Row label="Prazo" value={q.termMonths ? `${q.termMonths} meses` : '—'} />
            <Row label="Início (adesão)" value={fmtDate(q.adhesionDate)} />
            <Row label="Renovação" value={q.autoRenew === false ? 'Sob ajuste' : 'Automática'} />
            <Row label="SLA" value={`${q.slaAvailability || '99,5%'}`} />
            <Row label="Emissão / Vencimento" value={`Dia ${q.billingIssueDay ?? 1} / Dia ${q.billingDueDay ?? 10}`} />
            <Row label="Foro" value={q.jurisdiction || 'Ribeirão Pires – SP'} />
          </div>
        </div>
      </div>
    </div>
  );
}

// Aba de Serviços (comercial/financeiro): catálogo de serviços faturáveis.
// Base para itens de contrato e futura emissão de boleto/nota fiscal. Importável
// da GestãoClick, com CRUD para adicionar/editar novos serviços.
function ServicesTab() {
  const toast = useToast();
  const { confirm } = useDialog();
  const [items, setItems] = useState<CommercialService[]>([]);
  const [filter, setFilter] = useState('');
  const [editing, setEditing] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [importing, setImporting] = useState(false);
  const [importMsg, setImportMsg] = useState('');
  const empty = { code: '', name: '', salePrice: '', notes: '', active: true };
  const [form, setForm] = useState<{ code: string; name: string; salePrice: string; notes: string; active: boolean }>({ ...empty });

  const openNew = () => { setEditing(null); setForm({ ...empty }); setOpen(true); };
  const closeModal = () => { setOpen(false); setEditing(null); setForm({ ...empty }); };

  const load = () => api.get<Paginated<CommercialService>>('/services').then((r) => setItems(r.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const payload = {
        code: form.code || undefined,
        name: form.name,
        salePrice: form.salePrice ? Number(form.salePrice) : undefined,
        notes: form.notes || undefined,
        active: form.active,
      };
      if (editing) await api.patch(`/services/${editing}`, payload);
      else await api.post('/services', payload);
      toast.success(editing ? 'Serviço atualizado' : 'Serviço criado');
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  const edit = (s: CommercialService) => {
    setEditing(s.id);
    setForm({ code: s.code ?? '', name: s.name, salePrice: s.salePrice?.toString() ?? '', notes: s.notes ?? '', active: s.active });
    setOpen(true);
  };

  const remove = async (s: CommercialService) => {
    if (!(await confirm({ title: 'Excluir serviço', message: `Remover "${s.name}"?`, confirmLabel: 'Excluir', danger: true }))) return;
    await api.delete(`/services/${s.id}`);
    toast.success('Serviço removido');
    if (editing === s.id) closeModal();
    load();
  };

  // Importa todos os serviços da GestãoClick sob demanda.
  const importNow = async () => {
    setImporting(true);
    setImportMsg('');
    try {
      const r = await api.post<{ fetched: number; created: number; updated: number }>('/services/sync', {});
      setImportMsg(`${r.created} criados, ${r.updated} atualizados (${r.fetched} lidos).`);
      toast.success('Importação de serviços concluída');
      load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha na importação');
    } finally {
      setImporting(false);
    }
  };

  const fmtMoney = (v?: number) => (v == null ? '—' : v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
  const visible = filter
    ? items.filter((s) => `${s.name} ${s.code ?? ''}`.toLowerCase().includes(filter.toLowerCase()))
    : items;
  const { sorted, sort } = useSortable<CommercialService>(visible, {
    name: (s) => s.name,
    code: (s) => s.code ?? '',
    price: (s) => s.salePrice ?? -1,
  });
  const paged = usePaged(sorted, 20);

  return (
    <div>
      <div className="flex items-center justify-between mb-3 gap-2" style={{ flexWrap: 'wrap' }}>
        <input
          className="input"
          style={{ maxWidth: 280 }}
          placeholder="Buscar serviço (nome ou código)"
          value={filter}
          onChange={(e) => { setFilter(e.target.value); paged.setPage(1); }}
        />
        <div className="flex items-center gap-2" style={{ flexWrap: 'wrap' }}>
          <button className="btn btn-secondary" type="button" disabled={importing} onClick={importNow}>
            {importing ? 'Importando...' : '⬇ Importar da GestãoClick'}
          </button>
          <button className="btn btn-primary" onClick={openNew}>+ Novo serviço</button>
        </div>
      </div>
      {importMsg && <div className="text-dim text-xs mb-2">{importMsg}</div>}

      <div className="card card-flush">
        {sorted.length === 0 ? (
          <div className="empty"><div className="empty-icon">🧾</div>Nenhum serviço cadastrado. Crie um novo ou importe da GestãoClick.</div>
        ) : (
          <table className="table"><thead><tr>
            <SortableTh<CommercialService> field="name" sort={sort}>Serviço</SortableTh>
            <SortableTh<CommercialService> field="code" sort={sort}>Código</SortableTh>
            <SortableTh<CommercialService> field="price" sort={sort}>Valor de venda</SortableTh>
            <th>Observações</th>
            <th></th>
          </tr></thead><tbody>
            {paged.pageItems.map((s) => (
              <tr key={s.id}>
                <td className="font-semibold">{s.name}{!s.active && <span className="badge badge-closed" style={{ marginLeft: 6 }}>Inativo</span>}</td>
                <td className="text-muted text-sm">{s.code ?? '—'}</td>
                <td className="text-muted text-sm">{fmtMoney(s.salePrice)}</td>
                <td className="text-muted text-sm" style={{ maxWidth: 280, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.notes ?? '—'}</td>
                <td className="text-right">
                  <button className="btn btn-sm btn-ghost" onClick={() => edit(s)}>Editar</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => remove(s)}>Excluir</button>
                </td>
              </tr>
            ))}
          </tbody></table>
        )}
      </div>
      <Pager paged={paged} noun="serviços" />

      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? 'Editar serviço' : 'Novo serviço'}
        maxWidth={520}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="service-form">{editing ? 'Salvar' : 'Adicionar'}</button>
          </>
        }
      >
        <form id="service-form" onSubmit={save}>
          <div className="field"><label className="label">Nome do serviço</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="field-pair">
            <div className="field mb-0"><label className="label">Código</label>
              <div className="flex gap-1">
                <input className="input" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} placeholder="deixe vazio para gerar" />
                <button type="button" className="btn btn-ghost btn-sm" title="Gerar código aleatório" onClick={() => { const a = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; let s = ''; for (let i = 0; i < 5; i++) s += a[Math.floor(Math.random() * a.length)]; setForm({ ...form, code: `SRV-${s}` }); }}>🎲</button>
              </div>
            </div>
            <div className="field mb-0"><label className="label">Valor de venda (R$)</label><input className="input" type="number" min="0" step="0.01" value={form.salePrice} onChange={(e) => setForm({ ...form, salePrice: e.target.value })} /></div>
          </div>
          <div className="field"><label className="label">Observações</label><textarea className="textarea" rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></div>
          <label className="flex items-center gap-2 field mb-0" style={{ cursor: 'pointer' }}>
            <input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} /> Serviço ativo
          </label>
        </form>
      </Modal>
    </div>
  );
}

// Aba de Ativos (CMDB): inventário por empresa, alimentável pelo MW-SCAN.
function AssetsTab() {
  const toast = useToast();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [items, setItems] = useState<Asset[]>([]);
  const [filterCompany, setFilterCompany] = useState('');
  const [filter, setFilter] = useState(''); // busca textual instantânea
  const [editing, setEditing] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const empty = { companyId: '', name: '', type: AssetType.WORKSTATION, status: AssetStatus.ACTIVE, identifier: '', ipAddress: '', os: '', location: '', assignedTo: '', notes: '' };
  const [form, setForm] = useState<Record<string, string>>({ ...empty });
  const openNew = () => { setEditing(null); setForm({ ...empty }); setOpen(true); };
  const closeModal = () => { setOpen(false); setEditing(null); setForm({ ...empty }); };

  const load = () => api.get<Paginated<Asset>>('/assets')
    .then((r) => setItems(r.items))
    .catch((e) => toast.error(e instanceof Error ? e.message : 'Falha ao carregar ativos'));
  useEffect(() => { api.get<Paginated<Company>>('/companies').then((r) => setCompanies(r.items)).catch(() => {}); load(); }, []);

  const companyName = (id: string) => companies.find((c) => c.id === id)?.name ?? id;
  const term = filter.trim().toLowerCase();
  const visible = items.filter((a) => {
    if (filterCompany && a.companyId !== filterCompany) return false;
    if (term) {
      const haystack = `${a.name} ${a.identifier ?? ''} ${companyName(a.companyId)} ${AssetTypeLabels[a.type]} ${a.ipAddress ?? ''} ${a.os ?? ''} ${a.location ?? ''} ${a.assignedTo ?? ''}`.toLowerCase();
      if (!haystack.includes(term)) return false;
    }
    return true;
  });
  const { sorted: sortedAssets, sort } = useSortable<Asset>(visible, {
    name: (a) => a.name,
    company: (a) => companyName(a.companyId),
    type: (a) => AssetTypeLabels[a.type],
    status: (a) => AssetStatusLabels[a.status],
    ip: (a) => a.ipAddress ?? '',
  });
  const paged = usePaged(sortedAssets, 20);

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const payload = {
        companyId: form.companyId, name: form.name, type: form.type as AssetType, status: form.status as AssetStatus,
        identifier: form.identifier || undefined, ipAddress: form.ipAddress || undefined, os: form.os || undefined,
        location: form.location || undefined, assignedTo: form.assignedTo || undefined, notes: form.notes || undefined,
      };
      if (editing) await api.patch(`/assets/${editing}`, payload);
      else await api.post('/assets', payload);
      toast.success(editing ? 'Ativo atualizado' : 'Ativo criado');
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  const remove = async (id: string) => {
    await api.delete(`/assets/${id}`);
    toast.success('Ativo removido');
    if (editing === id) closeModal();
    load();
  };

  const edit = (a: Asset) => {
    setEditing(a.id);
    setForm({
      companyId: a.companyId, name: a.name, type: a.type, status: a.status,
      identifier: a.identifier ?? '', ipAddress: a.ipAddress ?? '', os: a.os ?? '',
      location: a.location ?? '', assignedTo: a.assignedTo ?? '', notes: a.notes ?? '',
    });
    setOpen(true);
  };

  // Estado do modal de duplicação (form pré-preenchido a partir de um ativo).
  const [dupForm, setDupForm] = useState<Record<string, string> | null>(null);
  const [dupSaving, setDupSaving] = useState(false);

  // Abre o modal com os dados do ativo. O identificador (chave natural única) é
  // limpo e o nome recebe "(cópia)" para evitar colisão com o original.
  const duplicate = (a: Asset) => {
    setDupForm({
      companyId: a.companyId, name: `${a.name} (cópia)`, type: a.type, status: a.status,
      identifier: '', ipAddress: a.ipAddress ?? '', os: a.os ?? '',
      location: a.location ?? '', assignedTo: a.assignedTo ?? '', notes: a.notes ?? '',
    });
  };

  const saveDuplicate = async () => {
    if (!dupForm) return;
    if (!dupForm.companyId || !dupForm.name.trim()) { toast.error('Informe empresa e nome.'); return; }
    setDupSaving(true);
    try {
      await api.post('/assets', {
        companyId: dupForm.companyId, name: dupForm.name, type: dupForm.type as AssetType, status: dupForm.status as AssetStatus,
        identifier: dupForm.identifier || undefined, ipAddress: dupForm.ipAddress || undefined, os: dupForm.os || undefined,
        location: dupForm.location || undefined, assignedTo: dupForm.assignedTo || undefined, notes: dupForm.notes || undefined,
      });
      toast.success('Ativo duplicado');
      setDupForm(null); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao duplicar');
    } finally {
      setDupSaving(false);
    }
  };
  const setDup = (k: string, v: string) => setDupForm((f) => (f ? { ...f, [k]: v } : f));

  return (
    <div>
      <div className="flex gap-2 items-end justify-between flex-wrap" style={{ marginBottom: 'var(--s3)' }}>
        <div className="flex gap-2 items-end flex-wrap" style={{ flex: 1 }}>
          <div className="field mb-0" style={{ maxWidth: 260, flex: 1 }}>
            <label className="label">Buscar ativo</label>
            <input className="input" value={filter} onChange={(e) => { setFilter(e.target.value); paged.setPage(1); }} placeholder="nome, ID, IP, sistema, local..." />
          </div>
          <div className="field mb-0" style={{ maxWidth: 240 }}>
            <label className="label">Filtrar por empresa</label>
            <select className="select" value={filterCompany} onChange={(e) => { setFilterCompany(e.target.value); paged.setPage(1); }}>
              <option value="">Todas</option>
              {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
        </div>
        <div className="flex gap-2 items-end">
          <button
            type="button"
            className="btn btn-sm btn-ghost"
            disabled={visible.length === 0}
            onClick={() => {
              const csv = toCsv(
                ['nome', 'identificador', 'empresa', 'tipo', 'status', 'ip', 'sistema', 'local', 'responsavel'],
                visible.map((a) => [a.name, a.identifier ?? '', companyName(a.companyId), AssetTypeLabels[a.type], AssetStatusLabels[a.status], a.ipAddress ?? '', a.os ?? '', a.location ?? '', a.assignedTo ?? '']),
              );
              downloadCsv('ativos.csv', csv);
            }}
          >⬇ Exportar CSV</button>
          <button className="btn btn-primary" onClick={openNew}>+ Novo ativo</button>
        </div>
      </div>
      <div className="card card-flush">
            {visible.length === 0 ? <div className="empty"><div className="empty-icon">🖥</div>Nenhum ativo.</div> :
              <table className="table"><thead><tr>
                <SortableTh<Asset> field="name" sort={sort}>Ativo</SortableTh>
                <SortableTh<Asset> field="company" sort={sort}>Empresa</SortableTh>
                <SortableTh<Asset> field="type" sort={sort}>Tipo</SortableTh>
                <SortableTh<Asset> field="status" sort={sort}>Status</SortableTh>
                <SortableTh<Asset> field="ip" sort={sort}>IP</SortableTh>
                <th></th>
              </tr></thead><tbody>
                {paged.pageItems.map((a) => (
                  <tr key={a.id}>
                    <td className="font-semibold">{a.name}{a.identifier && <span className="text-dim text-xs"> · {a.identifier}</span>}</td>
                    <td className="text-muted text-sm">{companyName(a.companyId)}</td>
                    <td className="text-muted text-sm">{AssetTypeLabels[a.type]}</td>
                    <td><span className={`badge ${a.status === 'active' ? 'badge-resolved' : 'badge-closed'}`}>{AssetStatusLabels[a.status]}</span></td>
                    <td className="text-muted text-sm">{a.ipAddress ?? '—'}</td>
                    <td className="text-right" style={{ whiteSpace: 'nowrap' }}>
                      <button className="btn btn-sm btn-ghost" onClick={() => edit(a)}>Editar</button>
                      <button className="btn btn-sm btn-ghost" title="Duplicar" onClick={() => duplicate(a)}>⧉ Duplicar</button>
                      <button className="btn btn-sm btn-ghost" onClick={() => remove(a.id)}>Excluir</button>
                    </td>
                  </tr>
                ))}
              </tbody></table>}
          </div>
          <Pager paged={paged} noun="ativos" />

          {/* Modal de duplicação de ativo (editável antes de salvar como novo). */}
          <Modal
            open={!!dupForm}
            title="Duplicar ativo"
            onClose={() => setDupForm(null)}
            maxWidth={520}
            footer={
              <>
                <button className="btn btn-ghost" onClick={() => setDupForm(null)} disabled={dupSaving}>Fechar</button>
                <button className="btn btn-primary" onClick={saveDuplicate} disabled={dupSaving}>{dupSaving ? 'Salvando...' : 'Salvar cópia'}</button>
              </>
            }
          >
            {dupForm && (
              <div>
                <div className="field"><label className="label">Empresa</label>
                  <select className="select" value={dupForm.companyId} onChange={(e) => setDup('companyId', e.target.value)} required>
                    <option value="">Selecione</option>
                    {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
                <div className="field"><label className="label">Nome</label><input className="input" value={dupForm.name} onChange={(e) => setDup('name', e.target.value)} required /></div>
                <div className="field-pair">
                  <div className="field mb-0"><label className="label">Tipo</label>
                    <select className="select" value={dupForm.type} onChange={(e) => setDup('type', e.target.value)}>
                      {Object.entries(AssetTypeLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                    </select>
                  </div>
                  <div className="field mb-0"><label className="label">Status</label>
                    <select className="select" value={dupForm.status} onChange={(e) => setDup('status', e.target.value)}>
                      {Object.entries(AssetStatusLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                    </select>
                  </div>
                </div>
                <div className="field-pair mt-3">
                  <div className="field mb-0"><label className="label">Identificador (único)</label><input className="input" value={dupForm.identifier} onChange={(e) => setDup('identifier', e.target.value)} placeholder="deixe vazio ou use um novo" /></div>
                  <div className="field mb-0"><label className="label">IP</label><input className="input" value={dupForm.ipAddress} onChange={(e) => setDup('ipAddress', e.target.value)} /></div>
                </div>
                <div className="field-pair mt-3">
                  <div className="field mb-0"><label className="label">Sistema</label><input className="input" value={dupForm.os} onChange={(e) => setDup('os', e.target.value)} /></div>
                  <div className="field mb-0"><label className="label">Local</label><input className="input" value={dupForm.location} onChange={(e) => setDup('location', e.target.value)} /></div>
                </div>
                <div className="field mt-3"><label className="label">Responsável</label><input className="input" value={dupForm.assignedTo} onChange={(e) => setDup('assignedTo', e.target.value)} /></div>
                <div className="field mb-0"><label className="label">Observações</label><textarea className="textarea" rows={2} value={dupForm.notes} onChange={(e) => setDup('notes', e.target.value)} /></div>
              </div>
            )}
      </Modal>

      {/* Modal de criação/edição de ativo */}
      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? 'Editar ativo' : 'Novo ativo'}
        maxWidth={560}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="asset-form">{editing ? 'Salvar' : 'Adicionar'}</button>
          </>
        }
      >
        <form id="asset-form" onSubmit={save}>
          <div className="field"><label className="label">Empresa</label>
            <select className="select" value={form.companyId} onChange={(e) => setForm({ ...form, companyId: e.target.value })} required>
              <option value="">Selecione</option>
              {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="field"><label className="label">Nome</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="form-grid">
            <div className="field"><label className="label">Tipo</label>
              <select className="select" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                {Object.entries(AssetTypeLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div className="field"><label className="label">Status</label>
              <select className="select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                {Object.entries(AssetStatusLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          </div>
          <div className="field"><label className="label">Identificador (hostname/serial/tag)</label><input className="input" value={form.identifier} onChange={(e) => setForm({ ...form, identifier: e.target.value })} placeholder="usado pelo MW-SCAN" /></div>
          <div className="form-grid">
            <div className="field"><label className="label">IP</label><input className="input" value={form.ipAddress} onChange={(e) => setForm({ ...form, ipAddress: e.target.value })} /></div>
            <div className="field"><label className="label">Sistema</label><input className="input" value={form.os} onChange={(e) => setForm({ ...form, os: e.target.value })} placeholder="Windows 11" /></div>
          </div>
          <div className="form-grid">
            <div className="field"><label className="label">Local/setor</label><input className="input" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} /></div>
            <div className="field"><label className="label">Responsável</label><input className="input" value={form.assignedTo} onChange={(e) => setForm({ ...form, assignedTo: e.target.value })} /></div>
          </div>
          <div className="field mb-0"><label className="label">Observações</label><textarea className="textarea" rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></div>
        </form>
      </Modal>
    </div>
  );
}

// Aba de Automações: construtor de regras QUANDO → SE → FAÇA (admin).
function AutomationTab() {
  const toast = useToast();
  const [rules, setRules] = useState<AutomationRule[]>([]);
  const [agents, setAgents] = useState<User[]>([]);
  const [departments, setDepartments] = useState<Department[]>([]);
  const [companies, setCompanies] = useState<Company[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [queues, setQueues] = useState<Queue[]>([]);
  const [clients, setClients] = useState<User[]>([]);
  const [editing, setEditing] = useState<AutomationRule | null>(null);

  const blank = (): AutomationRule => ({
    id: '', name: '', active: true, trigger: AutomationTrigger.TICKET_CREATED,
    conditions: [], actions: [], order: rules.length, stopOnMatch: false,
    createdAt: '', updatedAt: '',
  });
  const [draft, setDraft] = useState<AutomationRule>(blank());

  const load = () => api.get<Paginated<AutomationRule>>('/automation').then((r) => setRules(r.items)).catch(() => {});
  useEffect(() => {
    load();
    api.get<Paginated<User>>('/agents').then((r) => setAgents(r.items)).catch(() => {});
    api.get<Paginated<Company>>('/companies').then((r) => setCompanies(r.items)).catch(() => {});
    api.get<Paginated<Category>>('/categories').then((r) => setCategories(r.items)).catch(() => {});
    // Clientes (solicitantes) para a condição "por cliente".
    api.get<Paginated<User>>('/users').then((r) => setClients(r.items.filter((u) => u.role === UserRole.CLIENT))).catch(() => {});
    // Filas são por departamento: carrega os deptos e agrega as filas de todos.
    api.get<Paginated<Department>>('/departments').then((r) => {
      setDepartments(r.items);
      Promise.all(
        r.items.map((d) => api.get<Paginated<Queue>>(`/departments/${d.id}/queues`).then((q) => q.items).catch(() => [])),
      ).then((lists) => setQueues(lists.flat()));
    }).catch(() => {});
  }, []);

  const [open, setOpen] = useState(false);
  const startNew = () => { setEditing(null); setDraft(blank()); setOpen(true); };
  const startEdit = (r: AutomationRule) => { setEditing(r); setDraft({ ...r, conditions: [...r.conditions], actions: [...r.actions] }); setOpen(true); };
  const closeModal = () => { setOpen(false); setEditing(null); setDraft(blank()); };

  const save = async () => {
    if (!draft.name.trim()) { toast.error('Dê um nome à regra'); return; }
    try {
      const payload = { name: draft.name, active: draft.active, trigger: draft.trigger, conditions: draft.conditions, actions: draft.actions, order: draft.order, stopOnMatch: draft.stopOnMatch };
      if (editing) await api.patch(`/automation/${editing.id}`, payload);
      else await api.post('/automation', payload);
      toast.success(editing ? 'Regra atualizada' : 'Regra criada');
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };
  const toggle = async (r: AutomationRule) => { await api.patch(`/automation/${r.id}`, { active: !r.active }); load(); };
  const remove = async (id: string) => { await api.delete(`/automation/${id}`); toast.success('Regra removida'); if (editing?.id === id) closeModal(); load(); };

  // Editores de linha de condição/ação.
  const addCondition = () => setDraft((d) => ({ ...d, conditions: [...d.conditions, { field: ConditionField.PRIORITY, operator: ConditionOperator.EQ, value: '' }] }));
  const setCondition = (i: number, c: AutomationCondition) => setDraft((d) => ({ ...d, conditions: d.conditions.map((x, j) => (j === i ? c : x)) }));
  const delCondition = (i: number) => setDraft((d) => ({ ...d, conditions: d.conditions.filter((_, j) => j !== i) }));
  const addAction = () => setDraft((d) => ({ ...d, actions: [...d.actions, { type: ActionType.SET_PRIORITY, value: '' }] }));
  const setAction = (i: number, a: AutomationAction) => setDraft((d) => ({ ...d, actions: d.actions.map((x, j) => (j === i ? a : x)) }));
  const delAction = (i: number) => setDraft((d) => ({ ...d, actions: d.actions.filter((_, j) => j !== i) }));

  // Renderiza o input de valor conforme o campo. Operadores de lista (está/não está
  // entre) usam texto livre separado por vírgula, mesmo em campos que teriam dropdown.
  const conditionValueInput = (c: AutomationCondition, i: number) => {
    const set = (value: string) => setCondition(i, { ...c, value });
    const isListOp = c.operator === ConditionOperator.IN || c.operator === ConditionOperator.NOT_IN;
    const dropdown = (entries: [string, string][]) => (
      <select className="select" value={c.value} onChange={(e) => set(e.target.value)}>
        <option value="">—</option>
        {entries.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    );
    // Em operadores de lista, texto livre (ex.: "empresaA,empresaB" ou "urgent,high").
    if (isListOp) {
      return <input className="input" value={c.value} onChange={(e) => set(e.target.value)} placeholder="valores separados por vírgula" />;
    }
    if (c.field === ConditionField.PRIORITY) return dropdown(Object.entries(PriorityLabels));
    if (c.field === ConditionField.STATUS) return dropdown(Object.entries(StatusLabels));
    if (c.field === ConditionField.CHANNEL) return dropdown(Object.entries(ChannelLabels));
    if (c.field === ConditionField.SUPPORT_LEVEL) return dropdown(Object.entries(SupportLevelLabels));
    if (c.field === ConditionField.COMPANY) return dropdown(companies.map((co) => [co.id, co.name] as [string, string]));
    if (c.field === ConditionField.REQUESTER) return dropdown(clients.map((u) => [u.id, u.name] as [string, string]));
    if (c.field === ConditionField.DEPARTMENT) return dropdown(departments.map((d) => [d.id, d.name] as [string, string]));
    if (c.field === ConditionField.ASSIGNEE) return dropdown(agents.map((a) => [a.id, a.name] as [string, string]));
    if (c.field === ConditionField.CATEGORY) return dropdown(buildCategoryOptions(categories).map((o) => [o.id, o.label] as [string, string]));
    if (c.field === ConditionField.IS_TASK) return dropdown([['true', 'Sim'], ['false', 'Não']]);
    return <input className="input" value={c.value} onChange={(e) => set(e.target.value)} placeholder="valor" />;
  };

  const actionValueInput = (a: AutomationAction, i: number) => {
    if (a.type === ActionType.SET_PRIORITY) {
      return <select className="select" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })}><option value="">—</option>{Object.entries(PriorityLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>;
    }
    if (a.type === ActionType.SET_STATUS) {
      return <select className="select" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })}><option value="">—</option>{Object.entries(StatusLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>;
    }
    if (a.type === ActionType.ASSIGN) {
      return <select className="select" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })}><option value="">—</option>{agents.map((ag) => <option key={ag.id} value={ag.id}>{ag.name}</option>)}</select>;
    }
    if (a.type === ActionType.SET_DEPARTMENT) {
      return <select className="select" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })}><option value="">—</option>{departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}</select>;
    }
    if (a.type === ActionType.SET_SUPPORT_LEVEL) {
      return <select className="select" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })}><option value="">—</option>{Object.entries(SupportLevelLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>;
    }
    if (a.type === ActionType.SET_QUEUE) {
      return <select className="select" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })}><option value="">—</option>{queues.map((q) => <option key={q.id} value={q.id}>{q.name}</option>)}</select>;
    }
    if (a.type === ActionType.SET_CATEGORY) {
      return <select className="select" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })}><option value="">—</option>{buildCategoryOptions(categories).map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}</select>;
    }
    if (a.type === ActionType.MARK_TASK) {
      return <select className="select" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })}><option value="true">Sim (marcar)</option><option value="false">Não (desmarcar)</option></select>;
    }
    return <input className="input" value={a.value} onChange={(e) => setAction(i, { ...a, value: e.target.value })} placeholder={a.type === ActionType.NOTIFY ? 'mensagem' : 'valor'} />;
  };

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button className="btn btn-primary" onClick={startNew}>+ Nova regra</button>
      </div>
      <div className="card card-flush">
        {rules.length === 0 ? <div className="empty"><div className="empty-icon">🤖</div>Nenhuma regra de automação.</div> :
          rules.map((r) => (
            <div key={r.id} className="flex items-center justify-between" style={{ padding: '10px var(--s4)', borderBottom: '1px solid var(--border)', opacity: r.active ? 1 : 0.5 }}>
              <div>
                <strong>{r.name}</strong> {!r.active && <span className="badge badge-closed" style={{ marginLeft: 6 }}>Inativa</span>}
                <div className="text-muted text-sm">{AutomationTriggerLabels[r.trigger]} · {r.conditions.length} condição(ões) · {r.actions.length} ação(ões)</div>
              </div>
              <div className="flex gap-2">
                <button className="btn btn-sm btn-ghost" onClick={() => startEdit(r)}>Editar</button>
                <button className="btn btn-sm btn-ghost" onClick={() => toggle(r)}>{r.active ? 'Desativar' : 'Ativar'}</button>
                <button className="btn btn-sm btn-ghost" onClick={() => remove(r.id)}>Excluir</button>
              </div>
            </div>
          ))}
      </div>

      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? 'Editar regra' : 'Nova regra'}
        maxWidth={620}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" type="button" onClick={save}>{editing ? 'Salvar' : 'Criar regra'}</button>
          </>
        }
      >
        <div className="field"><label className="label">Nome</label><input className="input" value={draft.name} onChange={(e) => setDraft({ ...draft, name: e.target.value })} autoFocus /></div>
        <div className="field"><label className="label">QUANDO (gatilho)</label>
          <select className="select" value={draft.trigger} onChange={(e) => setDraft({ ...draft, trigger: e.target.value as AutomationTrigger })}>
            {Object.entries(AutomationTriggerLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>

        <div className="field">
          <label className="label">SE (todas as condições)</label>
          {draft.conditions.map((c, i) => (
            <div key={i} className="flex gap-1 mb-2" style={{ alignItems: 'center' }}>
              <select className="select" style={{ flex: 1 }} value={c.field} onChange={(e) => setCondition(i, { ...c, field: e.target.value as ConditionField })}>
                {Object.entries(ConditionFieldLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
              <select className="select" style={{ width: 110 }} value={c.operator} onChange={(e) => setCondition(i, { ...c, operator: e.target.value as ConditionOperator })}>
                {Object.entries(ConditionOperatorLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
              <div style={{ flex: 1 }}>{conditionValueInput(c, i)}</div>
              <button className="btn btn-sm btn-ghost" type="button" onClick={() => delCondition(i)}>✕</button>
            </div>
          ))}
          <button className="btn btn-sm btn-ghost" type="button" onClick={addCondition}>+ condição</button>
        </div>

        <div className="field">
          <label className="label">FAÇA (ações)</label>
          {draft.actions.map((a, i) => (
            <div key={i} className="flex gap-1 mb-2" style={{ alignItems: 'center' }}>
              <select className="select" style={{ flex: 1 }} value={a.type} onChange={(e) => setAction(i, { ...a, type: e.target.value as ActionType, value: '' })}>
                {Object.entries(ActionTypeLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
              <div style={{ flex: 1 }}>{actionValueInput(a, i)}</div>
              <button className="btn btn-sm btn-ghost" type="button" onClick={() => delAction(i)}>✕</button>
            </div>
          ))}
          <button className="btn btn-sm btn-ghost" type="button" onClick={addAction}>+ ação</button>
        </div>

        <div className="field">
          <label className="label">Ordem (menor roda primeiro)</label>
          <input className="input" type="number" style={{ maxWidth: 120 }} value={draft.order}
            onChange={(e) => setDraft({ ...draft, order: Number(e.target.value) || 0 })} />
          <p className="text-dim text-xs mt-1" style={{ marginBottom: 0 }}>
            Regras rodam em cascata por ordem. Use uma ordem menor para exceções (ex.: "Empresa X → N2")
            e uma maior para a regra geral (ex.: "todo chamado de suporte → N1").
          </p>
        </div>

        <label className="flex items-center gap-2 field mb-0" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={!!draft.stopOnMatch} onChange={(e) => setDraft({ ...draft, stopOnMatch: e.target.checked })} />
          <span>Exceção: parar aqui se casar (impede as regras seguintes de sobrescrever)</span>
        </label>

        <label className="flex items-center gap-2 field mb-0 mt-2" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={draft.active} onChange={(e) => setDraft({ ...draft, active: e.target.checked })} /> Regra ativa
        </label>
      </Modal>
    </div>
  );
}

// Aba do Bot de triagem (URA) do WhatsApp: fluxo configurável de passos ordenáveis
// (boas-vindas, nome, e-mail, mensagens/procedimentos, perguntas e menu de roteamento).
// Rótulos e descrições dos tipos de passo do fluxo do bot (para o painel).
const BOT_STEP_LABELS: Record<WhatsAppBotStepType, string> = {
  welcome: 'Boas-vindas',
  ask_name: 'Pedir nome',
  ask_email: 'Pedir e-mail',
  message: 'Mensagem/procedimento',
  question: 'Pergunta aberta',
  menu: 'Menu de opções (roteamento)',
  routed: 'Confirmação final',
};
const BOT_STEP_HINTS: Record<WhatsAppBotStepType, string> = {
  welcome: 'Mostra o texto e segue automaticamente.',
  ask_name: 'Coleta o nome. Pulado para clientes já cadastrados.',
  ask_email: 'Coleta o e-mail. Pulado para clientes já cadastrados.',
  message: 'Mostra um aviso/procedimento e segue automaticamente.',
  question: 'Faz uma pergunta e guarda a resposta no chamado.',
  menu: 'Mostra as opções e roteia o chamado (departamento/fila/nível).',
  routed: 'Mensagem final. Use {opcao} para o nome da opção escolhida.',
};
// Tipos que o admin pode adicionar no meio do fluxo (os demais são passos-base).
const BOT_ADDABLE_TYPES: WhatsAppBotStepType[] = ['message', 'question'];

function WhatsAppBotTab() {
  const toast = useToast();
  const [cfg, setCfg] = useState<WhatsAppBotConfig | null>(null);
  const [departments, setDepartments] = useState<Department[]>([]);
  // Filas indexadas por departamento (carregadas sob demanda ao escolher o depto).
  const [queuesByDept, setQueuesByDept] = useState<Record<string, Queue[]>>({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get<WhatsAppBotConfig>('/whatsapp/bot').then(setCfg).catch(() => toast.error('Falha ao carregar a configuração do bot.'))
      .finally(() => setLoading(false));
    api.get<Paginated<Department>>('/departments').then((r) => setDepartments(r.items)).catch(() => {});
  }, []);

  // Carrega (uma vez) as filas de um departamento para o select da opção.
  const loadQueues = (deptId: string) => {
    if (!deptId || queuesByDept[deptId]) return;
    api.get<Paginated<Queue>>(`/departments/${deptId}/queues`).then((r) =>
      setQueuesByDept((prev) => ({ ...prev, [deptId]: r.items })),
    ).catch(() => {});
  };

  // Garante que as filas dos deptos já escolhidos (em qualquer menu) estejam carregadas.
  useEffect(() => {
    cfg?.steps.forEach((s) => s.options?.forEach((o) => { if (o.departmentId) loadQueues(o.departmentId); }));
  }, [cfg]);

  if (loading || !cfg) return <div className="empty-state">Carregando…</div>;

  // Gera um id local estável para passos novos criados no painel.
  const localId = () => `step_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

  const setEnabled = (value: boolean) => setCfg((c) => (c ? { ...c, enabled: value } : c));
  const setAskRegistration = (value: boolean) => setCfg((c) => (c ? { ...c, askRegistration: value } : c));

  const setStep = (index: number, patch: Partial<WhatsAppBotFlowStep>) =>
    setCfg((c) => c ? { ...c, steps: c.steps.map((s, i) => (i === index ? { ...s, ...patch } : s)) } : c);

  // Move um passo para cima/baixo na ordem do fluxo.
  const moveStep = (index: number, dir: -1 | 1) =>
    setCfg((c) => {
      if (!c) return c;
      const target = index + dir;
      if (target < 0 || target >= c.steps.length) return c;
      const steps = [...c.steps];
      [steps[index], steps[target]] = [steps[target], steps[index]];
      return { ...c, steps };
    });

  const addStep = (type: WhatsAppBotStepType) =>
    setCfg((c) => c ? {
      ...c,
      steps: [...c.steps, { id: localId(), type, enabled: true, title: BOT_STEP_LABELS[type], text: '' }],
    } : c);

  const removeStep = (index: number) =>
    setCfg((c) => c ? { ...c, steps: c.steps.filter((_, i) => i !== index) } : c);

  // Edição das opções de um passo de menu.
  const setOption = (stepIndex: number, optIndex: number, patch: Partial<WhatsAppBotOption>) =>
    setCfg((c) => c ? {
      ...c,
      steps: c.steps.map((s, i) => i === stepIndex
        ? { ...s, options: (s.options ?? []).map((o, j) => (j === optIndex ? { ...o, ...patch } : o)) }
        : s),
    } : c);

  const addOption = (stepIndex: number) =>
    setCfg((c) => c ? {
      ...c,
      steps: c.steps.map((s, i) => i === stepIndex
        ? { ...s, options: [...(s.options ?? []), { key: String((s.options?.length ?? 0) + 1), label: '' }] }
        : s),
    } : c);

  const removeOption = (stepIndex: number, optIndex: number) =>
    setCfg((c) => c ? {
      ...c,
      steps: c.steps.map((s, i) => i === stepIndex
        ? { ...s, options: (s.options ?? []).filter((_, j) => j !== optIndex) }
        : s),
    } : c);

  const save = async () => {
    // Validações: todo menu precisa de opções com tecla+rótulo; deve haver 1 menu.
    const menus = cfg.steps.filter((s) => s.type === 'menu' && s.enabled);
    if (menus.length === 0) { toast.error('O fluxo precisa de um passo de menu (roteamento) ativo.'); return; }
    const badOption = menus.some((m) => (m.options ?? []).length === 0 || (m.options ?? []).some((o) => !o.key.trim() || !o.label.trim()));
    if (badOption) { toast.error('Cada opção do menu precisa de tecla e nome.'); return; }
    setSaving(true);
    try {
      const saved = await api.put<WhatsAppBotConfig>('/whatsapp/bot', cfg);
      setCfg(saved);
      toast.success('Fluxo do bot salvo.');
    } catch {
      toast.error('Falha ao salvar o fluxo do bot.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="stack gap-4" style={{ maxWidth: 780 }}>
      <div className="card stack gap-3" style={{ padding: 16 }}>
        <label className="flex items-center gap-2" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={cfg.enabled} onChange={(e) => setEnabled(e.target.checked)} />
          <strong>Bot de triagem ativo</strong>
        </label>
        <p className="sec-desc" style={{ margin: 0 }}>
          Quando ativo, o bot conduz o fluxo de triagem no WhatsApp antes de abrir o chamado,
          na ordem definida abaixo. Conversas de grupo não passam pelo bot.
        </p>
        <label className="flex items-center gap-2" style={{ cursor: 'pointer' }}>
          <input type="checkbox" checked={cfg.askRegistration} onChange={(e) => setAskRegistration(e.target.checked)} />
          Pular "Pedir nome/e-mail" quando o contato já for um cliente cadastrado
        </label>
      </div>

      <div className="card stack gap-3" style={{ padding: 16 }}>
        <div className="flex items-center justify-between flex-wrap gap-2">
          <h3 style={{ margin: 0 }}>Fluxo do atendimento</h3>
          <div className="flex gap-2">
            {BOT_ADDABLE_TYPES.map((t) => (
              <button key={t} type="button" className="btn btn-ghost btn-sm" onClick={() => addStep(t)}>
                + {BOT_STEP_LABELS[t]}
              </button>
            ))}
          </div>
        </div>
        <p className="sec-desc" style={{ margin: 0 }}>
          Use as setas para ordenar. Cada passo pode ser ligado/desligado. Adicione passos
          de "Mensagem" ou "Pergunta" no meio do fluxo para procedimentos personalizados.
        </p>

        {cfg.steps.map((s, i) => {
          const isMenu = s.type === 'menu';
          return (
            <div key={s.id} className="card stack gap-2" style={{ padding: 12, background: 'var(--surface-2, #f7f7f8)', opacity: s.enabled ? 1 : 0.6 }}>
              <div className="flex items-center gap-2 flex-wrap justify-between">
                <div className="flex items-center gap-2">
                  <span className="badge badge-normal">{i + 1}</span>
                  <strong>{BOT_STEP_LABELS[s.type]}</strong>
                </div>
                <div className="flex items-center gap-1">
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => moveStep(i, -1)} disabled={i === 0} title="Subir">↑</button>
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => moveStep(i, 1)} disabled={i === cfg.steps.length - 1} title="Descer">↓</button>
                  <label className="flex items-center gap-1" style={{ cursor: 'pointer', marginLeft: 8 }} title="Ativar/desativar passo">
                    <input type="checkbox" checked={s.enabled} onChange={(e) => setStep(i, { enabled: e.target.checked })} />
                    Ativo
                  </label>
                  {BOT_ADDABLE_TYPES.includes(s.type) && (
                    <button type="button" className="btn btn-ghost btn-sm" onClick={() => removeStep(i)} title="Remover passo">✕</button>
                  )}
                </div>
              </div>
              <p className="sec-desc" style={{ margin: 0 }}>{BOT_STEP_HINTS[s.type]}</p>

              <div className="field">
                <label className="label">
                  {isMenu ? 'Enunciado do menu' : s.type === 'routed' ? 'Mensagem final' : 'Mensagem'}
                </label>
                <textarea className="input" rows={2} value={s.text} onChange={(e) => setStep(i, { text: e.target.value })} placeholder={isMenu ? 'Ex.: Selecione uma opção abaixo:' : ''} />
              </div>

              {isMenu && (
                <>
                  <div className="field">
                    <label className="label">Resposta para opção inválida</label>
                    <input className="input" value={s.invalidOptionMessage ?? ''} onChange={(e) => setStep(i, { invalidOptionMessage: e.target.value })} />
                  </div>
                  <div className="flex items-center justify-between">
                    <label className="label" style={{ margin: 0 }}>Opções</label>
                    <button type="button" className="btn btn-ghost btn-sm" onClick={() => addOption(i)}>+ Adicionar opção</button>
                  </div>
                  {(s.options ?? []).map((o, j) => {
                    const queues = o.departmentId ? queuesByDept[o.departmentId] ?? [] : [];
                    return (
                      <div key={j} className="card stack gap-2" style={{ padding: 10, background: 'var(--surface, #fff)' }}>
                        <div className="flex gap-2 flex-wrap">
                          <div className="field" style={{ width: 80 }}>
                            <label className="label">Tecla</label>
                            <input className="input" value={o.key} onChange={(e) => setOption(i, j, { key: e.target.value })} />
                          </div>
                          <div className="field" style={{ flex: 1, minWidth: 150 }}>
                            <label className="label">Nome da opção</label>
                            <input className="input" value={o.label} onChange={(e) => setOption(i, j, { label: e.target.value })} placeholder="Ex.: Suporte" />
                          </div>
                        </div>
                        <div className="flex gap-2 flex-wrap">
                          <div className="field" style={{ flex: 1, minWidth: 170 }}>
                            <label className="label">Departamento</label>
                            <select
                              className="select"
                              value={o.departmentId ?? ''}
                              onChange={(e) => { const departmentId = e.target.value || undefined; setOption(i, j, { departmentId, queueId: undefined }); if (departmentId) loadQueues(departmentId); }}
                            >
                              <option value="">—</option>
                              {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
                            </select>
                          </div>
                          <div className="field" style={{ flex: 1, minWidth: 170 }}>
                            <label className="label">Fila (opcional)</label>
                            <select className="select" value={o.queueId ?? ''} onChange={(e) => setOption(i, j, { queueId: e.target.value || undefined })} disabled={!o.departmentId}>
                              <option value="">—</option>
                              {queues.map((q) => <option key={q.id} value={q.id}>{q.name}</option>)}
                            </select>
                          </div>
                          <div className="field" style={{ width: 150 }}>
                            <label className="label">Nível (opcional)</label>
                            <select className="select" value={o.supportLevel ?? ''} onChange={(e) => setOption(i, j, { supportLevel: (e.target.value || undefined) as SupportLevel | undefined })}>
                              <option value="">—</option>
                              {Object.entries(SupportLevelLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                            </select>
                          </div>
                        </div>
                        <div className="flex justify-end">
                          <button type="button" className="btn btn-ghost btn-sm" onClick={() => removeOption(i, j)}>Remover opção</button>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          );
        })}
      </div>

      <div className="flex justify-end">
        <button type="button" className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Salvando…' : 'Salvar fluxo'}
        </button>
      </div>
    </div>
  );
}

// Aba de Catálogo de serviços: itens solicitáveis que pré-configuram chamados (admin).
function CatalogTab() {
  const toast = useToast();
  const [items, setItems] = useState<ServiceCatalogItem[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [departments, setDepartments] = useState<Department[]>([]);
  const [editing, setEditing] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState('');
  const empty = { name: '', description: '', categoryId: '', departmentId: '', defaultPriority: '' };
  const [form, setForm] = useState<Record<string, string>>({ ...empty });
  const openNew = () => { setEditing(null); setForm({ ...empty }); setOpen(true); };
  const closeModal = () => { setOpen(false); setEditing(null); setForm({ ...empty }); };

  const load = () => api.get<{ items: ServiceCatalogItem[] }>('/catalog?all=true').then((r) => setItems(r.items)).catch(() => {});
  useEffect(() => {
    load();
    api.get<Paginated<Category>>('/categories').then((r) => setCategories(r.items)).catch(() => {});
    api.get<Paginated<Department>>('/departments').then((r) => setDepartments(r.items)).catch(() => {});
  }, []);

  const categoryOptions = buildCategoryOptions(categories);

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const payload = {
        name: form.name,
        description: form.description || undefined,
        categoryId: form.categoryId || undefined,
        departmentId: form.departmentId || undefined,
        defaultPriority: (form.defaultPriority || undefined) as TicketPriority | undefined,
      };
      if (editing) await api.patch(`/catalog/${editing}`, payload);
      else await api.post('/catalog', payload);
      toast.success(editing ? 'Serviço atualizado' : 'Serviço criado');
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  const toggleActive = async (i: ServiceCatalogItem) => {
    await api.patch(`/catalog/${i.id}`, { active: !i.active }); load();
  };
  const remove = async (id: string) => {
    await api.delete(`/catalog/${id}`); toast.success('Serviço removido');
    if (editing === id) closeModal();
    load();
  };
  const edit = (i: ServiceCatalogItem) => {
    setEditing(i.id);
    setForm({ name: i.name, description: i.description ?? '', categoryId: i.categoryId ?? '', departmentId: i.departmentId ?? '', defaultPriority: i.defaultPriority ?? '' });
    setOpen(true);
  };

  const term = filter.trim().toLowerCase();
  const visible = term
    ? items.filter((i) => `${i.name} ${i.description ?? ''}`.toLowerCase().includes(term))
    : items;
  const paged = usePaged(visible, 20);

  return (
    <div>
      <div className="flex gap-2 items-end justify-between flex-wrap mb-3">
        <div className="field mb-0" style={{ flex: 1, maxWidth: 320 }}>
          <label className="label">Buscar serviço</label>
          <input className="input" value={filter} onChange={(e) => { setFilter(e.target.value); paged.setPage(1); }} placeholder="nome ou descrição" />
        </div>
        <button className="btn btn-primary" onClick={openNew}>+ Novo serviço</button>
      </div>
      <div className="card card-flush">
        {visible.length === 0 ? <div className="empty"><div className="empty-icon">🧰</div>{items.length === 0 ? 'Nenhum serviço no catálogo.' : 'Nenhum serviço encontrado.'}</div> :
          paged.pageItems.map((i) => (
            <div key={i.id} className="flex items-center justify-between" style={{ padding: '10px var(--s4)', borderBottom: '1px solid var(--border)', opacity: i.active ? 1 : 0.5 }}>
              <div>
                <strong>{i.name}</strong>
                {!i.active && <span className="badge badge-closed" style={{ marginLeft: 8 }}>Inativo</span>}
                {i.description && <div className="text-muted text-sm">{i.description}</div>}
              </div>
              <div className="flex gap-2">
                <button className="btn btn-sm btn-ghost" onClick={() => edit(i)}>Editar</button>
                <button className="btn btn-sm btn-ghost" onClick={() => toggleActive(i)}>{i.active ? 'Desativar' : 'Ativar'}</button>
                <button className="btn btn-sm btn-ghost" onClick={() => remove(i.id)}>Excluir</button>
              </div>
            </div>
          ))}
      </div>
      <Pager paged={paged} noun="serviços" />
      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? 'Editar serviço' : 'Novo serviço'}
        maxWidth={520}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="catalog-form">{editing ? 'Salvar' : 'Adicionar'}</button>
          </>
        }
      >
        <form id="catalog-form" onSubmit={save}>
          <div className="field"><label className="label">Nome</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required autoFocus /></div>
          <div className="field"><label className="label">Descrição</label><textarea className="textarea" rows={2} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          {categoryOptions.length > 0 && (
            <div className="field"><label className="label">Categoria</label>
              <select className="select" value={form.categoryId} onChange={(e) => setForm({ ...form, categoryId: e.target.value })}>
                <option value="">—</option>
                {categoryOptions.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
              </select>
            </div>
          )}
          <div className="field"><label className="label">Departamento</label>
            <select className="select" value={form.departmentId} onChange={(e) => setForm({ ...form, departmentId: e.target.value })}>
              <option value="">—</option>
              {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>
          </div>
          <div className="field mb-0"><label className="label">Prioridade padrão</label>
            <select className="select" value={form.defaultPriority} onChange={(e) => setForm({ ...form, defaultPriority: e.target.value })}>
              <option value="">—</option>
              <option value={TicketPriority.LOW}>Baixa</option>
              <option value={TicketPriority.NORMAL}>Normal</option>
              <option value={TicketPriority.HIGH}>Alta</option>
              <option value={TicketPriority.URGENT}>Urgente</option>
            </select>
          </div>
        </form>
      </Modal>
    </div>
  );
}

// Aba de Categorias de chamado (árvore categoria → subcategoria → tipo).
function CategoriesTab() {
  const toast = useToast();
  const [items, setItems] = useState<Category[]>([]);
  const [form, setForm] = useState<{ name: string; parentId: string }>({ name: '', parentId: '' });
  const [editing, setEditing] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const openNew = () => { setEditing(null); setForm({ name: '', parentId: '' }); setOpen(true); };
  const closeModal = () => { setOpen(false); setEditing(null); setForm({ name: '', parentId: '' }); };

  const load = () => api.get<Paginated<Category>>('/categories').then((r) => setItems(r.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  // Opções de pai (inclui inativas para permitir reorganização).
  const parentOptions = buildCategoryOptions(items, { includeInactive: true }).filter((o) => o.id !== editing);

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const payload = { name: form.name, parentId: form.parentId || undefined };
      if (editing) await api.patch(`/categories/${editing}`, payload);
      else await api.post('/categories', payload);
      toast.success(editing ? 'Categoria atualizada' : 'Categoria criada');
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  const toggleActive = async (c: Category) => {
    try {
      await api.patch(`/categories/${c.id}`, { active: !c.active });
      load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao atualizar');
    }
  };

  const remove = async (id: string) => {
    try {
      await api.delete(`/categories/${id}`);
      toast.success('Categoria removida');
      if (editing === id) closeModal();
      load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao remover');
    }
  };

  const tree = buildCategoryOptions(items, { includeInactive: true });

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button className="btn btn-primary" onClick={openNew}>+ Nova categoria</button>
      </div>
      <div className="card card-flush">
        {tree.length === 0 ? <div className="empty"><div className="empty-icon">🏷</div>Nenhuma categoria. Crie a árvore com o botão acima.</div> :
          tree.map((o) => {
            const c = items.find((x) => x.id === o.id)!;
            return (
              <div key={o.id} className="flex items-center justify-between" style={{ padding: '10px var(--s4)', borderBottom: '1px solid var(--border)' }}>
                <span style={{ paddingLeft: o.depth * 18, opacity: c.active ? 1 : 0.5 }}>
                  {o.depth > 0 && <span className="text-dim">↳ </span>}
                  <strong>{c.name}</strong>
                  {!c.active && <span className="badge badge-closed" style={{ marginLeft: 8 }}>Inativa</span>}
                </span>
                <div className="flex gap-2">
                  <button className="btn btn-sm btn-ghost" onClick={() => { setEditing(c.id); setForm({ name: c.name, parentId: c.parentId ?? '' }); setOpen(true); }}>Editar</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => toggleActive(c)}>{c.active ? 'Desativar' : 'Ativar'}</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => remove(c.id)}>Excluir</button>
                </div>
              </div>
            );
          })}
      </div>
      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? 'Editar categoria' : 'Nova categoria'}
        maxWidth={440}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="category-form">{editing ? 'Salvar' : 'Adicionar'}</button>
          </>
        }
      >
        <form id="category-form" onSubmit={save}>
          <div className="field"><label className="label">Nome</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required autoFocus /></div>
          <div className="field mb-0"><label className="label">Categoria pai (opcional)</label>
            <select className="select" value={form.parentId} onChange={(e) => setForm({ ...form, parentId: e.target.value })}>
              <option value="">— Raiz —</option>
              {parentOptions.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
            </select>
          </div>
          <p className="text-dim text-xs mt-2">Monte a hierarquia: categoria → subcategoria → tipo.</p>
        </form>
      </Modal>
    </div>
  );
}

// Aba de Faturamento: consumo de horas por empresa vs contratado, no período (admin).
function BillingTab() {
  const toast = useToast();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [report, setReport] = useState<BillingReport | null>(null);
  const [loading, setLoading] = useState(false);
  // Período padrão: mês corrente.
  const firstOfMonth = new Date();
  firstOfMonth.setDate(1);
  const [company, setCompany] = useState('');
  const [from, setFrom] = useState(firstOfMonth.toISOString().slice(0, 10));
  const [to, setTo] = useState(new Date().toISOString().slice(0, 10));

  useEffect(() => { api.get<Paginated<Company>>('/companies').then((r) => setCompanies(r.items)).catch(() => {}); }, []);

  const run = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (company) params.set('company', company);
    if (from) params.set('from', new Date(from + 'T00:00:00').toISOString());
    if (to) params.set('to', new Date(to + 'T23:59:59').toISOString());
    api.get<BillingReport>(`/billing?${params.toString()}`)
      .then(setReport)
      .catch((e) => toast.error(e instanceof Error ? e.message : 'Falha ao gerar relatório'))
      .finally(() => setLoading(false));
  };
  useEffect(run, []); // gera o relatório do mês ao abrir

  const fmtH = (min: number) => (min / 60).toFixed(1) + 'h';

  return (
    <div>
      <div className="card">
        <div className="flex gap-4 flex-wrap items-end">
          <div className="field mb-0" style={{ minWidth: 200 }}>
            <label className="label">Empresa</label>
            <select className="select" value={company} onChange={(e) => setCompany(e.target.value)}>
              <option value="">Todas</option>
              {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="field mb-0"><label className="label">De</label><input className="input" type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></div>
          <div className="field mb-0"><label className="label">Até</label><input className="input" type="date" value={to} onChange={(e) => setTo(e.target.value)} /></div>
          <button className="btn btn-primary" onClick={run} disabled={loading}>{loading ? 'Gerando...' : 'Gerar relatório'}</button>
          <button
            className="btn btn-ghost"
            disabled={!report || report.rows.length === 0}
            onClick={() => {
              if (!report) return;
              const csv = toCsv(
                ['empresa', 'contrato', 'tipo', 'contratado_h', 'gasto_h', 'faturavel_h', 'excedente_h', 'valor_excedente'],
                report.rows.map((r) => [
                  r.companyName, r.contractName ?? '', r.contractType ? (ContractTypeLabels[r.contractType] ?? r.contractType) : '',
                  (r.contractedMinutes / 60).toFixed(1), (r.totalMinutes / 60).toFixed(1),
                  (r.billableMinutes / 60).toFixed(1), (r.overageMinutes / 60).toFixed(1),
                  r.overageAmount !== undefined ? r.overageAmount.toFixed(2) : '',
                ]),
              );
              downloadCsv('faturamento.csv', csv);
            }}
          >⬇ Exportar CSV</button>
        </div>
      </div>

      <div className="card card-flush mt-4">
        {!report || report.rows.length === 0 ? (
          <div className="empty"><div className="empty-icon">💰</div>Nenhuma hora apontada no período.</div>
        ) : (
          <table className="table">
            <thead><tr><th>Empresa</th><th>Contrato</th><th>Contratado</th><th>Gasto</th><th>Faturável</th><th>Excedente</th><th>Valor excedente</th></tr></thead>
            <tbody>
              {report.rows.map((r) => (
                <tr key={r.companyId}>
                  <td className="font-semibold">{r.companyName}</td>
                  <td className="text-muted text-sm">{r.contractName ? `${r.contractName}${r.contractType ? ` (${ContractTypeLabels[r.contractType] ?? r.contractType})` : ''}` : '—'}</td>
                  <td className="text-muted text-sm">{r.contractedMinutes ? fmtH(r.contractedMinutes) : '—'}</td>
                  <td>{fmtH(r.totalMinutes)}</td>
                  <td className="text-muted text-sm">{fmtH(r.billableMinutes)}</td>
                  <td>{r.overageMinutes > 0 ? <span className="badge badge-high">{fmtH(r.overageMinutes)}</span> : fmtH(0)}</td>
                  <td className="font-semibold">{r.overageAmount !== undefined ? `R$ ${r.overageAmount.toFixed(2)}` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {report && <div className="text-dim text-xs mt-2">Período: {new Date(report.from).toLocaleDateString('pt-BR')} a {new Date(report.to).toLocaleDateString('pt-BR')}. Excedente calculado sobre horas faturáveis acima do banco contratado.</div>}
    </div>
  );
}

// Aba de Satisfação (CSAT): média, distribuição de notas e por empresa.
function CsatTab() {
  const [report, setReport] = useState<CsatReport | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get<CsatReport>('/surveys').then(setReport).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center" style={{ padding: 40 }}><span className="spinner" /></div>;
  if (!report) return <div className="card empty"><div className="empty-icon">⭐</div>Sem dados de satisfação.</div>;

  const responseRate = report.totalSent ? Math.round((report.totalAnswered / report.totalSent) * 100) : 0;
  const maxDist = Math.max(1, ...Object.values(report.distribution));

  return (
    <div>
      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--s4)', marginBottom: 'var(--s5)' }}>
        <div className="stat-card">
          <span className="stat-icon">⭐</span>
          <div className="stat-label">Nota média</div>
          <div className="stat-value">{report.average || '—'}</div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">💬</span>
          <div className="stat-label">Respostas</div>
          <div className="stat-value">{report.totalAnswered}<span className="text-dim" style={{ fontSize: 15, fontWeight: 500 }}> / {report.totalSent}</span></div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">📈</span>
          <div className="stat-label">Taxa de resposta</div>
          <div className="stat-value">{responseRate}%</div>
        </div>
      </div>

      <div className="card mb-4">
        <h3>Distribuição das notas</h3>
        <div className="flex flex-col gap-2 mt-2">
          {[5, 4, 3, 2, 1].map((n) => {
            const count = report.distribution[String(n)] ?? 0;
            return (
              <div key={n} className="flex items-center gap-3">
                <span style={{ width: 40 }}>{n} ⭐</span>
                <div style={{ flex: 1, background: 'var(--surface-3)', borderRadius: 6, height: 14, overflow: 'hidden' }}>
                  <div style={{ width: `${(count / maxDist) * 100}%`, height: '100%', background: 'var(--gradient-primary)' }} />
                </div>
                <span className="text-muted text-sm" style={{ width: 32, textAlign: 'right' }}>{count}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="card card-flush">
        <div style={{ padding: '14px var(--s4) 0' }}><h3>Por empresa</h3></div>
        {report.byCompany.length === 0 ? <div className="empty"><div className="empty-icon">🏢</div>Nenhuma resposta ainda.</div> :
          <table className="table"><thead><tr><th>Empresa</th><th>Respostas</th><th>Média</th></tr></thead><tbody>
            {report.byCompany.map((r) => (
              <tr key={r.companyId}>
                <td className="font-semibold">{r.companyName}</td>
                <td className="text-muted text-sm">{r.responses}</td>
                <td><span className={`badge ${r.average >= 4 ? 'badge-resolved' : r.average >= 3 ? 'badge-high' : 'badge-urgent'}`}>{r.average} ⭐</span></td>
              </tr>
            ))}
          </tbody></table>}
      </div>
      <div className="text-dim text-xs mt-2">Período: {new Date(report.from).toLocaleDateString('pt-BR')} a {new Date(report.to).toLocaleDateString('pt-BR')}.</div>
    </div>
  );
}

// Aba de Auditoria: eventos recentes de todos os chamados (admin).
function AuditTab() {
  const [items, setItems] = useState<TicketEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  useEffect(() => {
    api.get<Paginated<TicketEvent>>('/audit').then((r) => setItems(r.items)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const term = filter.trim().toLowerCase();
  const visible = term
    ? items.filter((ev) => {
        const hay = `#${ev.ticketNumber ?? ''} ${TicketEventLabels[ev.type] ?? ev.type} ${ev.actorName ?? 'Sistema'} ${ev.note ?? ''} ${ev.to ?? ''} ${ev.from ?? ''}`.toLowerCase();
        return hay.includes(term);
      })
    : items;
  const { sorted: sortedEvents, sort } = useSortable<TicketEvent>(visible, {
    at: (ev) => ev.at,
    ticket: (ev) => ev.ticketNumber ?? 0,
    type: (ev) => TicketEventLabels[ev.type] ?? ev.type,
    actor: (ev) => ev.actorName ?? 'Sistema',
  });
  const paged = usePaged(sortedEvents, 25);

  if (loading) return <div className="flex justify-center" style={{ padding: 40 }}><span className="spinner" /></div>;

  return (
    <div>
      <div className="flex gap-2 items-end flex-wrap mb-3">
        <div className="field mb-0" style={{ flex: 1, maxWidth: 360 }}>
          <label className="label">Buscar evento</label>
          <input className="input" value={filter} onChange={(e) => { setFilter(e.target.value); paged.setPage(1); }} placeholder="chamado, evento, autor ou detalhe" />
        </div>
      </div>
      <div className="card card-flush">
      {sortedEvents.length === 0 ? <div className="empty"><div className="empty-icon">📜</div>{items.length === 0 ? 'Nenhum evento registrado ainda.' : 'Nenhum evento encontrado.'}</div> :
        <table className="table"><thead><tr>
          <SortableTh<TicketEvent> field="at" sort={sort}>Quando</SortableTh>
          <SortableTh<TicketEvent> field="ticket" sort={sort}>Chamado</SortableTh>
          <SortableTh<TicketEvent> field="type" sort={sort}>Evento</SortableTh>
          <SortableTh<TicketEvent> field="actor" sort={sort}>Autor</SortableTh>
          <th>Detalhe</th>
        </tr></thead><tbody>
          {paged.pageItems.map((ev) => (
            <tr key={ev.id}>
              <td className="text-muted text-sm">{new Date(ev.at).toLocaleString('pt-BR')}</td>
              <td className="text-sm">{ev.ticketNumber ? <Link to={`/tickets/${ev.ticketId}`}>#{ev.ticketNumber}</Link> : '—'}</td>
              <td className="text-sm">{TicketEventIcons[ev.type] ?? '•'} {TicketEventLabels[ev.type] ?? ev.type}</td>
              <td className="text-muted text-sm">{ev.actorName ?? 'Sistema'}</td>
              <td className="text-muted text-sm">{ev.to ? (ev.from ? `${ev.from} → ${ev.to}` : ev.to) : (ev.note ?? '—')}</td>
            </tr>
          ))}
        </tbody></table>}
      </div>
      <Pager paged={paged} noun="eventos" />
    </div>
  );
}

// Aba de Respostas prontas (macros): CRUD simples.
function CannedTab() {
  const toast = useToast();
  const [items, setItems] = useState<CannedResponse[]>([]);
  const [form, setForm] = useState({ title: '', body: '' });
  const [editing, setEditing] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState('');

  const load = () => api.get<Paginated<CannedResponse>>('/canned').then((r) => setItems(r.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setForm({ title: '', body: '' }); setOpen(true); };
  const closeModal = () => { setOpen(false); setEditing(null); setForm({ title: '', body: '' }); };

  const save = async (e: FormEvent) => {
    e.preventDefault();
    try {
      if (editing) await api.patch(`/canned/${editing}`, form);
      else await api.post('/canned', form);
      toast.success(editing ? 'Resposta atualizada' : 'Resposta criada');
      closeModal(); load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Falha ao salvar');
    }
  };

  const remove = async (id: string) => {
    await api.delete(`/canned/${id}`);
    toast.success('Resposta removida');
    if (editing === id) closeModal();
    load();
  };

  const term = filter.trim().toLowerCase();
  const visible = term
    ? items.filter((c) => `${c.title} ${c.body}`.toLowerCase().includes(term))
    : items;
  const paged = usePaged(visible, 20);

  return (
    <div>
      <div className="flex gap-2 items-end justify-between flex-wrap mb-3">
        <div className="field mb-0" style={{ flex: 1, maxWidth: 320 }}>
          <label className="label">Buscar resposta</label>
          <input className="input" value={filter} onChange={(e) => { setFilter(e.target.value); paged.setPage(1); }} placeholder="título ou conteúdo" />
        </div>
        <button className="btn btn-primary" onClick={openNew}>+ Nova resposta</button>
      </div>
      <div className="card card-flush">
        {visible.length === 0 ? <div className="empty"><div className="empty-icon">💬</div>{items.length === 0 ? 'Nenhuma resposta pronta.' : 'Nenhuma resposta encontrada.'}</div> :
          paged.pageItems.map((c) => (
            <div key={c.id} style={{ padding: 'var(--s4)', borderBottom: '1px solid var(--border)' }}>
              <div className="flex items-center justify-between">
                <strong>{c.title}</strong>
                <div className="flex gap-2">
                  <button className="btn btn-sm btn-ghost" onClick={() => { setEditing(c.id); setForm({ title: c.title, body: c.body }); setOpen(true); }}>Editar</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => remove(c.id)}>Excluir</button>
                </div>
              </div>
              <div className="text-muted text-sm mt-2" style={{ whiteSpace: 'pre-wrap' }}>{c.body}</div>
            </div>
          ))}
      </div>
      <Pager paged={paged} noun="respostas" />
      <Modal
        open={open}
        onClose={closeModal}
        title={editing ? 'Editar resposta' : 'Nova resposta'}
        maxWidth={560}
        footer={
          <>
            <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" type="submit" form="canned-form">{editing ? 'Salvar' : 'Adicionar'}</button>
          </>
        }
      >
        <form id="canned-form" onSubmit={save}>
          <div className="field"><label className="label">Título</label><input className="input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required autoFocus /></div>
          <div className="field mb-0"><label className="label">Conteúdo</label><textarea className="textarea" rows={6} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} required /></div>
        </form>
      </Modal>
    </div>
  );
}
